var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$a, $13c40c34b78c8ee2$var$s, $13c40c34b78c8ee2$var$h, $13c40c34b78c8ee2$var$p, $13c40c34b78c8ee2$var$v, $13c40c34b78c8ee2$var$y, $13c40c34b78c8ee2$var$d = {}, $13c40c34b78c8ee2$var$w = [], $13c40c34b78c8ee2$var$_ = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$g = Array.isArray;
function $13c40c34b78c8ee2$var$m(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$b(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $13c40c34b78c8ee2$var$x(l, e, i, r, null);
}
function $13c40c34b78c8ee2$var$x(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$13c40c34b78c8ee2$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(e), e;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$$(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$$(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$$(n) : null;
}
function $13c40c34b78c8ee2$var$I(n) {
    if (n.__P && n.__d) {
        var u = n.__v, t = u.__e, i = [], r = [], o = $13c40c34b78c8ee2$var$m({}, u);
        o.__v = u.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(o), $13c40c34b78c8ee2$var$q(n.__P, o, u, n.__n, n.__P.namespaceURI, 32 & u.__u ? [
            t
        ] : null, i, null == t ? $13c40c34b78c8ee2$var$$(u) : t, !!(32 & u.__u), r), o.__v = u.__v, o.__.__k[o.__i] = o, $13c40c34b78c8ee2$var$D(i, o, r), u.__e = u.__ = null, o.__e != t && $13c40c34b78c8ee2$var$P(o);
    }
}
function $13c40c34b78c8ee2$var$P(n) {
    if (null != (n = n.__) && null != n.__c) return n.__e = n.__c.base = null, n.__k.some(function(l) {
        if (null != l && null != l.__e) return n.__e = n.__c.base = l.__e;
    }), $13c40c34b78c8ee2$var$P(n);
}
function $13c40c34b78c8ee2$var$A(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$H.__r++ || $13c40c34b78c8ee2$var$r != $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$r = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$o)($13c40c34b78c8ee2$var$H);
}
function $13c40c34b78c8ee2$var$H() {
    try {
        for(var n, l = 1; $13c40c34b78c8ee2$var$i.length;)$13c40c34b78c8ee2$var$i.length > l && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$e), n = $13c40c34b78c8ee2$var$i.shift(), l = $13c40c34b78c8ee2$var$i.length, $13c40c34b78c8ee2$var$I(n);
    } finally{
        $13c40c34b78c8ee2$var$i.length = $13c40c34b78c8ee2$var$H.__r = 0;
    }
}
function $13c40c34b78c8ee2$var$L(n, l, u, t, i, r, o, e, f, c, a) {
    var s, h, p, v, y, _, g, m = t && t.__k || $13c40c34b78c8ee2$var$w, b = l.length;
    for(f = $13c40c34b78c8ee2$var$T(u, l, m, f, b), s = 0; s < b; s++)null != (p = u.__k[s]) && (h = -1 != p.__i && m[p.__i] || $13c40c34b78c8ee2$var$d, p.__i = s, _ = $13c40c34b78c8ee2$var$q(n, p, h, i, r, o, e, f, c, a), v = p.__e, p.ref && h.ref != p.ref && (h.ref && $13c40c34b78c8ee2$var$J(h.ref, null, p), a.push(p.ref, p.__c || v, p)), null == y && null != v && (y = v), (g = !!(4 & p.__u)) || h.__k === p.__k ? (f = $13c40c34b78c8ee2$var$j(p, f, n, g), g && h.__e && (h.__e = null)) : "function" == typeof p.type && void 0 !== _ ? f = _ : v && (f = v.nextSibling), p.__u &= -7);
    return u.__e = y, f;
}
function $13c40c34b78c8ee2$var$T(n, l, u, t, i) {
    var r, o, e, f, c, a = u.length, s = a, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? o = n.__k[r] = $13c40c34b78c8ee2$var$x(null, o, null, null, null) : $13c40c34b78c8ee2$var$g(o) ? o = n.__k[r] = $13c40c34b78c8ee2$var$x($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? o = n.__k[r] = $13c40c34b78c8ee2$var$x(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $13c40c34b78c8ee2$var$O(o, u, f, s)) && (s--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > a ? h-- : i < a && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (s) for(r = 0; r < a; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $13c40c34b78c8ee2$var$$(e)), $13c40c34b78c8ee2$var$K(e, e));
    return t;
}
function $13c40c34b78c8ee2$var$j(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $13c40c34b78c8ee2$var$j(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $13c40c34b78c8ee2$var$$(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$g(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$O(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], a = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || a && e == c.key && f == c.type) return u;
    if (t > (a ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $13c40c34b78c8ee2$var$z(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$_.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$N(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$z(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $13c40c34b78c8ee2$var$z(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($13c40c34b78c8ee2$var$s, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u[$13c40c34b78c8ee2$var$a] = t[$13c40c34b78c8ee2$var$a] : (u[$13c40c34b78c8ee2$var$a] = $13c40c34b78c8ee2$var$h, n.addEventListener(l, r ? $13c40c34b78c8ee2$var$v : $13c40c34b78c8ee2$var$p, r)) : n.removeEventListener(l, r ? $13c40c34b78c8ee2$var$v : $13c40c34b78c8ee2$var$p, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $13c40c34b78c8ee2$var$V(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u[$13c40c34b78c8ee2$var$c]) u[$13c40c34b78c8ee2$var$c] = $13c40c34b78c8ee2$var$h++;
            else if (u[$13c40c34b78c8ee2$var$c] < t[$13c40c34b78c8ee2$var$a]) return;
            return t($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $13c40c34b78c8ee2$var$q(n, u, t, i, r, o, e, f, c, a) {
    var s, h, p, v, y, d, _, k, x, M, $, I, P, A, H, T, j = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && s(u);
    n: if ("function" == typeof j) {
        h = e.length;
        try {
            if (x = u.props, M = j.prototype && j.prototype.render, $ = (s = j.contextType) && i[s.__c], I = s ? $ ? $.props.value : s.__ : i, t.__c ? k = (p = u.__c = t.__c).__ = p.__E : (M ? u.__c = p = new j(x, I) : (u.__c = p = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(x, I), p.constructor = j, p.render = $13c40c34b78c8ee2$var$Q), $ && $.sub(p), p.state || (p.state = {}), p.__n = i, v = p.__d = !0, p.__h = [], p._sb = []), M && null == p.__s && (p.__s = p.state), M && null != j.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $13c40c34b78c8ee2$var$m({}, p.__s)), $13c40c34b78c8ee2$var$m(p.__s, j.getDerivedStateFromProps(x, p.__s))), y = p.props, d = p.state, p.__v = u, v) M && null == j.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), M && null != p.componentDidMount && p.__h.push(p.componentDidMount);
            else {
                if (M && null == j.getDerivedStateFromProps && x !== y && null != p.componentWillReceiveProps && p.componentWillReceiveProps(x, I), u.__v == t.__v || !p.__e && null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(x, p.__s, I)) {
                    u.__v != t.__v && (p.props = x, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                        n && (n.__ = u);
                    }), $13c40c34b78c8ee2$var$w.push.apply(p.__h, p._sb), p._sb = [], p.__h.length && e.push(p);
                    break n;
                }
                null != p.componentWillUpdate && p.componentWillUpdate(x, p.__s, I), M && null != p.componentDidUpdate && p.__h.push(function() {
                    p.componentDidUpdate(y, d, _);
                });
            }
            if (p.context = I, p.props = x, p.__P = n, p.__e = !1, P = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, A = 0, M) p.state = p.__s, p.__d = !1, P && P(u), s = p.render(p.props, p.state, p.context), $13c40c34b78c8ee2$var$w.push.apply(p.__h, p._sb), p._sb = [];
            else do p.__d = !1, P && P(u), s = p.render(p.props, p.state, p.context), p.state = p.__s;
            while (p.__d && ++A < 25);
            p.state = p.__s, null != p.getChildContext && (i = $13c40c34b78c8ee2$var$m($13c40c34b78c8ee2$var$m({}, i), p.getChildContext())), M && !v && null != p.getSnapshotBeforeUpdate && (_ = p.getSnapshotBeforeUpdate(y, d)), H = null != s && s.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == s.key ? $13c40c34b78c8ee2$var$E(s.props.children) : s, f = $13c40c34b78c8ee2$var$L(n, $13c40c34b78c8ee2$var$g(H) ? H : [
                H
            ], u, t, i, r, o, e, f, c, a), p.base = u.__e, u.__u &= -161, p.__h.length && e.push(p), k && (p.__E = p.__ = null);
        } catch (n) {
            if (e.length = h, u.__v = null, c || null != o) {
                if (n.then) {
                    for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                    null != o && (o[o.indexOf(f)] = null), u.__e = f;
                } else {
                    if (null != o) for(T = o.length; T--;)$13c40c34b78c8ee2$var$b(o[T]);
                    $13c40c34b78c8ee2$var$B(u);
                }
            } else u.__e = t.__e, !u.__k && t.__k && (u.__k = t.__k), n.then || $13c40c34b78c8ee2$var$B(u);
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
        }
    } else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $13c40c34b78c8ee2$var$G(t.__e, u, t, i, r, o, e, c, a);
    return (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && s(u), 128 & u.__u ? void 0 : f;
}
function $13c40c34b78c8ee2$var$B(n) {
    n && (n.__c && (n.__c.__e = !0), n.__k && n.__k.some($13c40c34b78c8ee2$var$B));
}
function $13c40c34b78c8ee2$var$D(n, u, t) {
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$J(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$E(n) {
    return "object" != typeof n || null == n || n.__b > 0 ? n : $13c40c34b78c8ee2$var$g(n) ? n.map($13c40c34b78c8ee2$var$E) : void 0 !== n.constructor ? null : $13c40c34b78c8ee2$var$m({}, n);
}
function $13c40c34b78c8ee2$var$G(u, t, i, r, o, e, f, c, a) {
    var s, h, p, v, y, w, _, m = i.props || $13c40c34b78c8ee2$var$d, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(s = 0; s < e.length; s++)if ((y = e[s]) && "setAttribute" in y == !!x && (x ? y.localName == x : 3 == y.nodeType)) {
            u = y, e[s] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($13c40c34b78c8ee2$export$41c562ebe57d11e2.__m && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) m === k || c && u.data == k || (u.data = k);
    else {
        if (e = "textarea" == x && null != k.defaultValue ? null : e && $13c40c34b78c8ee2$var$n.call(u.childNodes), !c && null != e) for(m = {}, s = 0; s < u.attributes.length; s++)m[(y = u.attributes[s]).name] = y.value;
        for(s in m)y = m[s], "dangerouslySetInnerHTML" == s ? p = y : "children" == s || s in k || "value" == s && "defaultValue" in k || "checked" == s && "defaultChecked" in k || $13c40c34b78c8ee2$var$N(u, s, null, y, o);
        for(s in k)y = k[s], "children" == s ? v = y : "dangerouslySetInnerHTML" == s ? h = y : "value" == s ? w = y : "checked" == s ? _ = y : c && "function" != typeof y || m[s] === y || $13c40c34b78c8ee2$var$N(u, s, y, m[s], o);
        if (h) c || p && (h.__html == p.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (p && (u.innerHTML = ""), $13c40c34b78c8ee2$var$L("template" == t.type ? u.content : u, $13c40c34b78c8ee2$var$g(v) ? v : [
            v
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $13c40c34b78c8ee2$var$$(i, 0), c, a), null != e) for(s = e.length; s--;)$13c40c34b78c8ee2$var$b(e[s]);
        c && "textarea" != x || (s = "value", "progress" == x && null == w ? u.removeAttribute("value") : null != w && (w !== u[s] || "progress" == x && !w || "option" == x && w != m[s]) && $13c40c34b78c8ee2$var$N(u, s, w, m[s], o), s = "checked", null != _ && _ != u[s] && $13c40c34b78c8ee2$var$N(u, s, _, m[s], o));
    }
    return u;
}
function $13c40c34b78c8ee2$var$J(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$K(n, u, t) {
    var i, r;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $13c40c34b78c8ee2$var$J(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = i.__n = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $13c40c34b78c8ee2$var$K(i[r], u, t || "function" != typeof n.type);
    t || $13c40c34b78c8ee2$var$b(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $13c40c34b78c8ee2$var$Q(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $13c40c34b78c8ee2$var$q(t, u = (!r && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), o || $13c40c34b78c8ee2$var$d, $13c40c34b78c8ee2$var$d, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $13c40c34b78c8ee2$var$D(e, u, f), u.props.children = null;
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $13c40c34b78c8ee2$var$m({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$x(l.type, f, i || l.key, r || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $13c40c34b78c8ee2$var$A(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $13c40c34b78c8ee2$var$y++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$w.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$m({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$m({}, u), this.props)), n && $13c40c34b78c8ee2$var$m(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$A(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$A(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$H.__r = 0, $13c40c34b78c8ee2$var$f = Math.random().toString(8), $13c40c34b78c8ee2$var$c = "__d" + $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$a = "__a" + $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$s = /(PointerCapture)$|Capture$/i, $13c40c34b78c8ee2$var$h = 0, $13c40c34b78c8ee2$var$p = $13c40c34b78c8ee2$var$V(!1), $13c40c34b78c8ee2$var$v = $13c40c34b78c8ee2$var$V(!0), $13c40c34b78c8ee2$var$y = 0;


var $7cf5de2d778dc547$var$t = /["&<]/;
function $7cf5de2d778dc547$var$n(r) {
    if (0 === r.length || !1 === $7cf5de2d778dc547$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $7cf5de2d778dc547$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $7cf5de2d778dc547$var$f = 0, $7cf5de2d778dc547$var$i = Array.isArray;
function $7cf5de2d778dc547$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$7cf5de2d778dc547$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).vnode && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).vnode(l), l;
}
function $7cf5de2d778dc547$export$45700d561b2268ac(r) {
    var t = $7cf5de2d778dc547$export$34b9dba7ce09269b((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $7cf5de2d778dc547$var$c = {}, $7cf5de2d778dc547$var$p = /[A-Z]/g;
function $7cf5de2d778dc547$export$991f6ffe102e5bac(e, t) {
    if ((0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).attr) {
        var f = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == typeof r && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $7cf5de2d778dc547$var$c[u] || ($7cf5de2d778dc547$var$c[u] = u.replace($7cf5de2d778dc547$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $7cf5de2d778dc547$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $7cf5de2d778dc547$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $7cf5de2d778dc547$var$n("" + t) + '"';
}
function $7cf5de2d778dc547$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($7cf5de2d778dc547$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $7cf5de2d778dc547$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $7cf5de2d778dc547$var$n("" + r);
}




var $204a33a7557cbbd0$var$t, $204a33a7557cbbd0$var$r, $204a33a7557cbbd0$var$u, $204a33a7557cbbd0$var$i, $204a33a7557cbbd0$var$o = 0, $204a33a7557cbbd0$var$f = [], $204a33a7557cbbd0$var$c = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2), $204a33a7557cbbd0$var$e = $204a33a7557cbbd0$var$c.__b, $204a33a7557cbbd0$var$a = $204a33a7557cbbd0$var$c.__r, $204a33a7557cbbd0$var$v = $204a33a7557cbbd0$var$c.diffed, $204a33a7557cbbd0$var$l = $204a33a7557cbbd0$var$c.__c, $204a33a7557cbbd0$var$m = $204a33a7557cbbd0$var$c.unmount, $204a33a7557cbbd0$var$p = $204a33a7557cbbd0$var$c.__;
function $204a33a7557cbbd0$var$s(n, t) {
    $204a33a7557cbbd0$var$c.__h && $204a33a7557cbbd0$var$c.__h($204a33a7557cbbd0$var$r, n, $204a33a7557cbbd0$var$o || t), $204a33a7557cbbd0$var$o = 0;
    var u = $204a33a7557cbbd0$var$r.__H || ($204a33a7557cbbd0$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $204a33a7557cbbd0$export$60241385465d0a34(n) {
    return $204a33a7557cbbd0$var$o = 1, $204a33a7557cbbd0$export$13e3392192263954($204a33a7557cbbd0$var$D, n);
}
function $204a33a7557cbbd0$export$13e3392192263954(n, u, i) {
    var o = $204a33a7557cbbd0$var$s($204a33a7557cbbd0$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $204a33a7557cbbd0$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $204a33a7557cbbd0$var$r, !$204a33a7557cbbd0$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = !1, i = o.__c.props !== n;
            if (o.__c.__H.__.some(function(n) {
                if (n.__N) {
                    u = !0;
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c) {
                var f = c.call(this, n, t, r);
                return u ? f || i : f;
            }
            return !u || i;
        };
        $204a33a7557cbbd0$var$r.__f = !0;
        var c = $204a33a7557cbbd0$var$r.shouldComponentUpdate, e = $204a33a7557cbbd0$var$r.componentWillUpdate;
        $204a33a7557cbbd0$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $204a33a7557cbbd0$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $204a33a7557cbbd0$export$6d9c69b0de29b591(n, u) {
    var i = $204a33a7557cbbd0$var$s($204a33a7557cbbd0$var$t++, 3);
    !$204a33a7557cbbd0$var$c.__s && $204a33a7557cbbd0$var$C(i.__H, u) && (i.__ = n, i.u = u, $204a33a7557cbbd0$var$r.__H.__h.push(i));
}
function $204a33a7557cbbd0$export$e5c5a5f917a5871c(n, u) {
    var i = $204a33a7557cbbd0$var$s($204a33a7557cbbd0$var$t++, 4);
    !$204a33a7557cbbd0$var$c.__s && $204a33a7557cbbd0$var$C(i.__H, u) && (i.__ = n, i.u = u, $204a33a7557cbbd0$var$r.__h.push(i));
}
function $204a33a7557cbbd0$export$b8f5890fc79d6aca(n) {
    return $204a33a7557cbbd0$var$o = 5, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $204a33a7557cbbd0$export$d5a552a76deda3c2(n, t, r) {
    $204a33a7557cbbd0$var$o = 6, $204a33a7557cbbd0$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $204a33a7557cbbd0$export$1538c33de8887b59(n, r) {
    var u = $204a33a7557cbbd0$var$s($204a33a7557cbbd0$var$t++, 7);
    return $204a33a7557cbbd0$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $204a33a7557cbbd0$export$35808ee640e87ca7(n, t) {
    return $204a33a7557cbbd0$var$o = 8, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $204a33a7557cbbd0$export$fae74005e78b1a27(n) {
    var u = $204a33a7557cbbd0$var$r.context[n.__c], i = $204a33a7557cbbd0$var$s($204a33a7557cbbd0$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($204a33a7557cbbd0$var$r)), u.props.value) : n.__;
}
function $204a33a7557cbbd0$export$dc8fbce3eb94dc1e(n, t) {
    $204a33a7557cbbd0$var$c.useDebugValue && $204a33a7557cbbd0$var$c.useDebugValue(t ? t(n) : n);
}
function $204a33a7557cbbd0$export$c052f6604b7d51fe(n) {
    var u = $204a33a7557cbbd0$var$s($204a33a7557cbbd0$var$t++, 10), i = $204a33a7557cbbd0$export$60241385465d0a34();
    return u.__ = n, $204a33a7557cbbd0$var$r.componentDidCatch || ($204a33a7557cbbd0$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $204a33a7557cbbd0$export$f680877a34711e37() {
    var n = $204a33a7557cbbd0$var$s($204a33a7557cbbd0$var$t++, 11);
    if (!n.__) {
        for(var u = $204a33a7557cbbd0$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $204a33a7557cbbd0$var$j() {
    for(var n; n = $204a33a7557cbbd0$var$f.shift();){
        var t = n.__H;
        if (n.__P && t) try {
            t.__h.some($204a33a7557cbbd0$var$z), t.__h.some($204a33a7557cbbd0$var$B), t.__h = [];
        } catch (r) {
            t.__h = [], $204a33a7557cbbd0$var$c.__e(r, n.__v);
        }
    }
}
$204a33a7557cbbd0$var$c.__b = function(n) {
    $204a33a7557cbbd0$var$r = null, $204a33a7557cbbd0$var$e && $204a33a7557cbbd0$var$e(n);
}, $204a33a7557cbbd0$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $204a33a7557cbbd0$var$p && $204a33a7557cbbd0$var$p(n, t);
}, $204a33a7557cbbd0$var$c.__r = function(n) {
    $204a33a7557cbbd0$var$a && $204a33a7557cbbd0$var$a(n), $204a33a7557cbbd0$var$t = 0;
    var i = ($204a33a7557cbbd0$var$r = n.__c).__H;
    i && ($204a33a7557cbbd0$var$u === $204a33a7557cbbd0$var$r ? (i.__h = [], $204a33a7557cbbd0$var$r.__h = [], i.__.some(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.length && $204a33a7557cbbd0$var$j(), $204a33a7557cbbd0$var$t = 0)), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r;
}, $204a33a7557cbbd0$var$c.diffed = function(n) {
    $204a33a7557cbbd0$var$v && $204a33a7557cbbd0$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $204a33a7557cbbd0$var$f.push(t) && $204a33a7557cbbd0$var$i === $204a33a7557cbbd0$var$c.requestAnimationFrame || (($204a33a7557cbbd0$var$i = $204a33a7557cbbd0$var$c.requestAnimationFrame) || $204a33a7557cbbd0$var$w)($204a33a7557cbbd0$var$j)), t.__H.__.some(function(n) {
        n.u && (n.__H = n.u, n.u = void 0);
    })), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r = null;
}, $204a33a7557cbbd0$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.some($204a33a7557cbbd0$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $204a33a7557cbbd0$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $204a33a7557cbbd0$var$c.__e(r, n.__v);
        }
    }), $204a33a7557cbbd0$var$l && $204a33a7557cbbd0$var$l(n, t);
}, $204a33a7557cbbd0$var$c.unmount = function(n) {
    $204a33a7557cbbd0$var$m && $204a33a7557cbbd0$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.some(function(n) {
        try {
            $204a33a7557cbbd0$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $204a33a7557cbbd0$var$c.__e(t, r.__v));
};
var $204a33a7557cbbd0$var$k = "function" == typeof requestAnimationFrame;
function $204a33a7557cbbd0$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $204a33a7557cbbd0$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $204a33a7557cbbd0$var$k && (t = requestAnimationFrame(r));
}
function $204a33a7557cbbd0$var$z(n) {
    var t = $204a33a7557cbbd0$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$B(n) {
    var t = $204a33a7557cbbd0$var$r;
    n.__c = n.__(), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $204a33a7557cbbd0$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


class $d7391e6a0d77ea45$export$cbdb7321be0c886b {
    /**
   * The chat transport deliberately knows nothing about the DOM.  Preact owns
   * rendering; this class only turns FastPubSub packets into chat objects.
   */ constructor({ onMessage: onMessage }){
        this.onMessage = onMessage;
        this.seen = new Set();
    }
    start(client, tenant, { subscribePatterns: subscribePatterns, publishChannel: publishChannel }) {
        this.client = client;
        this.tenant = tenant;
        this.publishChannel = publishChannel;
        this.stopped = false;
        for (const pattern of subscribePatterns)this.subscribe(pattern);
    }
    async subscribe(pattern) {
        const queue = await this.client.subscribe(this.tenant, pattern);
        while(!this.stopped){
            const message = await queue.recv();
            if (!message || this.stopped) break;
            try {
                this.add(JSON.parse(new TextDecoder().decode(message.payload)));
            } catch  {}
        }
    }
    async send(participant, text) {
        const messageText = text.trim();
        if (!messageText || !this.client || !this.publishChannel) return;
        const chat = {
            id: crypto.randomUUID(),
            from: participant.participant_id,
            name: participant.display_name,
            text: messageText
        };
        await this.client.publish(this.tenant, this.publishChannel, JSON.stringify(chat));
        this.add(chat);
    }
    add(chat) {
        if (!chat?.id || this.seen.has(chat.id)) return;
        this.seen.add(chat.id);
        this.onMessage({
            ...chat,
            name: chat.name || chat.from,
            text: chat.text || ""
        });
    }
    stop() {
        this.stopped = true;
    }
}


const $6ce98e86537e26d8$export$310a89419f878635 = [
    {
        codec: "avc1.42001f",
        label: "H.264/AVC",
        avc: {
            format: "annexb"
        }
    },
    {
        codec: "avc1.420028",
        label: "H.264/AVC 1080p",
        avc: {
            format: "annexb"
        }
    },
    {
        codec: "vp09.00.30.08.00",
        label: "VP9"
    },
    {
        codec: "vp8",
        label: "VP8"
    },
    {
        codec: "av01.0.05M.08",
        label: "AV1"
    },
    {
        codec: "hvc1.1.6.L120.B0",
        label: "HEVC/H.265"
    }
];
const $6ce98e86537e26d8$export$40105d0178b236dd = {
    auto: {
        width: 480,
        height: 270,
        bitrate: 200000,
        framerate: 12,
        preference: "auto"
    },
    avc360: {
        width: 640,
        height: 360,
        bitrate: 300000,
        framerate: 15,
        preference: "avc1.42001f"
    },
    avc270: {
        width: 480,
        height: 270,
        bitrate: 200000,
        framerate: 12,
        preference: "avc1.42001f"
    },
    hevc270: {
        width: 480,
        height: 270,
        bitrate: 150000,
        framerate: 12,
        preference: "hvc1.1.6.L120.B0"
    },
    vp9270: {
        width: 480,
        height: 270,
        bitrate: 170000,
        framerate: 12,
        preference: "vp09.00.30.08.00"
    },
    vp8180: {
        width: 320,
        height: 180,
        bitrate: 150000,
        framerate: 10,
        preference: "vp8"
    },
    av1180: {
        width: 320,
        height: 180,
        bitrate: 80000,
        framerate: 8,
        preference: "av01.0.05M.08"
    }
};
const $6ce98e86537e26d8$export$e5ce0b90cfc7c793 = {
    auto: {
        width: 1280,
        height: 720,
        bitrate: 1600000,
        framerate: 30,
        preference: "auto"
    },
    avc1080: {
        width: 1920,
        height: 1080,
        bitrate: 2800000,
        framerate: 30,
        preference: "avc1.420028",
        hardwareOnly: true
    },
    avc720: {
        width: 1280,
        height: 720,
        bitrate: 1600000,
        framerate: 30,
        preference: "avc1.42001f"
    },
    vp8720: {
        width: 1280,
        height: 720,
        bitrate: 1600000,
        framerate: 30,
        preference: "vp8"
    },
    vp9720: {
        width: 1280,
        height: 720,
        bitrate: 1100000,
        framerate: 24,
        preference: "vp09.00.30.08.00"
    },
    hevc720: {
        width: 1280,
        height: 720,
        bitrate: 1000000,
        framerate: 30,
        preference: "hvc1.1.6.L120.B0"
    },
    av1540: {
        width: 960,
        height: 540,
        bitrate: 650000,
        framerate: 20,
        preference: "av01.0.05M.08"
    }
};
const $6ce98e86537e26d8$var$IS_FIREFOX = /Firefox\//.test(navigator.userAgent);
function $6ce98e86537e26d8$export$40a5ed4d0752a125(codec, track, hardwareAcceleration = "prefer-hardware") {
    return {
        codec: codec.codec,
        width: track.width,
        height: track.height,
        bitrate: track.bitrate,
        framerate: track.framerate,
        latencyMode: "realtime",
        hardwareAcceleration: hardwareAcceleration,
        ...codec.avc ? {
            avc: codec.avc
        } : {}
    };
}
function $6ce98e86537e26d8$export$fb6b2a074ae3ee21(quality) {
    const priority = $6ce98e86537e26d8$var$IS_FIREFOX ? quality === "high" ? [
        "vp8",
        "vp09.00.30.08.00",
        "avc1.42001f",
        "av01.0.05M.08",
        "hvc1.1.6.L120.B0"
    ] : [
        "vp8",
        "avc1.42001f",
        "vp09.00.30.08.00",
        "av01.0.05M.08",
        "hvc1.1.6.L120.B0"
    ] : quality === "high" ? [
        "avc1.42001f",
        "vp8",
        "vp09.00.30.08.00",
        "hvc1.1.6.L120.B0",
        "av01.0.05M.08"
    ] : [
        "avc1.42001f",
        "hvc1.1.6.L120.B0",
        "vp09.00.30.08.00",
        "vp8",
        "av01.0.05M.08"
    ];
    return priority.map((codec)=>$6ce98e86537e26d8$export$310a89419f878635.find((candidate)=>candidate.codec === codec)).filter(Boolean);
}
async function $6ce98e86537e26d8$export$3087b69c708aa5d9(track, preference, hardwareOnly = false) {
    const candidates = preference === "auto" ? $6ce98e86537e26d8$export$fb6b2a074ae3ee21(track.quality) : $6ce98e86537e26d8$export$310a89419f878635.filter((candidate)=>candidate.codec === preference);
    for (const acceleration of hardwareOnly ? [
        "prefer-hardware"
    ] : [
        "prefer-hardware",
        "prefer-software"
    ])for (const codec of candidates){
        const support = await VideoEncoder.isConfigSupported($6ce98e86537e26d8$export$40a5ed4d0752a125(codec, track, acceleration)).catch(()=>({
                supported: false
            }));
        if (support.supported) return {
            codec: codec,
            acceleration: acceleration
        };
    }
    return undefined;
}
async function $6ce98e86537e26d8$export$d892a920364a0f60(mode, quality) {
    if (!globalThis.VideoEncoder) return false;
    return Boolean(await $6ce98e86537e26d8$export$3087b69c708aa5d9({
        ...mode,
        quality: quality
    }, mode.preference, mode.hardwareOnly));
}
async function $6ce98e86537e26d8$export$4040f15e6d258223(select, modes, quality) {
    for (const option of select.options){
        const mode = modes[option.value];
        if (!mode) continue;
        option.dataset.label ??= option.textContent;
        const supported = await $6ce98e86537e26d8$export$d892a920364a0f60(mode, quality);
        option.disabled = !supported;
        option.textContent = supported ? option.dataset.label : `${option.dataset.label} \xb7 unavailable`;
        if (!supported && select.value === option.value) select.value = "auto";
    }
}


async function $cbc7cb66acde099d$export$2db45ecbb35621b9() {
    try {
        const lines = [
            `User agent: ${navigator.userAgent}`,
            `Secure context: ${window.isSecureContext ? "yes" : "no"}`,
            `MediaDevices: ${navigator.mediaDevices ? "yes" : "no"}`,
            `WebCodecs: encoder=${globalThis.VideoEncoder ? "yes" : "no"}, decoder=${globalThis.VideoDecoder ? "yes" : "no"}`,
            `MediaStreamTrackProcessor: ${globalThis.MediaStreamTrackProcessor ? "yes" : "no"}`,
            "",
            "WebCodecs at 1280\xd7720 / 30 fps (prefer hardware):"
        ];
        for (const candidate of (0, $6ce98e86537e26d8$export$310a89419f878635)){
            const track = {
                width: 1280,
                height: 720,
                bitrate: 1600000,
                framerate: 30
            };
            const hardware = globalThis.VideoEncoder ? await VideoEncoder.isConfigSupported((0, $6ce98e86537e26d8$export$40a5ed4d0752a125)(candidate, track, "prefer-hardware")).catch(()=>({
                    supported: false
                })) : {
                supported: false
            };
            const software = globalThis.VideoEncoder ? await VideoEncoder.isConfigSupported((0, $6ce98e86537e26d8$export$40a5ed4d0752a125)(candidate, track, "prefer-software")).catch(()=>({
                    supported: false
                })) : {
                supported: false
            };
            const decoder = globalThis.VideoDecoder ? await VideoDecoder.isConfigSupported({
                codec: candidate.codec,
                codedWidth: 1280,
                codedHeight: 720
            }).catch(()=>({
                    supported: false
                })) : {
                supported: false
            };
            lines.push(`  ${candidate.label.padEnd(10)} encode hardware: ${hardware.supported ? "yes" : "no"} \xb7 software: ${software.supported ? "yes" : "no"} \xb7 decode: ${decoder.supported ? "yes" : "no"}`);
        }
        const recorderTypes = [
            "video/webm;codecs=vp8",
            "video/webm;codecs=vp9",
            "video/webm;codecs=av01.0.05M.08",
            "video/mp4;codecs=avc1.42001f",
            "video/mp4;codecs=hvc1.1.6.L120.B0"
        ];
        lines.push("", "MediaRecorder types:");
        for (const type of recorderTypes)lines.push(`  ${type}: ${globalThis.MediaRecorder?.isTypeSupported(type) ? "yes" : "no"}`);
        const codecs = globalThis.RTCRtpSender?.getCapabilities?.("video")?.codecs ?? [];
        lines.push("", "WebRTC video codecs advertised by this browser:");
        if (codecs.length) for (const codec of codecs)lines.push(`  ${codec.mimeType}${codec.sdpFmtpLine ? ` \xb7 ${codec.sdpFmtpLine}` : ""}`);
        else lines.push("  unavailable");
        if (navigator.mediaDevices?.getSupportedConstraints) {
            const constraints = Object.entries(navigator.mediaDevices.getSupportedConstraints()).filter(([, supported])=>supported).map(([name])=>name).join(", ");
            lines.push("", `Camera constraints: ${constraints || "none"}`);
        }
        if (navigator.mediaDevices?.enumerateDevices) {
            const devices = await navigator.mediaDevices.enumerateDevices();
            lines.push(`Video input devices detected: ${devices.filter((device)=>device.kind === "videoinput").length}`);
        }
        return lines.join("\n");
    } catch (error) {
        return `Capability check failed: ${error?.message || String(error)}`;
    }
}


/** Initial audio pipeline counter state. */ function $ea71a0b4b5f3b38e$export$61a68d4025b3028d() {
    return {
        subscriptions: 0,
        configPackets: 0,
        framePackets: 0,
        decodedFrames: 0,
        playedFrames: 0,
        droppedFrames: 0,
        pendingEnqueued: 0,
        underruns: 0,
        encodeBackpressure: 0,
        reconnects: 0,
        mixerMode: "\u2014",
        contextState: "\u2014",
        bufferedMs: 0,
        targetMs: 50,
        catchUpMs: 0,
        lastEvent: "idle",
        lastSignificantEvent: "idle",
        lastChannel: "",
        lastFrameAt: 0,
        lastPlayedAt: 0,
        startedAt: Date.now(),
        dropsByType: {},
        recentEvents: []
    };
}
const $ea71a0b4b5f3b38e$var$DROP_EVENT_TYPES = new Set([
    "audio_dropped_no_decoder",
    "audio_dropped_pending_full",
    "audio_dropped_decode_exception",
    "audio_dropped_context",
    "audio_dropped_start",
    "audio_decoder_error",
    "audio_subscription_error"
]);
const $ea71a0b4b5f3b38e$var$RECENT_LIMIT = 14;
/** Events that fire dozens of times per second — hidden from UI flicker. */ const $ea71a0b4b5f3b38e$var$NOISY_EVENT_TYPES = new Set([
    "audio_played",
    "audio_decoded",
    "audio_frame_packet",
    "audio_config_packet",
    "audio_buffer_stats"
]);
function $ea71a0b4b5f3b38e$export$934800c44d3689d1(type) {
    return !$ea71a0b4b5f3b38e$var$NOISY_EVENT_TYPES.has(type);
}
function $ea71a0b4b5f3b38e$export$bfd5269466af3b86(state, event) {
    const next = {
        ...state
    };
    if ($ea71a0b4b5f3b38e$export$934800c44d3689d1(event.type)) {
        next.lastEvent = event.type;
        next.lastSignificantEvent = event.type;
        if (event.channel) next.lastChannel = event.channel;
    }
    if (event.type === "audio_subscribed") next.subscriptions += 1;
    if (event.type === "audio_unsubscribed") next.subscriptions = Math.max(0, next.subscriptions - 1);
    if (event.type === "audio_config_packet") next.configPackets += 1;
    if (event.type === "audio_frame_packet") {
        next.framePackets += 1;
        next.lastFrameAt = Date.now();
    }
    if (event.type === "audio_decoded") next.decodedFrames += 1;
    if (event.type === "audio_played") {
        next.playedFrames += 1;
        next.lastPlayedAt = Date.now();
    }
    if (event.type === "audio_pending_decode") next.pendingEnqueued += 1;
    if (event.type === "audio_encode_backpressure") next.encodeBackpressure += 1;
    if (event.type === "audio_underrun") next.underruns = event.count ?? next.underruns + 1;
    if (event.type === "audio_buffer_stats") {
        if (Number.isFinite(event.bufferedMs)) next.bufferedMs = event.bufferedMs;
        if (Number.isFinite(event.targetMs)) next.targetMs = event.targetMs;
        if (Number.isFinite(event.catchUpMs)) next.catchUpMs = event.catchUpMs;
        if (Number.isFinite(event.count)) next.underruns = event.count;
    }
    if (event.type === "audio_subscription_reconnecting") next.reconnects += 1;
    if (event.type === "audio_mixer_running") {
        next.mixerMode = event.mode || next.mixerMode;
        next.contextState = event.state || next.contextState;
    }
    if (event.type === "audio_context_resumed") next.contextState = event.state || "running";
    if ($ea71a0b4b5f3b38e$var$DROP_EVENT_TYPES.has(event.type) || event.type.startsWith("audio_dropped")) {
        next.droppedFrames += 1;
        next.dropsByType = {
            ...next.dropsByType,
            [event.type]: (next.dropsByType[event.type] || 0) + 1
        };
    }
    if (event.type !== "audio_played" && event.type !== "audio_decoded" && event.type !== "audio_frame_packet" && event.type !== "audio_config_packet" && event.type !== "audio_buffer_stats") {
        const recent = [
            {
                type: event.type,
                channel: event.channel || "",
                at: Date.now()
            },
            ...next.recentEvents
        ];
        next.recentEvents = recent.slice(0, $ea71a0b4b5f3b38e$var$RECENT_LIMIT);
    }
    return next;
}
/** Share of successful stages, 0–100. */ function $ea71a0b4b5f3b38e$var$pct(part, total) {
    if (!total) return 100;
    return Math.round(part / total * 100);
}
/** Seconds since session start. */ function $ea71a0b4b5f3b38e$var$sessionSec(state) {
    return Math.max(1, Math.round((Date.now() - state.startedAt) / 1000));
}
function $ea71a0b4b5f3b38e$export$6d6ee81e00bef33a(state) {
    const health = state.framePackets ? $ea71a0b4b5f3b38e$var$pct(state.decodedFrames, state.framePackets) : 100;
    const playFps = state.playedFrames ? Math.round(state.playedFrames / $ea71a0b4b5f3b38e$var$sessionSec(state)) : 0;
    const recvFps = state.framePackets ? Math.round(state.framePackets / $ea71a0b4b5f3b38e$var$sessionSec(state)) : 0;
    const note = $ea71a0b4b5f3b38e$var$eventLabel(state.lastSignificantEvent);
    return `audio: ${health}% \xb7 buf ${state.bufferedMs}/${state.targetMs} ms \xb7 catch ${state.catchUpMs} ms \xb7 ~${playFps} fps \xb7 und ${state.underruns} \xb7 ${note}`;
}
function $ea71a0b4b5f3b38e$export$723acaa7cec89c5(state, presence = {}) {
    const hints = [];
    const sec = $ea71a0b4b5f3b38e$var$sessionSec(state);
    const decodePct = $ea71a0b4b5f3b38e$var$pct(state.decodedFrames, state.framePackets);
    const playPct = $ea71a0b4b5f3b38e$var$pct(state.playedFrames, state.decodedFrames);
    const remoteMicOn = presence.remoteMicOn;
    if (state.framePackets === 0) {
        if (remoteMicOn === false) {
            hints.push("No packets yet \u2014 remote microphone is off.");
            return hints;
        }
        hints.push("No packets yet \u2014 waiting for media.audio.opus subscription.");
        return hints;
    }
    if (state.contextState !== "running") hints.push("AudioContext is not running \u2014 click the page to unlock audio.");
    const idleSec = state.lastFrameAt ? Math.round((Date.now() - state.lastFrameAt) / 1000) : 0;
    if (state.playedFrames > 0 && idleSec > 3) {
        if (remoteMicOn === false) hints.push(`No Opus for ${idleSec} s \u{2014} remote microphone is off.`);
        else hints.push(`No packets for ${idleSec} s \u{2014} check audio_subscription_ended / network.`);
    }
    if (state.reconnects > 0) hints.push(`Audio subscription reconnected ${state.reconnects}\xd7 (auto after recv disconnect).`);
    const recentEnded = state.recentEvents.some((item)=>item.type === "audio_subscription_ended");
    if (recentEnded) hints.push("recv() recently returned null \u2014 subscription restarts; audio may drop for ~1 s.");
    if (decodePct < 92) hints.push(`Only ${decodePct}% of packets decoded \u{2014} see "losses by type" (decoder queue / network).`);
    else if (decodePct < 99) hints.push(`Rare pre-decode losses (${decodePct}%) \u{2014} usually a brief load spike.`);
    if (state.playedFrames > 0 && playPct < 99) hints.push("Some PCM did not reach the mixer \u2014 check audio_dropped_context / audio_dropped_start.");
    if (state.underruns > 0) {
        const undPerMin = Math.round(state.underruns / sec * 60);
        if (undPerMin > 30) hints.push(`Worklet underrun ~${undPerMin}/min \u{2014} target may rise to 100/150 ms.`);
        else hints.push(`Rare underruns (${state.underruns} in ${sec} s) \u{2014} usually inaudible.`);
    }
    if (state.targetMs > 50) hints.push(`Jitter buffer target ${state.targetMs} ms (raised after underruns; steps down when stable).`);
    if (state.catchUpMs > 0) hints.push(`Pause catch-up compressed ${state.catchUpMs} ms of noise (overlap-add), speech untouched.`);
    if (state.encodeBackpressure > 5) hints.push("Microphone: encoder often waited on queue \u2014 CPU or slow FastPubSub publish.");
    if (state.pendingEnqueued > state.droppedFrames && state.pendingEnqueued > 20) hints.push("Decoder queued packets in pending \u2014 brief overload, not a full drop.");
    if ((state.dropsByType.audio_subscription_error || 0) > 0) hints.push("Audio subscription error \u2014 WebSocket / FastPubSub may have disconnected.");
    if ((state.dropsByType.audio_dropped_no_decoder || 0) > 0) hints.push(`Lost ${state.dropsByType.audio_dropped_no_decoder} frames before Opus config (usually only on connect).`);
    if ((state.dropsByType.audio_dropped_pending_full || 0) > 0) hints.push("Pending queue overflow \u2014 decoder is far behind.");
    if (hints.length === 0 && state.playedFrames > 0) hints.push(`Audio is healthy (~${Math.round(state.playedFrames / sec)} play fps over ${sec} s).`);
    return hints;
}
function $ea71a0b4b5f3b38e$export$2b833180f8471ab9(state, presence = {}) {
    const sec = $ea71a0b4b5f3b38e$var$sessionSec(state);
    const lines = [
        "=== Audio: receive (listener) ===",
        `session: ${sec} s \xb7 subscriptions: ${state.subscriptions} \xb7 config: ${state.configPackets}`,
        `recv (frames): ${state.framePackets} \xb7 decoded: ${state.decodedFrames} \xb7 played: ${state.playedFrames}`,
        `decode: ${$ea71a0b4b5f3b38e$var$pct(state.decodedFrames, state.framePackets)}% \xb7 play/decode: ${$ea71a0b4b5f3b38e$var$pct(state.playedFrames, state.decodedFrames)}%`,
        `drop total: ${state.droppedFrames} \xb7 pending queued: ${state.pendingEnqueued} \xb7 underrun: ${state.underruns} \xb7 reconnect: ${state.reconnects}`
    ];
    lines.push("", "=== Playback / jitter buffer ===");
    lines.push(`mixer: ${state.mixerMode} \xb7 AudioContext: ${state.contextState}`);
    lines.push(`buffer: ${state.bufferedMs} ms \xb7 target: ${state.targetMs} ms \xb7 catch-up: ${state.catchUpMs} ms`);
    lines.push(`activity: ~${Math.round(state.playedFrames / sec)} play fps \xb7 ~${Math.round(state.framePackets / sec)} recv fps`);
    lines.push(`last significant: ${$ea71a0b4b5f3b38e$var$eventLabel(state.lastSignificantEvent)}${state.lastChannel ? ` \xb7 ${$ea71a0b4b5f3b38e$var$shortChannel(state.lastChannel)}` : ""}`);
    const dropTypes = Object.entries(state.dropsByType);
    lines.push("", "=== Losses by type ===");
    if (dropTypes.length === 0) lines.push("none");
    else for (const [type, count] of dropTypes.sort((a, b)=>b[1] - a[1]))lines.push(`${type}: ${count} \u{2014} ${$ea71a0b4b5f3b38e$var$dropTypeHint(type)}`);
    lines.push("", "=== Microphone (sender) ===");
    lines.push(`mode: continuous Opus \xb7 encode backpressure: ${state.encodeBackpressure}`);
    lines.push("", "=== Hints ===");
    for (const hint of $ea71a0b4b5f3b38e$export$723acaa7cec89c5(state, presence))lines.push(`\u{2022} ${hint}`);
    if (state.recentEvents.length > 0) {
        lines.push("", "=== Recent events ===");
        for (const item of state.recentEvents){
            const age = Math.round((Date.now() - item.at) / 1000);
            lines.push(`${age}s ago: ${$ea71a0b4b5f3b38e$var$eventLabel(item.type)}${item.channel ? ` \xb7 ${$ea71a0b4b5f3b38e$var$shortChannel(item.channel)}` : ""}`);
        }
    }
    return lines.join("\n");
}
/** Short channel name for logs. */ function $ea71a0b4b5f3b38e$var$shortChannel(channel) {
    const parts = channel.split(".");
    if (parts.length >= 3) return parts.slice(-3).join(".");
    return channel;
}
/** Human-readable event name. */ function $ea71a0b4b5f3b38e$var$eventLabel(type) {
    const labels = {
        idle: "waiting",
        audio_subscribed: "subscription ok",
        audio_unsubscribed: "unsubscribed",
        audio_mixer_running: "mixer running",
        audio_decoder_configured: "decoder ready",
        audio_underrun: "underrun worklet",
        audio_buffer_stats: "buffer stats",
        audio_pending_decode: "decode queue",
        audio_encode_backpressure: "encoder waited",
        audio_context_resumed: "AudioContext resume",
        audio_subscription_ended: "subscription ended",
        audio_subscription_reconnecting: "resubscribing",
        audio_subscription_error: "subscription error",
        audio_early_buffered: "buffer before config",
        audio_dropped_no_decoder: "drop: no decoder",
        audio_dropped_pending_full: "drop: pending full",
        audio_dropped_decode_exception: "drop: decode",
        audio_dropped_context: "drop: context",
        audio_dropped_start: "drop: start",
        audio_decoder_error: "decoder error"
    };
    return labels[type] || type;
}
/** Drop type explanation for the UI. */ function $ea71a0b4b5f3b38e$var$dropTypeHint(type) {
    const hints = {
        audio_dropped_no_decoder: "frame arrived before Opus config",
        audio_dropped_pending_full: "decoder wait queue overflow",
        audio_dropped_decode_exception: "decode() error",
        audio_dropped_context: "AudioContext not running",
        audio_dropped_start: "source.start() failed",
        audio_decoder_error: "AudioDecoder failure",
        audio_subscription_error: "FastPubSub subscription ended"
    };
    return hints[type] || "see console";
}


const $2a6bed64870680d8$var$textEncoder = new TextEncoder();
const $2a6bed64870680d8$var$textDecoder = new TextDecoder();
function $2a6bed64870680d8$export$e1b32e613f230dc6(value) {
    return $2a6bed64870680d8$var$textEncoder.encode(value);
}
function $2a6bed64870680d8$export$db70ef86b2db322a(value) {
    return $2a6bed64870680d8$var$textDecoder.decode(value);
}
function $2a6bed64870680d8$export$30a71edf0753ed6b(value) {
    if (typeof value === "string") return $2a6bed64870680d8$export$e1b32e613f230dc6(value);
    if (value instanceof Uint8Array) return new Uint8Array(value);
    if (value instanceof ArrayBuffer) return new Uint8Array(value.slice(0));
    return new Uint8Array(value.buffer.slice(value.byteOffset, value.byteOffset + value.byteLength));
}
function $2a6bed64870680d8$export$230b06546aa82954(value) {
    if (value instanceof Uint8Array) return value;
    if (value instanceof ArrayBuffer) return new Uint8Array(value);
    return new Uint8Array(value.buffer, value.byteOffset, value.byteLength);
}
function $2a6bed64870680d8$export$287dd7971339c972(chunks) {
    let size = 0;
    for (const chunk of chunks)size += chunk.byteLength;
    const out = new Uint8Array(size);
    let offset = 0;
    for (const chunk of chunks){
        out.set(chunk, offset);
        offset += chunk.byteLength;
    }
    return out;
}
function $2a6bed64870680d8$export$f163bb7e7f385f7(data, offset) {
    return new DataView(data.buffer, data.byteOffset + offset, 2).getUint16(0, false);
}
function $2a6bed64870680d8$export$74c0812a28d8ac40(data, offset, value) {
    new DataView(data.buffer, data.byteOffset + offset, 2).setUint16(0, value, false);
}
function $2a6bed64870680d8$export$fa598b0ff39af6cc(data, offset) {
    return new DataView(data.buffer, data.byteOffset + offset, 4).getUint32(0, false);
}
function $2a6bed64870680d8$export$a5bf86c9746bcbc2(data, offset, value) {
    new DataView(data.buffer, data.byteOffset + offset, 4).setUint32(0, value, false);
}
function $2a6bed64870680d8$export$fc829b2afbae3c90(data, offset) {
    return new DataView(data.buffer, data.byteOffset + offset, 8).getBigUint64(0, false);
}
function $2a6bed64870680d8$export$50c532c203db6404(data, offset, value) {
    new DataView(data.buffer, data.byteOffset + offset, 8).setBigUint64(0, value, false);
}
const $2a6bed64870680d8$var$XXH32_PRIME_1 = 0x9e3779b1;
const $2a6bed64870680d8$var$XXH32_PRIME_2 = 0x85ebca77;
const $2a6bed64870680d8$var$XXH32_PRIME_3 = 0xc2b2ae3d;
const $2a6bed64870680d8$var$XXH32_PRIME_4 = 0x27d4eb2f;
const $2a6bed64870680d8$var$XXH32_PRIME_5 = 0x165667b1;
function $2a6bed64870680d8$export$59c89c9fda511ec(data, seed = 0) {
    let offset = 0;
    let hash;
    if (data.length >= 16) {
        let v1 = seed + $2a6bed64870680d8$var$XXH32_PRIME_1 + $2a6bed64870680d8$var$XXH32_PRIME_2 >>> 0;
        let v2 = seed + $2a6bed64870680d8$var$XXH32_PRIME_2 >>> 0;
        let v3 = seed >>> 0;
        let v4 = seed - $2a6bed64870680d8$var$XXH32_PRIME_1 >>> 0;
        const limit = data.length - 16;
        while(offset <= limit){
            v1 = $2a6bed64870680d8$var$xxHash32Round(v1, $2a6bed64870680d8$var$readU32Le(data, offset));
            offset += 4;
            v2 = $2a6bed64870680d8$var$xxHash32Round(v2, $2a6bed64870680d8$var$readU32Le(data, offset));
            offset += 4;
            v3 = $2a6bed64870680d8$var$xxHash32Round(v3, $2a6bed64870680d8$var$readU32Le(data, offset));
            offset += 4;
            v4 = $2a6bed64870680d8$var$xxHash32Round(v4, $2a6bed64870680d8$var$readU32Le(data, offset));
            offset += 4;
        }
        hash = $2a6bed64870680d8$var$rotl32(v1, 1) + $2a6bed64870680d8$var$rotl32(v2, 7) + $2a6bed64870680d8$var$rotl32(v3, 12) + $2a6bed64870680d8$var$rotl32(v4, 18) >>> 0;
    } else hash = seed + $2a6bed64870680d8$var$XXH32_PRIME_5 >>> 0;
    hash = hash + data.length >>> 0;
    while(offset + 4 <= data.length){
        hash = hash + Math.imul($2a6bed64870680d8$var$readU32Le(data, offset), $2a6bed64870680d8$var$XXH32_PRIME_3) >>> 0;
        hash = Math.imul($2a6bed64870680d8$var$rotl32(hash, 17), $2a6bed64870680d8$var$XXH32_PRIME_4) >>> 0;
        offset += 4;
    }
    while(offset < data.length){
        hash = hash + Math.imul(data[offset] ?? 0, $2a6bed64870680d8$var$XXH32_PRIME_5) >>> 0;
        hash = Math.imul($2a6bed64870680d8$var$rotl32(hash, 11), $2a6bed64870680d8$var$XXH32_PRIME_1) >>> 0;
        offset += 1;
    }
    hash ^= hash >>> 15;
    hash = Math.imul(hash, $2a6bed64870680d8$var$XXH32_PRIME_2) >>> 0;
    hash ^= hash >>> 13;
    hash = Math.imul(hash, $2a6bed64870680d8$var$XXH32_PRIME_3) >>> 0;
    hash ^= hash >>> 16;
    return hash >>> 0;
}
function $2a6bed64870680d8$export$8c79fc1ce37f06de(parts, seed = 0) {
    let size = 0;
    for (const part of parts)size += 4 + part.length;
    const data = new Uint8Array(size);
    let offset = 0;
    for (const part of parts){
        $2a6bed64870680d8$var$writeU32Le(data, offset, part.length);
        offset += 4;
        data.set(part, offset);
        offset += part.length;
    }
    return $2a6bed64870680d8$export$59c89c9fda511ec(data, seed);
}
function $2a6bed64870680d8$var$xxHash32Round(acc, value) {
    let next = acc + Math.imul(value, $2a6bed64870680d8$var$XXH32_PRIME_2) >>> 0;
    next = $2a6bed64870680d8$var$rotl32(next, 13);
    return Math.imul(next, $2a6bed64870680d8$var$XXH32_PRIME_1) >>> 0;
}
function $2a6bed64870680d8$var$rotl32(value, bits) {
    return (value << bits | value >>> 32 - bits) >>> 0;
}
function $2a6bed64870680d8$var$readU32Le(data, offset) {
    return ((data[offset] ?? 0) | (data[offset + 1] ?? 0) << 8 | (data[offset + 2] ?? 0) << 16 | (data[offset + 3] ?? 0) << 24) >>> 0;
}
function $2a6bed64870680d8$var$writeU32Le(data, offset, value) {
    data[offset] = value & 0xff;
    data[offset + 1] = value >>> 8 & 0xff;
    data[offset + 2] = value >>> 16 & 0xff;
    data[offset + 3] = value >>> 24 & 0xff;
}


/**
 * Base SDK error.
 *
 * The code is stable enough for simple checks in user code.
 */ class $b09ac485321cc4ed$export$bd5e1fd04abe33dd extends Error {
    code;
    constructor(code, message){
        super(message);
        this.name = new.target.name;
        this.code = code;
    }
}
class $b09ac485321cc4ed$export$f2e832acab1bdd79 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(code, message){
        super(code, message);
    }
}
class $b09ac485321cc4ed$export$9f48ca187ff38621 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(code, message){
        super(code, message);
    }
}
class $b09ac485321cc4ed$export$f91b299ee183332c extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(message){
        super("build_error", message);
    }
}
class $b09ac485321cc4ed$export$107365fdc90b0143 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(message){
        super("publish_error", message);
    }
}
class $b09ac485321cc4ed$export$8e68de6fb26f2236 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(code, message){
        super(code, message);
    }
}
class $b09ac485321cc4ed$export$d8ea20af4c01b9d9 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(code, message){
        super(code, message);
    }
}
class $b09ac485321cc4ed$export$fe40046a1b08a9d7 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(message){
        super("meta_encode_error", message);
    }
}
class $b09ac485321cc4ed$export$6d29b48d1471e7e6 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(message){
        super("meta_decode_error", message);
    }
}
class $b09ac485321cc4ed$export$d5d995a9f97288b3 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(message){
        super("state_sync_error", message);
    }
}




const $9ebeb5fdd029b452$export$e818bad5c1128e7f = 1;
const $9ebeb5fdd029b452$export$165eab13b8aa7b99 = 0x0001;
const $9ebeb5fdd029b452$export$4d9a6b683a2fe834 = 0x0002;
const $9ebeb5fdd029b452$export$8d3a822fc375d7a3 = 0x0003;
const $9ebeb5fdd029b452$export$72ca7d3a57248cdd = 0x0004;
const $9ebeb5fdd029b452$export$bc4c0024bcac0400 = 0x0005;
const $9ebeb5fdd029b452$export$2c82e4acde754c20 = 0x0006;
const $9ebeb5fdd029b452$export$9e6b0bb213adbb66 = 0x0007;
const $9ebeb5fdd029b452$export$dd5de4bd32893730 = 0x0008;
const $9ebeb5fdd029b452$export$213b0026c188cc45 = 0x0009;
const $9ebeb5fdd029b452$export$59b74ed860b22bf8 = 0x000a;
const $9ebeb5fdd029b452$export$a752e0c4efca0558 = 0x000b;
const $9ebeb5fdd029b452$export$c43aba9a497fbbd8 = 1;
const $9ebeb5fdd029b452$export$61bbf024766606bf = 1;
const $9ebeb5fdd029b452$export$e63fed7c1e13426d = 2;
class $9ebeb5fdd029b452$export$90a59c3c1368656d {
    bytes;
    constructor(bytes){
        this.bytes = bytes ? (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(bytes) : new Uint8Array(0);
    }
    /**
     * Creates an empty metadata value.
     */ static none() {
        return new $9ebeb5fdd029b452$export$90a59c3c1368656d();
    }
    /**
     * Creates metadata from a binary blob.
     */ static blob(bytes) {
        return new $9ebeb5fdd029b452$export$90a59c3c1368656d(bytes);
    }
    /**
     * Returns true when there is no metadata.
     */ isEmpty() {
        return this.bytes.length === 0;
    }
    /**
     * Returns the record count from the header.
     */ stageCount() {
        if (this.isEmpty()) return 0;
        if (this.bytes.length < 2) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata blob is too short");
        if (this.bytes[0] !== $9ebeb5fdd029b452$export$e818bad5c1128e7f) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata version is not supported");
        return this.bytes[1] ?? 0;
    }
    /**
     * Returns all metadata records.
     */ records() {
        return Array.from(new $9ebeb5fdd029b452$export$b079d20fca7984af(this.bytes));
    }
}
class $9ebeb5fdd029b452$export$ea11f29158edde53 {
    tenant;
    channel;
    matchedPattern;
    receivedAt;
    payload;
    meta;
    constructor(input){
        this.tenant = input.tenant;
        this.channel = input.channel;
        this.matchedPattern = input.matchedPattern;
        this.receivedAt = input.receivedAt ?? new Date();
        this.payload = (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(input.payload);
        this.meta = input.meta ?? $9ebeb5fdd029b452$export$90a59c3c1368656d.none();
    }
    /**
     * Returns true when metadata exists.
     */ hasMetadata() {
        return !this.meta.isEmpty();
    }
}
class $9ebeb5fdd029b452$export$710aedf3f94c06a3 {
    chunks;
    countValue;
    constructor(){
        this.chunks = [
            new Uint8Array([
                $9ebeb5fdd029b452$export$e818bad5c1128e7f,
                0
            ])
        ];
        this.countValue = 0;
    }
    /**
     * Returns true when there are no records yet.
     */ isEmpty() {
        return this.countValue === 0;
    }
    /**
     * Adds one ready record.
     */ pushRecord(recordType, data) {
        if (this.countValue >= 255) throw new (0, $b09ac485321cc4ed$export$fe40046a1b08a9d7)("metadata records are more than 255");
        const body = (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(data);
        if (body.length > 0xffff) throw new (0, $b09ac485321cc4ed$export$fe40046a1b08a9d7)("metadata record is too large");
        const header = new Uint8Array(4);
        (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(header, 0, recordType);
        (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(header, 2, body.length);
        this.chunks.push(header, body);
        this.countValue += 1;
        this.chunks[0][1] = this.countValue;
    }
    /**
     * Finishes the writer and returns metadata.
     */ finish() {
        if (this.countValue === 0) return $9ebeb5fdd029b452$export$90a59c3c1368656d.none();
        let size = 0;
        for (const chunk of this.chunks)size += chunk.length;
        const out = new Uint8Array(size);
        let offset = 0;
        for (const chunk of this.chunks){
            out.set(chunk, offset);
            offset += chunk.length;
        }
        return $9ebeb5fdd029b452$export$90a59c3c1368656d.blob(out);
    }
}
class $9ebeb5fdd029b452$export$b079d20fca7984af {
    data;
    countValue;
    constructor(data){
        this.data = (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(data);
        if (this.data.length < 2) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata blob is too short");
        if (this.data[0] !== $9ebeb5fdd029b452$export$e818bad5c1128e7f) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata version is not supported");
        this.countValue = this.data[1] ?? 0;
    }
    /**
     * Returns the count written in the blob header.
     */ count() {
        return this.countValue;
    }
    *[Symbol.iterator]() {
        let offset = 2;
        for(let index = 0; index < this.countValue; index += 1){
            if (offset + 4 > this.data.length) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata blob is corrupted");
            const recordType = (0, $2a6bed64870680d8$export$f163bb7e7f385f7)(this.data, offset);
            const len = (0, $2a6bed64870680d8$export$f163bb7e7f385f7)(this.data, offset + 2);
            offset += 4;
            if (offset + len > this.data.length) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata blob is corrupted");
            const recordData = this.data.slice(offset, offset + len);
            offset += len;
            yield {
                recordType: recordType,
                data: recordData
            };
        }
        if (offset !== this.data.length) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata blob is corrupted");
    }
}


const $7e363819e496eacf$export$566ef25622b52783 = 16384;
const $7e363819e496eacf$export$eb9d0ae5047c333e = 16384;
const $7e363819e496eacf$export$df45e3bdb466d54d = 60000;
const $7e363819e496eacf$export$3375e531948be1c4 = 250;
const $7e363819e496eacf$var$FRAGMENT_MAGIC = (0, $2a6bed64870680d8$export$e1b32e613f230dc6)("FPSFRAG1");
const $7e363819e496eacf$var$REQUEST_MAGIC = (0, $2a6bed64870680d8$export$e1b32e613f230dc6)("FPSFREQ1");
const $7e363819e496eacf$var$MESSAGE_ID_BYTES = 8;
const $7e363819e496eacf$var$U32_BYTES = 4;
const $7e363819e496eacf$var$CONTROL_MARK = "._contrl.";
class $7e363819e496eacf$export$f1345d679fe06355 {
    fragmentThresholdBytes;
    maxFragmentBytes;
    requestIntervalMs;
    defragTimeoutMs;
    outboundCache = new Map();
    inboundCache = new Map();
    completed = new Map();
    constructor(fragmentThresholdBytes = $7e363819e496eacf$export$eb9d0ae5047c333e, maxFragmentBytes = $7e363819e496eacf$export$566ef25622b52783, requestIntervalMs = $7e363819e496eacf$export$3375e531948be1c4, defragTimeoutMs = $7e363819e496eacf$export$df45e3bdb466d54d){
        this.fragmentThresholdBytes = fragmentThresholdBytes;
        this.maxFragmentBytes = maxFragmentBytes;
        this.requestIntervalMs = requestIntervalMs;
        this.defragTimeoutMs = defragTimeoutMs;
    }
    outbound(ctx, payload) {
        if ($7e363819e496eacf$var$isControlChannel(ctx.channel) || payload.length < this.fragmentThresholdBytes) return [
            payload
        ];
        const maxChunk = $7e363819e496eacf$var$maxChunkLen(this.maxFragmentBytes);
        const fragmentCount = Math.ceil(payload.length / maxChunk);
        if (fragmentCount > 0xffffffff) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_encode_failed", "too many fragments");
        const messageId = $7e363819e496eacf$var$makeMessageId();
        const fragments = [];
        for(let index = 0; index < fragmentCount; index += 1){
            const start = index * maxChunk;
            const chunk = payload.slice(start, Math.min(payload.length, start + maxChunk));
            fragments.push($7e363819e496eacf$export$93e9c48bdb06e37a(messageId, payload.length, index, fragmentCount, chunk));
        }
        this.outboundCache.set($7e363819e496eacf$var$cacheKey(ctx.tenant, ctx.channel, messageId), {
            createdAt: Date.now(),
            fragments: fragments.slice()
        });
        return fragments;
    }
    inbound(ctx, payload, meta) {
        const control = $7e363819e496eacf$var$parseControlChannel(ctx.channel);
        if (control) return this.handleRequest(ctx.tenant, control.baseChannel, control.messageId, payload);
        const fragment = $7e363819e496eacf$export$e73f4c97dec1fd41(payload);
        if (!fragment) return {
            payloads: [
                payload
            ],
            messages: []
        };
        const key = $7e363819e496eacf$var$cacheKey(ctx.tenant, ctx.channel, fragment.messageId);
        if (this.completed.has(key)) return {
            payloads: [],
            messages: []
        };
        let entry = this.inboundCache.get(key);
        if (!entry) {
            entry = $7e363819e496eacf$var$newInboundMessage(fragment.originalLen, fragment.fragmentCount);
            this.inboundCache.set(key, entry);
        }
        const completed = $7e363819e496eacf$var$pushFragment(entry, fragment);
        if (!completed) return {
            payloads: [],
            messages: []
        };
        this.inboundCache.delete(key);
        this.completed.set(key, Date.now() + this.defragTimeoutMs);
        const record = new Uint8Array($7e363819e496eacf$var$MESSAGE_ID_BYTES + $7e363819e496eacf$var$U32_BYTES + $7e363819e496eacf$var$U32_BYTES);
        record.set(fragment.messageId, 0);
        (0, $2a6bed64870680d8$export$a5bf86c9746bcbc2)(record, $7e363819e496eacf$var$MESSAGE_ID_BYTES, fragment.originalLen);
        (0, $2a6bed64870680d8$export$a5bf86c9746bcbc2)(record, $7e363819e496eacf$var$MESSAGE_ID_BYTES + $7e363819e496eacf$var$U32_BYTES, fragment.fragmentCount);
        meta.pushRecord((0, $9ebeb5fdd029b452$export$bc4c0024bcac0400), record);
        return {
            payloads: [
                completed
            ],
            messages: []
        };
    }
    onTimer(_ctx) {
        const now = Date.now();
        for (const [key, entry] of Array.from(this.outboundCache))if (now - entry.createdAt >= this.defragTimeoutMs) this.outboundCache.delete(key);
        for (const [key, expiresAt] of Array.from(this.completed))if (expiresAt <= now) this.completed.delete(key);
        const messages = [];
        for (const [key, entry] of this.inboundCache){
            if (now - entry.createdAt >= this.defragTimeoutMs) {
                this.inboundCache.delete(key);
                throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", `fragment defrag timeout: key=${key}`);
            }
            if (entry.lastRequestAt !== undefined && now - entry.lastRequestAt < this.requestIntervalMs) continue;
            const missing = $7e363819e496eacf$var$missingIndexes(entry);
            if (missing.length === 0) continue;
            entry.lastRequestAt = now;
            const { tenant: tenant, channel: channel, messageId: messageId } = $7e363819e496eacf$var$parseCacheKey(key);
            messages.push({
                tenant: tenant,
                channel: $7e363819e496eacf$var$controlChannel(channel, messageId),
                payload: $7e363819e496eacf$var$encodeRequest(messageId, missing)
            });
        }
        return messages;
    }
    handleRequest(tenant, baseChannel, channelMessageId, payload) {
        const request = $7e363819e496eacf$var$decodeRequest(payload);
        if (!$7e363819e496eacf$var$bytesEqual(request.messageId, channelMessageId)) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment request id does not match control channel");
        const outbound = this.outboundCache.get($7e363819e496eacf$var$cacheKey(tenant, baseChannel, request.messageId));
        if (!outbound) return {
            payloads: [],
            messages: []
        };
        const messages = [];
        for (const index of request.indexes){
            const fragment = outbound.fragments[index];
            if (fragment) messages.push({
                tenant: tenant,
                channel: baseChannel,
                payload: fragment
            });
        }
        return {
            payloads: [],
            messages: messages
        };
    }
}
function $7e363819e496eacf$export$93e9c48bdb06e37a(messageId, originalLen, fragmentIndex, fragmentCount, chunk) {
    const out = new Uint8Array($7e363819e496eacf$var$fragmentHeaderLen() + chunk.length);
    let offset = 0;
    out.set($7e363819e496eacf$var$FRAGMENT_MAGIC, offset);
    offset += $7e363819e496eacf$var$FRAGMENT_MAGIC.length;
    out.set(messageId, offset);
    offset += $7e363819e496eacf$var$MESSAGE_ID_BYTES;
    (0, $2a6bed64870680d8$export$a5bf86c9746bcbc2)(out, offset, originalLen);
    offset += $7e363819e496eacf$var$U32_BYTES;
    (0, $2a6bed64870680d8$export$a5bf86c9746bcbc2)(out, offset, fragmentIndex);
    offset += $7e363819e496eacf$var$U32_BYTES;
    (0, $2a6bed64870680d8$export$a5bf86c9746bcbc2)(out, offset, fragmentCount);
    offset += $7e363819e496eacf$var$U32_BYTES;
    out.set(chunk, offset);
    return out;
}
function $7e363819e496eacf$export$e73f4c97dec1fd41(payload) {
    if (!$7e363819e496eacf$var$startsWith(payload, $7e363819e496eacf$var$FRAGMENT_MAGIC)) return undefined;
    if (payload.length < $7e363819e496eacf$var$fragmentHeaderLen()) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment payload is too short");
    let offset = $7e363819e496eacf$var$FRAGMENT_MAGIC.length;
    const messageId = payload.slice(offset, offset + $7e363819e496eacf$var$MESSAGE_ID_BYTES);
    offset += $7e363819e496eacf$var$MESSAGE_ID_BYTES;
    const originalLen = (0, $2a6bed64870680d8$export$fa598b0ff39af6cc)(payload, offset);
    offset += $7e363819e496eacf$var$U32_BYTES;
    const fragmentIndex = (0, $2a6bed64870680d8$export$fa598b0ff39af6cc)(payload, offset);
    offset += $7e363819e496eacf$var$U32_BYTES;
    const fragmentCount = (0, $2a6bed64870680d8$export$fa598b0ff39af6cc)(payload, offset);
    offset += $7e363819e496eacf$var$U32_BYTES;
    if (fragmentCount === 0 || fragmentIndex >= fragmentCount) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment index or count is invalid");
    if (payload.length === offset) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment chunk is empty");
    return {
        messageId: messageId,
        originalLen: originalLen,
        fragmentIndex: fragmentIndex,
        fragmentCount: fragmentCount,
        chunk: payload.slice(offset)
    };
}
function $7e363819e496eacf$var$fragmentHeaderLen() {
    return $7e363819e496eacf$var$FRAGMENT_MAGIC.length + $7e363819e496eacf$var$MESSAGE_ID_BYTES + $7e363819e496eacf$var$U32_BYTES + $7e363819e496eacf$var$U32_BYTES + $7e363819e496eacf$var$U32_BYTES;
}
function $7e363819e496eacf$var$maxChunkLen(maxFragmentBytes) {
    const headerLen = $7e363819e496eacf$var$fragmentHeaderLen();
    if (maxFragmentBytes <= headerLen) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("invalid_config", `fragment maxFragmentBytes must be greater than ${headerLen}`);
    return maxFragmentBytes - headerLen;
}
function $7e363819e496eacf$var$newInboundMessage(originalLen, fragmentCount) {
    if (originalLen === 0 || fragmentCount === 0 || fragmentCount > originalLen) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment message has bad length or count");
    return {
        createdAt: Date.now(),
        originalLen: originalLen,
        fragmentCount: fragmentCount,
        fragments: new Array(fragmentCount)
    };
}
function $7e363819e496eacf$var$pushFragment(entry, fragment) {
    if (entry.originalLen !== fragment.originalLen || entry.fragmentCount !== fragment.fragmentCount) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment header does not match previous fragments");
    entry.fragments[fragment.fragmentIndex] ??= fragment.chunk;
    for (const item of entry.fragments){
        if (!item) return undefined;
    }
    const out = new Uint8Array(entry.originalLen);
    let offset = 0;
    for (const item of entry.fragments){
        if (!item) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment message is not complete");
        out.set(item, offset);
        offset += item.length;
    }
    if (offset !== entry.originalLen) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "assembled payload length does not match original length");
    return out;
}
function $7e363819e496eacf$var$missingIndexes(entry) {
    const missing = [];
    for(let i = 0; i < entry.fragments.length; i += 1)if (!entry.fragments[i]) missing.push(i);
    return missing;
}
function $7e363819e496eacf$var$encodeRequest(messageId, indexes) {
    const out = new Uint8Array($7e363819e496eacf$var$REQUEST_MAGIC.length + $7e363819e496eacf$var$MESSAGE_ID_BYTES + $7e363819e496eacf$var$U32_BYTES + indexes.length * $7e363819e496eacf$var$U32_BYTES);
    let offset = 0;
    out.set($7e363819e496eacf$var$REQUEST_MAGIC, offset);
    offset += $7e363819e496eacf$var$REQUEST_MAGIC.length;
    out.set(messageId, offset);
    offset += $7e363819e496eacf$var$MESSAGE_ID_BYTES;
    (0, $2a6bed64870680d8$export$a5bf86c9746bcbc2)(out, offset, indexes.length);
    offset += $7e363819e496eacf$var$U32_BYTES;
    for (const index of indexes){
        (0, $2a6bed64870680d8$export$a5bf86c9746bcbc2)(out, offset, index);
        offset += $7e363819e496eacf$var$U32_BYTES;
    }
    return out;
}
function $7e363819e496eacf$var$decodeRequest(payload) {
    if (!$7e363819e496eacf$var$startsWith(payload, $7e363819e496eacf$var$REQUEST_MAGIC)) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment request has bad magic");
    let offset = $7e363819e496eacf$var$REQUEST_MAGIC.length;
    const messageId = payload.slice(offset, offset + $7e363819e496eacf$var$MESSAGE_ID_BYTES);
    offset += $7e363819e496eacf$var$MESSAGE_ID_BYTES;
    const count = (0, $2a6bed64870680d8$export$fa598b0ff39af6cc)(payload, offset);
    offset += $7e363819e496eacf$var$U32_BYTES;
    if (payload.length !== $7e363819e496eacf$var$REQUEST_MAGIC.length + $7e363819e496eacf$var$MESSAGE_ID_BYTES + $7e363819e496eacf$var$U32_BYTES + count * $7e363819e496eacf$var$U32_BYTES) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment request has bad length");
    const indexes = [];
    for(let i = 0; i < count; i += 1){
        indexes.push((0, $2a6bed64870680d8$export$fa598b0ff39af6cc)(payload, offset));
        offset += $7e363819e496eacf$var$U32_BYTES;
    }
    return {
        messageId: messageId,
        indexes: indexes
    };
}
function $7e363819e496eacf$var$isControlChannel(channel) {
    return channel.includes($7e363819e496eacf$var$CONTROL_MARK);
}
function $7e363819e496eacf$var$controlChannel(baseChannel, messageId) {
    return `${baseChannel}${$7e363819e496eacf$var$CONTROL_MARK}${$7e363819e496eacf$var$bytesToHex(messageId)}`;
}
function $7e363819e496eacf$var$parseControlChannel(channel) {
    const index = channel.indexOf($7e363819e496eacf$var$CONTROL_MARK);
    if (index < 0) return undefined;
    const baseChannel = channel.slice(0, index);
    const hex = channel.slice(index + $7e363819e496eacf$var$CONTROL_MARK.length);
    if (!baseChannel) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment control channel has empty base");
    return {
        baseChannel: baseChannel,
        messageId: $7e363819e496eacf$var$parseHexId(hex)
    };
}
function $7e363819e496eacf$var$makeMessageId() {
    const id = new Uint8Array($7e363819e496eacf$var$MESSAGE_ID_BYTES);
    if (globalThis.crypto?.getRandomValues) {
        globalThis.crypto.getRandomValues(id);
        return id;
    }
    for(let i = 0; i < id.length; i += 1)id[i] = Math.floor(Math.random() * 256);
    return id;
}
function $7e363819e496eacf$var$bytesToHex(bytes) {
    let out = "";
    for (const byte of bytes)out += byte.toString(16).padStart(2, "0");
    return out;
}
function $7e363819e496eacf$var$parseHexId(hex) {
    if (hex.length !== $7e363819e496eacf$var$MESSAGE_ID_BYTES * 2) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment message id has bad hex length");
    const out = new Uint8Array($7e363819e496eacf$var$MESSAGE_ID_BYTES);
    for(let i = 0; i < $7e363819e496eacf$var$MESSAGE_ID_BYTES; i += 1){
        const value = Number.parseInt(hex.slice(i * 2, i * 2 + 2), 16);
        if (!Number.isFinite(value)) throw new (0, $b09ac485321cc4ed$export$d8ea20af4c01b9d9)("fragment_decode_failed", "fragment message id has bad hex digit");
        out[i] = value;
    }
    return out;
}
function $7e363819e496eacf$var$cacheKey(tenant, channel, messageId) {
    return `${tenant}\n${channel}\n${$7e363819e496eacf$var$bytesToHex(messageId)}`;
}
function $7e363819e496eacf$var$parseCacheKey(key) {
    const [tenant = "", channel = "", id = ""] = key.split("\n");
    return {
        tenant: tenant,
        channel: channel,
        messageId: $7e363819e496eacf$var$parseHexId(id)
    };
}
function $7e363819e496eacf$var$startsWith(payload, prefix) {
    if (payload.length < prefix.length) return false;
    for(let i = 0; i < prefix.length; i += 1){
        if (payload[i] !== prefix[i]) return false;
    }
    return true;
}
function $7e363819e496eacf$var$bytesEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i += 1){
        if (a[i] !== b[i]) return false;
    }
    return true;
}




const $3b990687ea5a342a$export$72747cb09ed23ab2 = "sdkDefault100Hz";
class $3b990687ea5a342a$export$90251372f1939aee {
    tenant;
    prefix;
    filter;
    constructor(tenant, prefix, filter){
        this.tenant = tenant;
        this.prefix = prefix;
        this.filter = filter;
    }
    /**
     * Checks if this filter must run for this message.
     */ matches(ctx) {
        return ctx.tenant === this.tenant && ctx.channel.startsWith(this.prefix);
    }
}
function $3b990687ea5a342a$export$a518a1ff0c180fcc(mode) {
    return {
        mode: mode,
        intervalMs: $3b990687ea5a342a$export$e52b86c7c25ac359(mode)
    };
}
function $3b990687ea5a342a$export$e52b86c7c25ac359(mode) {
    switch(mode){
        case "ultraLowLatency1000Hz":
            return 1;
        case "highFrequency500Hz":
            return 2;
        case "lowLatency200Hz":
            return 5;
        case "economy20Hz":
            return 50;
        case "slow10Hz":
            return 100;
        case "sdkDefault100Hz":
        default:
            return 10;
    }
}
async function $3b990687ea5a342a$export$e3ddf273e40fce27(filters, ctx, payload, meta) {
    return $3b990687ea5a342a$export$cf32509dd19cedfd(filters, filters.length, ctx, payload, meta);
}
async function $3b990687ea5a342a$export$cf32509dd19cedfd(filters, endIndex, ctx, payload, meta) {
    let payloads = [
        payload
    ];
    const end = Math.min(Math.max(0, endIndex), filters.length);
    for(let i = end - 1; i >= 0; i -= 1){
        const registration = filters[i];
        if (!registration?.matches(ctx)) continue;
        const next = [];
        for (const item of payloads)if (registration.filter.outbound) {
            const filtered = await registration.filter.outbound(ctx, item, meta);
            next.push(...filtered);
        } else next.push(item);
        payloads = next;
    }
    return payloads;
}
async function $3b990687ea5a342a$export$438723802648587b(filters, ctx, payload, meta) {
    let payloads = [
        payload
    ];
    const messages = [];
    for (const registration of filters){
        if (!registration.matches(ctx)) continue;
        const next = [];
        for (const item of payloads)if (registration.filter.inbound) {
            const result = await registration.filter.inbound(ctx, item, meta);
            next.push(...result.payloads);
            messages.push(...result.messages);
        } else next.push(item);
        payloads = next;
    }
    return {
        payloads: payloads,
        messages: messages
    };
}
function $3b990687ea5a342a$export$3a494e8f1895c44b(payload) {
    return {
        payloads: [
            payload
        ],
        messages: []
    };
}






/**
 * Small async queue for subscription messages.
 *
 * `subscribe` returns this queue. You can read one message with `recv()`
 * or use `for await`.
 *
 * @example
 * ```ts
 * const queue = await client.subscribe("tenant_1", "public.#");
 *
 * for await (const message of queue) {
 *   console.log(message.channel, message.payload);
 * }
 * ```
 */ class $32761a3f8d3f5dc1$export$c24e73273208a9bb {
    capacity;
    items;
    waiters;
    closed;
    constructor(capacity = 256){
        this.capacity = Math.max(1, capacity);
        this.items = [];
        this.waiters = [];
        this.closed = false;
    }
    /**
     * Adds an item to the queue.
     *
     * Returns `false` when the queue is closed or full.
     */ push(item) {
        if (this.closed) return false;
        const waiter = this.waiters.shift();
        if (waiter) {
            waiter({
                value: item,
                done: false
            });
            return true;
        }
        if (this.items.length >= this.capacity) return false;
        this.items.push(item);
        return true;
    }
    /**
     * Reads one item without waiting.
     */ tryRecv() {
        return this.items.shift();
    }
    /**
     * Waits for one item.
     */ recv() {
        const item = this.items.shift();
        if (item !== undefined) return Promise.resolve(item);
        if (this.closed) return Promise.resolve(undefined);
        return new Promise((resolve)=>{
            this.waiters.push((result)=>{
                resolve(result.done ? undefined : result.value);
            });
        });
    }
    /**
     * Closes the queue and wakes all readers.
     */ close() {
        if (this.closed) return;
        this.closed = true;
        while(this.waiters.length > 0){
            const waiter = this.waiters.shift();
            waiter?.({
                value: undefined,
                done: true
            });
        }
    }
    /**
     * Returns the current number of items in the queue.
     */ len() {
        return this.items.length;
    }
    async *[Symbol.asyncIterator]() {
        while(true){
            const item = await this.recv();
            if (item === undefined) break;
            yield item;
        }
    }
}



const $1c6b3987498f62a9$export$d0a4d55fbab05d8f = 0x01;
const $1c6b3987498f62a9$export$2ba143b522a908f7 = 0x02;
const $1c6b3987498f62a9$export$6140aaf55daeb3d9 = "PING";
const $1c6b3987498f62a9$export$c5a04a3d52caa8d5 = "PONG";
function $1c6b3987498f62a9$export$19776548d9276c48(text) {
    return text === $1c6b3987498f62a9$export$c5a04a3d52caa8d5;
}
function $1c6b3987498f62a9$var$deliveryToWire(mode) {
    switch(mode){
        case "deliverOneLowLatency":
            return 1;
        case "deliverOneRandom":
            return 2;
        default:
            return 0;
    }
}
function $1c6b3987498f62a9$export$87699b10a0dfb985(tenant, channel, payload, delivery = "broadcast") {
    const tenantBytes = (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(tenant);
    const channelBytes = (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(channel);
    if (tenantBytes.length === 0 || channelBytes.length === 0) throw new Error("tenant and channel cannot be empty");
    if (tenantBytes.length > 0xffff || channelBytes.length > 0xffff) throw new Error("tenant or channel is too long");
    const headerLen = delivery === "broadcast" ? 0 : 2;
    const out = new Uint8Array(headerLen + 4 + tenantBytes.length + channelBytes.length + payload.length);
    let offset = 0;
    if (delivery !== "broadcast") {
        out[offset] = $1c6b3987498f62a9$export$2ba143b522a908f7;
        offset += 1;
        out[offset] = $1c6b3987498f62a9$var$deliveryToWire(delivery);
        offset += 1;
    }
    (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, tenantBytes.length);
    offset += 2;
    out.set(tenantBytes, offset);
    offset += tenantBytes.length;
    (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, channelBytes.length);
    offset += 2;
    out.set(channelBytes, offset);
    offset += channelBytes.length;
    out.set(payload, offset);
    return out;
}
function $1c6b3987498f62a9$export$9dd0db4d64b6fad(data) {
    const first = $1c6b3987498f62a9$var$readUtf8Blob(data, 0, "tenant");
    const second = $1c6b3987498f62a9$var$readUtf8Blob(data, first.nextOffset, "channel");
    return {
        tenant: first.value,
        channel: second.value,
        payload: data.slice(second.nextOffset)
    };
}
function $1c6b3987498f62a9$export$a54a4302d87cbf6f(data) {
    if (data.length === 0) throw new Error("empty frame");
    if (data[0] !== $1c6b3987498f62a9$export$d0a4d55fbab05d8f) throw new Error("expected FRAME_TAG_DELIVER tag");
    const tenantPart = $1c6b3987498f62a9$var$readUtf8Blob(data, 1, "tenant");
    const channelPart = $1c6b3987498f62a9$var$readUtf8Blob(data, tenantPart.nextOffset, "channel");
    let offset = channelPart.nextOffset;
    if (offset + 4 > data.length) throw new Error("missing payload length");
    const payloadLen = (0, $2a6bed64870680d8$export$fa598b0ff39af6cc)(data, offset);
    offset += 4;
    if (offset + payloadLen > data.length) throw new Error("truncated payload");
    const payload = data.slice(offset, offset + payloadLen);
    offset += payloadLen;
    if (offset + 2 > data.length) throw new Error("missing pattern count");
    const patternCount = (0, $2a6bed64870680d8$export$f163bb7e7f385f7)(data, offset);
    offset += 2;
    const matchedPatterns = [];
    for(let i = 0; i < patternCount; i += 1){
        const patternPart = $1c6b3987498f62a9$var$readUtf8Blob(data, offset, "pattern");
        if (patternPart.value.length === 0) throw new Error("empty pattern in list");
        matchedPatterns.push(patternPart.value);
        offset = patternPart.nextOffset;
    }
    if (offset !== data.length) throw new Error("extra bytes after pattern list");
    if (matchedPatterns.length === 0) throw new Error("pattern list is empty");
    return {
        tenant: tenantPart.value,
        channel: channelPart.value,
        payload: payload,
        matchedPatterns: matchedPatterns
    };
}
function $1c6b3987498f62a9$export$d07d359e1d558cc1(tenant, channelPattern) {
    return `SUB:${tenant}:${channelPattern}`;
}
function $1c6b3987498f62a9$export$9538aafd0dfd1720(tenant, channelPattern) {
    return `UNSUB:${tenant}:${channelPattern}`;
}
function $1c6b3987498f62a9$export$b0e41c537aa6fe06(tenant, channelPattern) {
    return `OK:SUB:${tenant}:${channelPattern}`;
}
function $1c6b3987498f62a9$export$7c34c0e98969aadd(tenant, channelPattern) {
    return `OK:UNSUB:${tenant}:${channelPattern}`;
}
function $1c6b3987498f62a9$export$22652ab787a185d4(text) {
    return text.startsWith("ERR:") ? text.slice(4) : undefined;
}
function $1c6b3987498f62a9$export$3c4e869fd5d68d6a(text) {
    if (text.startsWith("OK:SUB:")) {
        const parsed = $1c6b3987498f62a9$var$parseTenantPatternBody(text.slice(7));
        return parsed ? {
            kind: "sub",
            tenant: parsed.tenant,
            channelPattern: parsed.channelPattern
        } : undefined;
    }
    if (text.startsWith("OK:UNSUB:")) {
        const parsed = $1c6b3987498f62a9$var$parseTenantPatternBody(text.slice(9));
        return parsed ? {
            kind: "unsub",
            tenant: parsed.tenant,
            channelPattern: parsed.channelPattern
        } : undefined;
    }
    return undefined;
}
function $1c6b3987498f62a9$export$3c3308f3c5d34295(tenant, channelPattern) {
    return `${tenant}:${channelPattern}`;
}
function $1c6b3987498f62a9$export$2b1783cf5df3c65a(channelPattern) {
    if (channelPattern.trim().length === 0) throw new Error("channel pattern is invalid or empty");
}
function $1c6b3987498f62a9$var$parseTenantPatternBody(input) {
    const colon = input.indexOf(":");
    if (colon < 0) return undefined;
    const tenant = input.slice(0, colon).trim();
    const channelPattern = input.slice(colon + 1).trim();
    if (tenant.length === 0 || channelPattern.length === 0) return undefined;
    return {
        tenant: tenant,
        channelPattern: channelPattern
    };
}
function $1c6b3987498f62a9$var$readUtf8Blob(data, offset, field) {
    if (offset + 2 > data.length) throw new Error(`missing ${field} length`);
    const len = (0, $2a6bed64870680d8$export$f163bb7e7f385f7)(data, offset);
    offset += 2;
    if (len === 0) throw new Error(`empty ${field}`);
    if (offset + len > data.length) throw new Error(`truncated ${field}`);
    const value = (0, $2a6bed64870680d8$export$db70ef86b2db322a)(data.slice(offset, offset + len));
    return {
        value: value,
        nextOffset: offset + len
    };
}
function $1c6b3987498f62a9$export$331afb6eb63f25d5(input) {
    const tenant = (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(input.tenant);
    const channel = (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(input.channel);
    const patterns = input.matchedPatterns.map((pattern)=>(0, $2a6bed64870680d8$export$e1b32e613f230dc6)(pattern));
    let size = 3 + tenant.length + 2 + channel.length + 4 + input.payload.length + 2;
    for (const pattern of patterns)size += 2 + pattern.length;
    const out = new Uint8Array(size);
    let offset = 0;
    out[offset] = $1c6b3987498f62a9$export$d0a4d55fbab05d8f;
    offset += 1;
    (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, tenant.length);
    offset += 2;
    out.set(tenant, offset);
    offset += tenant.length;
    (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, channel.length);
    offset += 2;
    out.set(channel, offset);
    offset += channel.length;
    (0, $2a6bed64870680d8$export$a5bf86c9746bcbc2)(out, offset, input.payload.length);
    offset += 4;
    out.set(input.payload, offset);
    offset += input.payload.length;
    (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, patterns.length);
    offset += 2;
    for (const pattern of patterns){
        (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, pattern.length);
        offset += 2;
        out.set(pattern, offset);
        offset += pattern.length;
    }
    return out;
}


/**
 * Ring buffer of RTT samples; one in-flight PING at a time.
 */ class $3a4dd3a15118ceeb$export$e1777e1915f479dc {
    samples = [];
    pendingSentAtMs;
    maxSamples;
    constructor(maxSamples = 120){
        this.maxSamples = Math.max(8, maxSamples);
    }
    /**
     * Starts a ping. Returns false if the previous ping is still pending.
     */ beginPing(nowMs = Date.now()) {
        if (this.pendingSentAtMs !== undefined) return false;
        this.pendingSentAtMs = nowMs;
        return true;
    }
    /**
     * Finishes a ping on PONG.
     */ recordPong(nowMs = Date.now()) {
        if (this.pendingSentAtMs === undefined) return undefined;
        const rttMs = Math.max(0, nowMs - this.pendingSentAtMs);
        this.pendingSentAtMs = undefined;
        this.pushSample(nowMs, rttMs);
        return rttMs;
    }
    /**
     * Clears a stuck pending ping.
     */ expirePending(timeoutMs, nowMs = Date.now()) {
        if (this.pendingSentAtMs === undefined) return;
        if (nowMs - this.pendingSentAtMs >= timeoutMs) this.pendingSentAtMs = undefined;
    }
    pushSample(atMs, rttMs) {
        if (this.samples.length >= this.maxSamples) this.samples.shift();
        this.samples.push({
            atMs: atMs,
            rttMs: rttMs
        });
    }
    lastRttMs() {
        const last = this.samples[this.samples.length - 1];
        return last?.rttMs;
    }
    medianRttMs(windowSec = 30, nowMs = Date.now()) {
        const cutoff = nowMs - windowSec * 1000;
        const values = this.samples.filter((s)=>s.atMs >= cutoff).map((s)=>s.rttMs);
        if (values.length === 0) return undefined;
        values.sort((a, b)=>a - b);
        const mid = Math.floor(values.length / 2);
        if (values.length % 2 === 1) return values[mid];
        return Math.floor((values[mid - 1] + values[mid]) / 2);
    }
    snapshot(windowSec = 30) {
        return {
            lastRttMs: this.lastRttMs(),
            medianRttMs: this.medianRttMs(windowSec)
        };
    }
}


const $854d7c88cb215c97$export$f8af265e214bdb59 = {
    queueCapacity: 256
};
const $854d7c88cb215c97$export$c0d2082e4d19b297 = {
    delivery: "broadcast"
};


const $ecb8a282c75664fb$var$WS_OPEN = 1;
const $ecb8a282c75664fb$var$OVERLAP_GRACE_MS = 5000;
const $ecb8a282c75664fb$var$OVERLAP_DEDUP_TTL_MS = $ecb8a282c75664fb$var$OVERLAP_GRACE_MS + 1000;
const $ecb8a282c75664fb$var$DEDUP_SEED_LO = 0x9e3779b1;
const $ecb8a282c75664fb$var$DEDUP_SEED_HI = 0x85ebca77;
class $ecb8a282c75664fb$export$de21836fc42c6f9c {
    kind = "websocket";
    endpoint = "";
    accessToken = "";
    ws;
    connectionId = 0;
    filters = [];
    filterTimerMode = (0, $3b990687ea5a342a$export$72747cb09ed23ab2);
    metaMode = "none";
    onEvent;
    factory;
    subscriptions = new Map();
    dedup = new Map();
    filterTimer;
    filterTimerRunning = false;
    overlapDedupEnabled = false;
    overlapTimer;
    closedByUser = false;
    reconnecting = false;
    linkQualityTracker = new (0, $3a4dd3a15118ceeb$export$e1777e1915f479dc)();
    pingTimer;
    pingIntervalSec;
    /**
     * Opens the WebSocket connection.
     *
     * The builder usually calls this method.
     */ async connect(endpoint, params) {
        this.endpoint = endpoint;
        this.accessToken = params.accessToken;
        this.filters = params.filters ? [
            ...params.filters
        ] : [];
        this.filterTimerMode = params.filterTimerMode ?? (0, $3b990687ea5a342a$export$72747cb09ed23ab2);
        this.metaMode = params.metaMode ?? "none";
        this.onEvent = params.onWebSocketEvent;
        this.factory = params.webSocketFactory;
        this.pingIntervalSec = $ecb8a282c75664fb$var$normalizePingInterval(params.pingIntervalSec);
        this.closedByUser = false;
        await this.openSocket(false);
        this.startFilterTimer();
        this.startPingTimer();
    }
    /**
     * Snapshot of WebSocket link quality (PING/PONG).
     */ linkQuality(windowSec = 30) {
        return this.linkQualityTracker.snapshot(windowSec);
    }
    /**
     * Publishes one payload.
     *
     * Success means that the transport accepted the message locally and sent it to the socket.
     */ async publish(tenant, channel, payload, options = {}) {
        const socket = this.requireOpenSocket();
        const delivery = options.delivery ?? (0, $854d7c88cb215c97$export$c0d2082e4d19b297).delivery;
        const ctx = {
            tenant: tenant,
            channel: channel
        };
        const meta = new (0, $9ebeb5fdd029b452$export$710aedf3f94c06a3)();
        const payloads = await (0, $3b990687ea5a342a$export$e3ddf273e40fce27)(this.filters, ctx, payload, meta);
        for (const item of payloads)socket.send((0, $1c6b3987498f62a9$export$87699b10a0dfb985)(tenant, channel, item, delivery));
    }
    /**
     * Subscribes to one channel pattern.
     *
     * @example
     * ```ts
     * const queue = await client.subscribe("tenant_1", "public.#");
     * const message = await queue.recv();
     * ```
     */ async subscribe(tenant, channelPattern, options = {}) {
        (0, $1c6b3987498f62a9$export$2b1783cf5df3c65a)(channelPattern);
        const key = (0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(tenant, channelPattern);
        if (this.subscriptions.has(key)) throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("duplicate_subscription", "subscription with this tenant and pattern already exists");
        const queue = new (0, $32761a3f8d3f5dc1$export$c24e73273208a9bb)(options.queueCapacity ?? (0, $854d7c88cb215c97$export$f8af265e214bdb59).queueCapacity);
        this.subscriptions.set(key, {
            tenant: tenant,
            channelPattern: channelPattern,
            queue: queue
        });
        this.requireOpenSocket().send((0, $1c6b3987498f62a9$export$d07d359e1d558cc1)(tenant, channelPattern));
        return queue;
    }
    /**
     * Removes one subscription.
     */ async unsubscribe(tenant, channelPattern) {
        const key = (0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(tenant, channelPattern);
        const sub = this.subscriptions.get(key);
        if (sub) {
            sub.queue.close();
            this.subscriptions.delete(key);
        }
        this.requireOpenSocket().send((0, $1c6b3987498f62a9$export$9538aafd0dfd1720)(tenant, channelPattern));
    }
    /**
     * Closes the transport and local subscription queues.
     */ close() {
        this.closedByUser = true;
        this.stopFilterTimer();
        this.disableOverlapDedup();
        for (const sub of this.subscriptions.values())sub.queue.close();
        this.subscriptions.clear();
        this.ws?.close();
        this.ws = undefined;
    }
    requireOpenSocket() {
        const socket = this.ws;
        if (!socket || socket.readyState !== $ecb8a282c75664fb$var$WS_OPEN) throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("not_connected", "transport is not connected");
        return socket;
    }
    async openSocket(isReconnect) {
        const socket = await $ecb8a282c75664fb$var$createSocket(this.endpoint, this.accessToken, this.factory);
        this.connectionId += 1;
        const currentId = this.connectionId;
        this.ws = socket;
        socket.binaryType = "arraybuffer";
        this.attachSocket(socket, currentId);
        await $ecb8a282c75664fb$var$waitForOpen(socket);
        if (isReconnect) {
            for (const sub of this.subscriptions.values())socket.send((0, $1c6b3987498f62a9$export$d07d359e1d558cc1)(sub.tenant, sub.channelPattern));
            this.enableOverlapDedup();
            this.emit({
                type: "reconnectReady"
            });
        }
    }
    attachSocket(socket, connectionId) {
        $ecb8a282c75664fb$var$addSocketListener(socket, "message", (event)=>{
            this.handleMessage(connectionId, event);
        });
        $ecb8a282c75664fb$var$addSocketListener(socket, "close", ()=>{
            if (!this.closedByUser && this.ws === socket) this.reconnectLoop();
        });
        $ecb8a282c75664fb$var$addSocketListener(socket, "error", (event)=>{
            this.emit({
                type: "error",
                error: {
                    type: "read",
                    connectionId: connectionId,
                    message: $ecb8a282c75664fb$var$eventToMessage(event)
                }
            });
        });
    }
    async reconnectLoop() {
        if (this.reconnecting || this.closedByUser) return;
        this.reconnecting = true;
        this.emit({
            type: "reconnectStarted"
        });
        let delayMs = 100;
        while(!this.closedByUser)try {
            await $ecb8a282c75664fb$var$sleep(delayMs);
            await this.openSocket(true);
            this.reconnecting = false;
            return;
        } catch (error) {
            this.emit({
                type: "error",
                error: {
                    type: "reconnect",
                    connectionId: this.connectionId,
                    message: $ecb8a282c75664fb$var$errorToMessage(error)
                }
            });
            delayMs = Math.min(delayMs * 2, 2000);
        }
        this.reconnecting = false;
    }
    async handleMessage(connectionId, event) {
        const data = $ecb8a282c75664fb$var$messageData(event);
        if (typeof data === "string") {
            this.handleText(data);
            return;
        }
        try {
            await this.handleBinary(connectionId, (0, $2a6bed64870680d8$export$230b06546aa82954)(data));
        } catch (error) {
            this.emit({
                type: "error",
                error: {
                    type: "decode",
                    message: $ecb8a282c75664fb$var$errorToMessage(error)
                }
            });
        }
    }
    handleText(text) {
        if ((0, $1c6b3987498f62a9$export$19776548d9276c48)(text)) {
            const rttMs = this.linkQualityTracker.recordPong();
            if (rttMs !== undefined) this.emit({
                type: "rttMeasured",
                rttMs: rttMs
            });
            return;
        }
        const serverError = (0, $1c6b3987498f62a9$export$22652ab787a185d4)(text);
        if (serverError !== undefined) {
            this.emit({
                type: "error",
                error: {
                    type: "server",
                    message: serverError
                }
            });
            return;
        }
        const ack = (0, $1c6b3987498f62a9$export$3c4e869fd5d68d6a)(text);
        if (!ack) return;
        if (ack.kind === "sub") this.emit({
            type: "subscriptionConfirmed",
            tenant: ack.tenant,
            channelPattern: ack.channelPattern
        });
        else this.emit({
            type: "unsubscriptionConfirmed",
            tenant: ack.tenant,
            channelPattern: ack.channelPattern
        });
    }
    async handleBinary(connectionId, data) {
        const deliver = (0, $1c6b3987498f62a9$export$a54a4302d87cbf6f)(data);
        if (deliver.matchedPatterns.length === 0) {
            this.emit({
                type: "error",
                error: {
                    type: "emptyDelivery",
                    tenant: deliver.tenant,
                    channel: deliver.channel
                }
            });
            return;
        }
        const notices = [];
        const ctx = {
            tenant: deliver.tenant,
            channel: deliver.channel,
            emitFilterNotice: (notice)=>{
                notices.push(notice);
            }
        };
        const meta = new (0, $9ebeb5fdd029b452$export$710aedf3f94c06a3)();
        let result;
        try {
            result = await (0, $3b990687ea5a342a$export$438723802648587b)(this.filters, ctx, deliver.payload, meta);
        } catch (error) {
            this.emit({
                type: "error",
                error: {
                    type: "inboundFilter",
                    message: $ecb8a282c75664fb$var$errorToMessage(error)
                }
            });
            return;
        }
        for (const notice of notices)this.emit({
            type: "filterNotice",
            level: notice.level,
            message: notice.message
        });
        for (const message of result.messages)await this.publish(message.tenant, message.channel, message.payload);
        if (result.payloads.length === 0) return;
        const dedupPayload = result.payloads.length === 1 ? result.payloads[0] : deliver.payload;
        if (this.isDuplicate(deliver.tenant, deliver.channel, dedupPayload)) {
            this.emit({
                type: "duplicateDropped"
            });
            return;
        }
        const missing = [];
        for (const pattern of deliver.matchedPatterns){
            const key = (0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(deliver.tenant, pattern);
            const sub = this.subscriptions.get(key);
            if (!sub) {
                missing.push(pattern);
                continue;
            }
            for (const payload of result.payloads){
                const sdkMessage = new (0, $9ebeb5fdd029b452$export$ea11f29158edde53)({
                    tenant: deliver.tenant,
                    channel: deliver.channel,
                    matchedPattern: pattern,
                    receivedAt: new Date(),
                    payload: payload,
                    meta: this.metaMode === "stages" ? meta.finish() : (0, $9ebeb5fdd029b452$export$90a59c3c1368656d).none()
                });
                if (!sub.queue.push(sdkMessage)) this.emit({
                    type: "error",
                    error: {
                        type: "subscriptionQueueFull",
                        tenant: deliver.tenant,
                        channelPattern: pattern
                    }
                });
            }
        }
        if (missing.length > 0) this.emit({
            type: "error",
            error: {
                type: "missingSubscription",
                tenant: deliver.tenant,
                channelPatterns: missing
            }
        });
        this.filterTimerMode;
    }
    isDuplicate(tenant, channel, payload) {
        if (!this.overlapDedupEnabled) return false;
        const now = Date.now();
        for (const [key, expiresAt] of this.dedup)if (expiresAt <= now) this.dedup.delete(key);
        const key = $ecb8a282c75664fb$var$overlapDedupKey(tenant, channel, payload);
        if (this.dedup.has(key)) return true;
        this.dedup.set(key, now + $ecb8a282c75664fb$var$OVERLAP_DEDUP_TTL_MS);
        return false;
    }
    startFilterTimer() {
        this.stopFilterTimer();
        const intervalMs = (0, $3b990687ea5a342a$export$a518a1ff0c180fcc)(this.filterTimerMode).intervalMs;
        this.filterTimer = setInterval(()=>{
            this.tickFilterTimer();
        }, intervalMs);
        this.filterTimer.unref?.();
    }
    stopFilterTimer() {
        if (this.filterTimer) {
            clearInterval(this.filterTimer);
            this.filterTimer = undefined;
        }
        this.filterTimerRunning = false;
    }
    async tickFilterTimer() {
        if (this.filterTimerRunning || this.closedByUser) return;
        this.filterTimerRunning = true;
        try {
            const ctx = (0, $3b990687ea5a342a$export$a518a1ff0c180fcc)(this.filterTimerMode);
            for(let index = 0; index < this.filters.length; index += 1){
                const registration = this.filters[index];
                const onTimer = registration?.filter.onTimer;
                if (!registration || !onTimer) continue;
                let messages;
                try {
                    messages = await onTimer.call(registration.filter, ctx);
                } catch (error) {
                    this.emit({
                        type: "error",
                        error: {
                            type: "transport",
                            operation: "filter_timer",
                            message: $ecb8a282c75664fb$var$errorToMessage(error)
                        }
                    });
                    continue;
                }
                for (const message of messages)await this.publishTimerMessage(index, message);
            }
        } finally{
            this.filterTimerRunning = false;
        }
    }
    async publishTimerMessage(endIndex, message) {
        const socket = this.ws;
        if (!socket || socket.readyState !== $ecb8a282c75664fb$var$WS_OPEN) return;
        const meta = new (0, $9ebeb5fdd029b452$export$710aedf3f94c06a3)();
        const ctx = {
            tenant: message.tenant,
            channel: message.channel
        };
        try {
            const payloads = await (0, $3b990687ea5a342a$export$cf32509dd19cedfd)(this.filters, endIndex, ctx, message.payload, meta);
            for (const payload of payloads)socket.send((0, $1c6b3987498f62a9$export$87699b10a0dfb985)(message.tenant, message.channel, payload, "broadcast"));
        } catch (error) {
            this.emit({
                type: "error",
                error: {
                    type: "transport",
                    operation: "publish_until_filter_index",
                    message: $ecb8a282c75664fb$var$errorToMessage(error)
                }
            });
        }
    }
    enableOverlapDedup() {
        this.disableOverlapDedup();
        this.overlapDedupEnabled = true;
        this.overlapTimer = setTimeout(()=>{
            this.disableOverlapDedup();
        }, $ecb8a282c75664fb$var$OVERLAP_GRACE_MS);
    }
    disableOverlapDedup() {
        this.overlapDedupEnabled = false;
        this.dedup.clear();
        if (this.overlapTimer) {
            clearTimeout(this.overlapTimer);
            this.overlapTimer = undefined;
        }
    }
    emit(event) {
        this.onEvent?.(event);
    }
    startPingTimer() {
        this.stopPingTimer();
        if (!this.pingIntervalSec) return;
        const intervalMs = this.pingIntervalSec * 1000;
        this.pingTimer = setInterval(()=>{
            this.maybeSendPing();
        }, intervalMs);
    }
    stopPingTimer() {
        if (this.pingTimer) {
            clearInterval(this.pingTimer);
            this.pingTimer = undefined;
        }
    }
    async maybeSendPing() {
        const socket = this.ws;
        if (!socket || socket.readyState !== $ecb8a282c75664fb$var$WS_OPEN) return;
        if (!this.linkQualityTracker.beginPing()) {
            this.linkQualityTracker.expirePending(10000);
            return;
        }
        try {
            socket.send((0, $1c6b3987498f62a9$export$6140aaf55daeb3d9));
        } catch (error) {
            this.linkQualityTracker.expirePending(0);
            this.emit({
                type: "error",
                error: {
                    type: "transport",
                    operation: "ping",
                    message: $ecb8a282c75664fb$var$errorToMessage(error)
                }
            });
        }
    }
}
function $ecb8a282c75664fb$var$normalizePingInterval(value) {
    if (value === 1 || value === 3 || value === 5) return value;
    return undefined;
}
function $ecb8a282c75664fb$var$overlapDedupKey(tenant, channel, payload) {
    const parts = [
        (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(tenant),
        (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(channel),
        payload
    ];
    const lo = (0, $2a6bed64870680d8$export$8c79fc1ce37f06de)(parts, $ecb8a282c75664fb$var$DEDUP_SEED_LO);
    const hi = (0, $2a6bed64870680d8$export$8c79fc1ce37f06de)(parts, $ecb8a282c75664fb$var$DEDUP_SEED_HI);
    return BigInt(hi) << 32n | BigInt(lo);
}
async function $ecb8a282c75664fb$var$createSocket(endpoint, accessToken, factory) {
    const protocols = [
        "llps.v1",
        `at.${accessToken}`
    ];
    if (factory) return factory(endpoint, protocols, accessToken);
    const BrowserWebSocket = globalThis.WebSocket;
    if (BrowserWebSocket) return new BrowserWebSocket(endpoint, protocols);
    const importer = new Function("name", "return import(name)");
    const mod = await importer("ws");
    return new mod.WebSocket(endpoint, protocols, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
function $ecb8a282c75664fb$var$addSocketListener(socket, type, listener) {
    if (socket.addEventListener) {
        socket.addEventListener(type, listener);
        return;
    }
    socket.on?.(type, listener);
}
function $ecb8a282c75664fb$var$waitForOpen(socket) {
    if (socket.readyState === $ecb8a282c75664fb$var$WS_OPEN) return Promise.resolve();
    return new Promise((resolve, reject)=>{
        const onOpen = ()=>{
            cleanup();
            resolve();
        };
        const onError = (event)=>{
            cleanup();
            reject(new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("connect_failed", $ecb8a282c75664fb$var$eventToMessage(event)));
        };
        const cleanup = ()=>{
            socket.removeEventListener?.("open", onOpen);
            socket.removeEventListener?.("error", onError);
            socket.off?.("open", onOpen);
            socket.off?.("error", onError);
        };
        $ecb8a282c75664fb$var$addSocketListener(socket, "open", onOpen);
        $ecb8a282c75664fb$var$addSocketListener(socket, "error", onError);
    });
}
function $ecb8a282c75664fb$var$messageData(event) {
    if (typeof event === "object" && event !== null && "data" in event) {
        const data = event.data;
        if (typeof data === "string" || data instanceof ArrayBuffer || ArrayBuffer.isView(data)) return data;
    }
    if (typeof event === "string" || event instanceof ArrayBuffer || ArrayBuffer.isView(event)) return event;
    if (Array.isArray(event) && event.length > 0) return (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(event[0]);
    throw new Error("unsupported WebSocket message data");
}
function $ecb8a282c75664fb$var$eventToMessage(event) {
    if (event instanceof Error) return event.message;
    if (typeof event === "string") return event;
    return "WebSocket event";
}
function $ecb8a282c75664fb$var$errorToMessage(error) {
    return error instanceof Error ? error.message : String(error);
}
function $ecb8a282c75664fb$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}



class $8585ef59a212420f$export$2a3746908af85482 {
    kind = "webtransport";
    async connect(_endpoint, _params) {
        throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("unsupported", "WebTransport is not implemented in contract v0.1");
    }
    async publish(_tenant, _channel, _payload, _options = {}) {
        throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("unsupported", "WebTransport is not implemented in contract v0.1");
    }
    async subscribe(_tenant, _channelPattern, _options = {}) {
        throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("unsupported", "WebTransport is not implemented in contract v0.1");
    }
    async unsubscribe(_tenant, _channelPattern) {
        throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("unsupported", "WebTransport is not implemented in contract v0.1");
    }
    close() {
    // Nothing is open in the placeholder.
    }
}




function $53649ab7bd2d4662$export$e9ddf1da8d18d6f(apiBase, path) {
    const base = apiBase.endsWith("/") ? apiBase : `${apiBase}/`;
    return new URL(path.replace(/^\/+/, ""), base).toString();
}
async function $53649ab7bd2d4662$export$b0613bdcd91c3d8(url, init = {}, config = {}, defaultTimeoutMs = 5000) {
    const fetchImpl = config.fetchImpl ?? globalThis.fetch;
    if (!fetchImpl) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("fetch_missing", "fetch is not available in this runtime");
    const controller = new AbortController();
    const externalSignal = init.signal;
    const abortFromCaller = ()=>controller.abort();
    if (externalSignal?.aborted) controller.abort();
    else externalSignal?.addEventListener("abort", abortFromCaller, {
        once: true
    });
    const timeout = setTimeout(()=>controller.abort(), config.timeoutMs ?? defaultTimeoutMs);
    try {
        return await fetchImpl(url, {
            ...init,
            signal: controller.signal
        });
    } catch (error) {
        throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("network_error", error instanceof Error ? error.message : String(error));
    } finally{
        clearTimeout(timeout);
        externalSignal?.removeEventListener("abort", abortFromCaller);
    }
}
async function $53649ab7bd2d4662$export$e03e3c24cd30661(response) {
    const body = await response.text();
    if (!response.ok) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_status", `HTTP ${response.status}: ${body}`);
    return body;
}


const $7f8afe2618a9f493$var$DEFAULT_MAX_CANDIDATES = 4;
const $7f8afe2618a9f493$var$DEFAULT_PING_TIMEOUT_MS = 1000;
const $7f8afe2618a9f493$var$DEFAULT_SELECTION_WINDOW_MS = 200;
function $7f8afe2618a9f493$export$c17ae9c1a44a5870(overlay) {
    return `https://${overlay}.fastpubsub.workers.dev/`;
}
async function $7f8afe2618a9f493$export$ccfc10b8bad1155a(apiBase, config = {}) {
    await $7f8afe2618a9f493$var$pingWithOptions(apiBase, config, config.timeoutMs ?? 3000);
}
async function $7f8afe2618a9f493$export$79b79b66fde39634(apiBases, config = {}) {
    const settled = await Promise.allSettled(apiBases.map(async (apiBase)=>{
        const durationMs = await $7f8afe2618a9f493$var$measureSecondPing(apiBase, config, config.timeoutMs ?? 3000);
        return {
            apiBase: apiBase,
            durationMs: durationMs
        };
    }));
    const timings = settled.filter((result)=>result.status === "fulfilled").map((result)=>result.value).sort((a, b)=>a.durationMs - b.durationMs);
    if (timings.length === 0) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_reachable_edges", "no edge ping succeeded");
    return {
        timings: timings.slice(0, 3)
    };
}
async function $7f8afe2618a9f493$export$8828a016a29f8730(apiBases, config = {}) {
    if (apiBases.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", "no base URLs for ping");
    const result = await $7f8afe2618a9f493$export$79b79b66fde39634(apiBases, config);
    const fastest = result.timings[0];
    if (!fastest) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", "no ping completed");
    return fastest;
}
async function $7f8afe2618a9f493$export$7c7678d71b4821d0(overlay, bootstrapUrl = $7f8afe2618a9f493$export$c17ae9c1a44a5870(overlay), config = {}) {
    const response = await (0, $53649ab7bd2d4662$export$b0613bdcd91c3d8)($7f8afe2618a9f493$var$cacheBustedUrl(bootstrapUrl, "_fps_bootstrap"), $7f8afe2618a9f493$var$getInit(), config, 5000);
    const body = await (0, $53649ab7bd2d4662$export$e03e3c24cd30661)(response);
    const parsed = JSON.parse(body);
    const edges = parsed.edges ?? [];
    const candidates = edges.map((edge)=>{
        const host = typeof edge === "string" ? edge : edge.host;
        if (!host) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", body);
        return $7f8afe2618a9f493$var$edgeCandidateFromHost(host);
    });
    if (candidates.length === 0) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_candidates", "no edge candidates");
    return candidates;
}
async function $7f8afe2618a9f493$export$515d30759ec3d446(candidates, config = {}, options = {}) {
    if (candidates.length === 0) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_candidates", "no edge candidates");
    const probeCandidates = candidates.slice(0, $7f8afe2618a9f493$var$normalizeMaxCandidates(options.maxCandidates));
    const timings = await $7f8afe2618a9f493$var$probeCandidatesWithinBudget(probeCandidates, config, options);
    const fastest = timings[0];
    if (!fastest) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_reachable_edges", "no edge ping succeeded");
    const candidate = probeCandidates.find((item)=>item.apiBase === fastest.apiBase);
    if (!candidate) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("candidate_not_found", "candidate not found after ping");
    return {
        candidate: candidate,
        pingMs: fastest.durationMs
    };
}
async function $7f8afe2618a9f493$var$probeCandidatesWithinBudget(candidates, config, options) {
    const pingTimeoutMs = $7f8afe2618a9f493$var$normalizePositiveMs(options.pingTimeoutMs, config.timeoutMs ?? $7f8afe2618a9f493$var$DEFAULT_PING_TIMEOUT_MS);
    const selectionWindowMs = $7f8afe2618a9f493$var$normalizeNonNegativeMs(options.selectionWindowMs, $7f8afe2618a9f493$var$DEFAULT_SELECTION_WINDOW_MS);
    const controllers = candidates.map(()=>new AbortController());
    const timings = [];
    return new Promise((resolve, reject)=>{
        let completed = 0;
        let finished = false;
        let selectionTimer;
        const finish = ()=>{
            if (finished) return;
            finished = true;
            if (selectionTimer !== undefined) clearTimeout(selectionTimer);
            for (const controller of controllers)controller.abort();
            timings.sort((a, b)=>a.durationMs - b.durationMs);
            if (timings.length > 0) resolve(timings);
            else reject(new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_reachable_edges", "no edge ping succeeded"));
        };
        candidates.forEach((candidate, index)=>{
            const controller = controllers[index];
            if (!controller) return;
            $7f8afe2618a9f493$var$measureSecondPing(candidate.apiBase, config, pingTimeoutMs, controller.signal).then((durationMs)=>{
                timings.push({
                    apiBase: candidate.apiBase,
                    durationMs: durationMs
                });
                if (timings.length === 1) {
                    if (selectionWindowMs === 0) finish();
                    else selectionTimer = setTimeout(finish, selectionWindowMs);
                }
            }).catch(()=>{
            // One unhealthy edge is expected; only fail if every probe failed.
            }).finally(()=>{
                completed += 1;
                if (completed === candidates.length) finish();
            });
        });
    });
}
async function $7f8afe2618a9f493$var$measureSecondPing(apiBase, config, timeoutMs, signal) {
    await $7f8afe2618a9f493$var$pingWithOptions(apiBase, config, timeoutMs, signal);
    const started = $7f8afe2618a9f493$var$nowMs();
    await $7f8afe2618a9f493$var$pingWithOptions(apiBase, config, timeoutMs, signal);
    return $7f8afe2618a9f493$var$nowMs() - started;
}
async function $7f8afe2618a9f493$var$pingWithOptions(apiBase, config, timeoutMs, signal) {
    const response = await (0, $53649ab7bd2d4662$export$b0613bdcd91c3d8)($7f8afe2618a9f493$var$pingUrl(apiBase), $7f8afe2618a9f493$var$getInit(signal), {
        ...config,
        timeoutMs: timeoutMs
    }, timeoutMs);
    const body = await (0, $53649ab7bd2d4662$export$e03e3c24cd30661)(response);
    if (body.trim() !== "pong") throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", body);
}
function $7f8afe2618a9f493$var$pingUrl(apiBase) {
    return $7f8afe2618a9f493$var$cacheBustedUrl((0, $53649ab7bd2d4662$export$e9ddf1da8d18d6f)(apiBase, "ping"), "_fps_ping");
}
function $7f8afe2618a9f493$var$cacheBustedUrl(input, paramName) {
    const url = new URL(input);
    url.searchParams.set(paramName, `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    return url.toString();
}
function $7f8afe2618a9f493$var$getInit(signal) {
    return {
        method: "GET",
        ...signal ? {
            signal: signal
        } : {}
    };
}
function $7f8afe2618a9f493$var$edgeCandidateFromHost(rawHost) {
    const host = rawHost.trim().replace(/\/+$/, "");
    const idPart = host.split(".")[0] || host;
    return {
        id: `edge-${idPart}`,
        apiBase: `https://${host}`,
        wsEndpoint: `wss://${host}/ws`,
        wtEndpoint: `https://${host}/wt`,
        region: idPart.toUpperCase()
    };
}
function $7f8afe2618a9f493$var$normalizeMaxCandidates(value) {
    if (value === undefined) return $7f8afe2618a9f493$var$DEFAULT_MAX_CANDIDATES;
    return Math.max(1, Math.floor(value));
}
function $7f8afe2618a9f493$var$normalizePositiveMs(value, fallback) {
    return value === undefined ? fallback : Math.max(1, Math.floor(value));
}
function $7f8afe2618a9f493$var$normalizeNonNegativeMs(value, fallback) {
    return value === undefined ? fallback : Math.max(0, Math.floor(value));
}
function $7f8afe2618a9f493$var$nowMs() {
    return typeof performance !== "undefined" ? performance.now() : Date.now();
}
const $7f8afe2618a9f493$export$f54cbbc2cff05aed = $7f8afe2618a9f493$export$c17ae9c1a44a5870;
const $7f8afe2618a9f493$export$e6052fdb8776f969 = $7f8afe2618a9f493$export$79b79b66fde39634;
const $7f8afe2618a9f493$export$ba72dfbea5d94a82 = $7f8afe2618a9f493$export$8828a016a29f8730;
const $7f8afe2618a9f493$export$76fb33decda5ca8f = $7f8afe2618a9f493$export$7c7678d71b4821d0;
const $7f8afe2618a9f493$export$1bfd0a12bc35c623 = $7f8afe2618a9f493$export$515d30759ec3d446;



class $1adf30b58a83e819$export$6516fa0e9545d085 {
    tenant;
    channelPattern;
    queueCapacity;
    constructor(tenant, channelPattern, options = {}){
        this.tenant = tenant;
        this.channelPattern = channelPattern;
        this.queueCapacity = options.queueCapacity ?? 256;
    }
    /**
     * Returns the route key used by the transport.
     */ routeKey() {
        return (0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(this.tenant, this.channelPattern);
    }
}
class $1adf30b58a83e819$export$4f48298e83c3d5fd {
    items;
    constructor(){
        this.items = new Map();
    }
    /**
     * Returns number of records.
     */ len() {
        return this.items.size;
    }
    /**
     * Returns true when the registry is empty.
     */ isEmpty() {
        return this.items.size === 0;
    }
    /**
     * Returns ordered subscription list.
     */ subscriptions() {
        return Array.from(this.items.values()).sort((a, b)=>{
            const left = `${a.tenant}:${a.channelPattern}`;
            const right = `${b.tenant}:${b.channelPattern}`;
            return left.localeCompare(right);
        });
    }
    /**
     * Checks if a subscription exists.
     */ contains(tenant, channelPattern) {
        return this.items.has((0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(tenant, channelPattern));
    }
    /**
     * Adds or replaces a subscription.
     */ insert(spec) {
        this.items.set(spec.routeKey(), spec);
    }
    /**
     * Removes a subscription.
     */ remove(tenant, channelPattern) {
        return this.items.delete((0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(tenant, channelPattern));
    }
}


function $7b4d8a91271f1bc3$export$a66334a85aba09dd(overlay) {
    return `wss://${overlay}.fastpubsub.invalid/ws`;
}
class $7b4d8a91271f1bc3$export$84278c718a874505 {
    overlay;
    accessToken;
    transportFactory;
    endpointValue;
    apiBaseValue;
    filtersValue = [];
    filterTimerModeValue = (0, $3b990687ea5a342a$export$72747cb09ed23ab2);
    metaModeValue = "none";
    onWebSocketEventValue;
    httpConfigValue;
    webSocketFactoryValue;
    endpointResolverValue;
    pingIntervalSecValue;
    constructor(overlay, accessToken, transportFactory){
        this.overlay = overlay;
        this.accessToken = accessToken;
        this.transportFactory = transportFactory;
    }
    /**
     * Sets an explicit transport endpoint.
     */ endpoint(url) {
        this.endpointValue = url;
        return this;
    }
    /**
     * Defers endpoint resolution until `build()`.
     *
     * @internal Used by `FastPubSubSession`; applications normally should not
     * need to set an edge endpoint themselves.
     */ resolveEndpoint(resolver) {
        this.endpointResolverValue = resolver;
        return this;
    }
    /**
     * Sets REST API base URL.
     */ apiBase(url) {
        this.apiBaseValue = url;
        return this;
    }
    /**
     * Stores HTTP settings for REST helpers.
     */ httpConfig(config) {
        this.httpConfigValue = config;
        return this;
    }
    /**
     * Adds a filter for an exact tenant and static channel prefix.
     *
     * @example
     * ```ts
     * builder.addFilter("tenant_1", "private.", new EncryptionFilter(keys));
     * ```
     */ addFilter(tenant, prefix, filter) {
        this.filtersValue.push(new (0, $3b990687ea5a342a$export$90251372f1939aee)(tenant, prefix, filter));
        return this;
    }
    /**
     * Sets the filter timer rate.
     *
     * The timer is used by filters that send messages later.
     */ filterTimerMode(mode) {
        this.filterTimerModeValue = mode;
        return this;
    }
    /**
     * Sets metadata mode.
     */ metaMode(mode) {
        this.metaModeValue = mode;
        return this;
    }
    /**
     * Receives WebSocket transport events.
     */ onWebSocketEvent(handler) {
        this.onWebSocketEventValue = handler;
        return this;
    }
    /**
     * WS PING interval in seconds: 1, 3, or 5.
     */ pingIntervalSec(seconds) {
        this.pingIntervalSecValue = seconds;
        return this;
    }
    /**
     * Overrides WebSocket creation.
     *
     * This is useful for tests or custom integration.
     */ webSocketFactory(factory) {
        this.webSocketFactoryValue = factory;
        return this;
    }
    /**
     * Connects the transport and returns a ready client.
     */ async build() {
        let endpoint = this.endpointValue;
        let apiBase = this.apiBaseValue;
        if (!endpoint && this.endpointResolverValue) {
            const resolved = await this.endpointResolverValue();
            endpoint = resolved.endpoint;
            apiBase ??= resolved.apiBase;
        }
        endpoint ??= $7b4d8a91271f1bc3$export$a66334a85aba09dd(this.overlay);
        apiBase ??= `https://${this.overlay}.fastpubsub.com`;
        const transport = this.transportFactory();
        const params = {
            filters: this.filtersValue,
            filterTimerMode: this.filterTimerModeValue,
            metaMode: this.metaModeValue,
            accessToken: this.accessToken,
            ...this.onWebSocketEventValue ? {
                onWebSocketEvent: this.onWebSocketEventValue
            } : {},
            ...this.webSocketFactoryValue ? {
                webSocketFactory: this.webSocketFactoryValue
            } : {},
            ...this.pingIntervalSecValue ? {
                pingIntervalSec: this.pingIntervalSecValue
            } : {}
        };
        try {
            await transport.connect(endpoint, params);
        } catch (error) {
            throw new (0, $b09ac485321cc4ed$export$f91b299ee183332c)(error instanceof Error ? error.message : String(error));
        }
        return new $7b4d8a91271f1bc3$export$8c3e4b3a9b8f5384(transport, this.overlay, apiBase, this.httpConfigValue);
    }
}
class $7b4d8a91271f1bc3$export$8c3e4b3a9b8f5384 {
    transport;
    overlay;
    apiBaseValue;
    httpConfigValue;
    registry;
    constructor(transport, overlay, apiBaseValue, httpConfigValue = {}){
        this.transport = transport;
        this.overlay = overlay;
        this.apiBaseValue = apiBaseValue;
        this.httpConfigValue = httpConfigValue;
        this.registry = new (0, $1adf30b58a83e819$export$4f48298e83c3d5fd)();
    }
    /**
     * Returns overlay network name.
     */ overlayNetworkName() {
        return this.overlay;
    }
    /**
     * Returns REST API base URL.
     */ apiBase() {
        return this.apiBaseValue;
    }
    /**
     * Calls GET /ping on the selected edge.
     */ async ping() {
        await (0, $7f8afe2618a9f493$export$ccfc10b8bad1155a)(this.apiBaseValue, this.httpConfigValue);
    }
    /**
     * WebSocket link quality from PING/PONG (WebSocket transport only).
     */ linkQuality(windowSec = 30) {
        if (this.transport.kind !== "websocket") return {
            lastRttMs: undefined,
            medianRttMs: undefined
        };
        return this.transport.linkQuality(windowSec);
    }
    /**
     * Publishes a payload with default options.
     *
     * @example
     * ```ts
     * await client.publish("tenant_1", "public.chat", "hello");
     * ```
     */ async publish(tenant, channel, payload) {
        await this.publishWithOptions(tenant, channel, payload, {});
    }
    /**
     * Publishes a payload with explicit options.
     */ async publishWithOptions(tenant, channel, payload, options) {
        try {
            await this.transport.publish(tenant, channel, (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(payload), options);
        } catch (error) {
            throw new (0, $b09ac485321cc4ed$export$107365fdc90b0143)(error instanceof Error ? error.message : String(error));
        }
    }
    /**
     * Subscribes to one channel pattern.
     *
     * @example
     * ```ts
     * const queue = await client.subscribe("tenant_1", "public.#");
     * const message = await queue.recv();
     * ```
     */ async subscribe(tenant, channelPattern, options = {}) {
        const queue = await this.transport.subscribe(tenant, channelPattern, options);
        this.registry.insert(new (0, $1adf30b58a83e819$export$6516fa0e9545d085)(tenant, channelPattern, options));
        return queue;
    }
    /**
     * Removes one subscription.
     */ async unsubscribe(tenant, channelPattern) {
        await this.transport.unsubscribe(tenant, channelPattern);
        this.registry.remove(tenant, channelPattern);
    }
    /**
     * Returns active subscriptions.
     */ subscriptions() {
        return this.registry.subscriptions();
    }
    /**
     * Returns the subscription registry.
     */ subscriptionRegistry() {
        return this.registry;
    }
    /**
     * Returns a cloneable shared handle.
     */ intoShared() {
        return new $7b4d8a91271f1bc3$export$2c330fa98aeeb8ed(this);
    }
    /**
     * Closes the transport.
     */ close() {
        this.transport.close();
    }
}
class $7b4d8a91271f1bc3$export$2c330fa98aeeb8ed {
    client;
    constructor(client){
        this.client = client;
    }
    /**
     * Publishes a payload.
     */ async publish(tenant, channel, payload) {
        await this.client.publish(tenant, channel, payload);
    }
    /**
     * Publishes a payload with options.
     */ async publishWithOptions(tenant, channel, payload, options) {
        await this.client.publishWithOptions(tenant, channel, payload, options);
    }
    /**
     * Subscribes by pattern.
     */ async subscribe(tenant, channelPattern, options = {}) {
        return this.client.subscribe(tenant, channelPattern, options);
    }
    /**
     * Removes one subscription.
     */ async unsubscribe(tenant, channelPattern) {
        await this.client.unsubscribe(tenant, channelPattern);
    }
}
function $7b4d8a91271f1bc3$export$3454ddbbf9ef1f33(overlayNetworkName, accessToken) {
    return new $7b4d8a91271f1bc3$export$84278c718a874505(overlayNetworkName, accessToken, ()=>new (0, $ecb8a282c75664fb$export$de21836fc42c6f9c)());
}
function $7b4d8a91271f1bc3$export$ac45ba05e245bb5(overlayNetworkName, accessToken) {
    return new $7b4d8a91271f1bc3$export$84278c718a874505(overlayNetworkName, accessToken, ()=>new (0, $8585ef59a212420f$export$2a3746908af85482)());
}
const $7b4d8a91271f1bc3$export$8bb841525d28fe13 = $7b4d8a91271f1bc3$export$3454ddbbf9ef1f33;
const $7b4d8a91271f1bc3$export$26bb66da6a9d26ca = $7b4d8a91271f1bc3$export$ac45ba05e245bb5;
const $7b4d8a91271f1bc3$export$6eaf4d6852fd2635 = $7b4d8a91271f1bc3$export$a66334a85aba09dd;





const $447306b32f7f74c2$export$91bb716aaa6fe872 = 24;
const $447306b32f7f74c2$export$692878036c6bb647 = 1;
const $447306b32f7f74c2$export$89bb976f9be71f51 = $447306b32f7f74c2$export$692878036c6bb647;
function $447306b32f7f74c2$export$351651ddf8e40050(nowMarginSecs = $447306b32f7f74c2$export$692878036c6bb647) {
    return new Date(Date.now() - Math.max(0, nowMarginSecs) * 1000);
}
function $447306b32f7f74c2$export$7c5b7b485f5acc5b(nowMarginSecs = $447306b32f7f74c2$export$692878036c6bb647) {
    return new Date($447306b32f7f74c2$export$351651ddf8e40050(nowMarginSecs).getTime() + $447306b32f7f74c2$export$91bb716aaa6fe872 * 3600000);
}
function $447306b32f7f74c2$export$c3e2c340c4359aaf(seconds, nowMarginSecs = $447306b32f7f74c2$export$692878036c6bb647) {
    const value = new Date($447306b32f7f74c2$export$351651ddf8e40050(nowMarginSecs).getTime() + Math.max(0, seconds) * 1000);
    const max = $447306b32f7f74c2$export$7c5b7b485f5acc5b(nowMarginSecs);
    return value > max ? max : value;
}
function $447306b32f7f74c2$export$89be358b786965fa(date) {
    return date.toISOString().replace(/\.\d{3}Z$/, "Z");
}
function $447306b32f7f74c2$export$b758f1bd88434b6b(input, nowMarginSecs = $447306b32f7f74c2$export$692878036c6bb647) {
    const date = $447306b32f7f74c2$var$parseExpiresAtDate(input, nowMarginSecs);
    const max = $447306b32f7f74c2$export$7c5b7b485f5acc5b(nowMarginSecs);
    if (date > max) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("ttl_too_long", `expiration is after maximum TTL ${$447306b32f7f74c2$export$91bb716aaa6fe872}h`);
    return $447306b32f7f74c2$export$89be358b786965fa(date);
}
function $447306b32f7f74c2$export$8b34c4aa4b4e77d2(input, nowMarginSecs = $447306b32f7f74c2$export$692878036c6bb647) {
    const date = $447306b32f7f74c2$var$parseExpiresAtDate(input, nowMarginSecs);
    const max = $447306b32f7f74c2$export$7c5b7b485f5acc5b(nowMarginSecs);
    return $447306b32f7f74c2$export$89be358b786965fa(date > max ? max : date);
}
function $447306b32f7f74c2$var$parseExpiresAtDate(input, nowMarginSecs) {
    const trimmed = input.trim();
    if (trimmed.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_expires_at", "expiration string is empty");
    const lower = trimmed.toLowerCase();
    if (lower === "max" || lower === "max_ttl" || lower === "24h") return $447306b32f7f74c2$export$7c5b7b485f5acc5b(nowMarginSecs);
    const relative = $447306b32f7f74c2$var$parseRelative(lower, nowMarginSecs);
    if (relative) return relative;
    const absolute = $447306b32f7f74c2$var$parseAbsolute(trimmed);
    if (absolute) return absolute;
    throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_expires_at", `expected RFC3339, date YYYY-MM-DD, +1h/+30m, or max; got: ${input}`);
}
function $447306b32f7f74c2$var$parseRelative(input, nowMarginSecs) {
    const body = input.startsWith("+") ? input.slice(1) : input;
    const match = /^(\d+)\s*([a-z]*)$/.exec(body);
    if (!match) return undefined;
    const amount = Number(match[1]);
    const unit = match[2] ?? "";
    const factor = $447306b32f7f74c2$var$unitToSeconds(unit);
    if (factor === undefined) return undefined;
    return $447306b32f7f74c2$export$c3e2c340c4359aaf(amount * factor, nowMarginSecs);
}
function $447306b32f7f74c2$var$unitToSeconds(unit) {
    if (unit === "" || unit === "s" || unit === "sec" || unit === "secs" || unit === "second" || unit === "seconds") return 1;
    if (unit === "m" || unit === "min" || unit === "mins" || unit === "minute" || unit === "minutes") return 60;
    if (unit === "h" || unit === "hr" || unit === "hrs" || unit === "hour" || unit === "hours") return 3600;
    return undefined;
}
function $447306b32f7f74c2$var$parseAbsolute(input) {
    const normalized = /^\d{4}-\d{2}-\d{2}$/.test(input) ? `${input}T23:59:59Z` : input;
    const withZone = /z$|[+-]\d{2}:\d{2}$/i.test(normalized) ? normalized : `${normalized}Z`;
    const date = new Date(withZone);
    return Number.isNaN(date.getTime()) ? undefined : date;
}


class $f6ceae4a600c8ad0$export$e3c687fb6431a6b3 {
    tenantIds;
    allowChannelsPub;
    allowChannelsSub;
    constructor(tenantIds, allowChannelsPub = [], allowChannelsSub = []){
        this.tenantIds = tenantIds;
        this.allowChannelsPub = allowChannelsPub;
        this.allowChannelsSub = allowChannelsSub;
    }
    /**
     * Sets publish channel patterns.
     */ allowPub(channels) {
        return new $f6ceae4a600c8ad0$export$e3c687fb6431a6b3(this.tenantIds, channels, this.allowChannelsSub);
    }
    /**
     * Sets subscribe channel patterns.
     */ allowSub(channels) {
        return new $f6ceae4a600c8ad0$export$e3c687fb6431a6b3(this.tenantIds, this.allowChannelsPub, channels);
    }
    /**
     * Converts this grant to API JSON.
     */ toJson() {
        return {
            tenant_ids: this.tenantIds,
            allow_channels_pub: this.allowChannelsPub,
            allow_channels_sub: this.allowChannelsSub
        };
    }
}
class $f6ceae4a600c8ad0$export$f0bf26cea86c61ac {
    createdByValue = "";
    descriptionValue;
    expiresAtValue = "";
    tenantGrantsValue = [];
    allowIpMasksValue = [];
    allowRegionsValue = [];
    allowedWsOriginValue = [];
    nowMarginSecsValue = (0, $447306b32f7f74c2$export$692878036c6bb647);
    /**
     * Sets who creates the token.
     */ createdBy(value) {
        this.createdByValue = value;
        return this;
    }
    /**
     * Sets optional description.
     */ description(value) {
        this.descriptionValue = value;
        return this;
    }
    /**
     * Sets expiration. Accepts RFC3339, +1h, +30m, or max.
     */ expiresAt(value) {
        this.expiresAtValue = (0, $447306b32f7f74c2$export$8b34c4aa4b4e77d2)(value, this.nowMarginSecsValue);
        return this;
    }
    /**
     * Sets expiration in seconds from now.
     */ expiresInSeconds(value) {
        this.expiresAtValue = (0, $447306b32f7f74c2$export$8b34c4aa4b4e77d2)(`+${Math.max(0, value)}s`, this.nowMarginSecsValue);
        return this;
    }
    /**
     * Sets the margin used for relative expiration.
     */ nowMarginSecs(value) {
        this.nowMarginSecsValue = Math.max(0, value);
        return this;
    }
    /**
     * Adds one tenant grant.
     */ addTenantGrant(grant) {
        this.tenantGrantsValue.push(grant);
        return this;
    }
    /**
     * Sets allowed IP masks.
     */ allowIpMasks(values) {
        this.allowIpMasksValue = values;
        return this;
    }
    /**
     * Sets allowed regions.
     */ allowRegions(values) {
        this.allowRegionsValue = values;
        return this;
    }
    /**
     * Sets allowed WebSocket origins.
     */ allowedWsOrigin(values) {
        this.allowedWsOriginValue = values;
        return this;
    }
    /**
     * Builds the request object.
     */ build() {
        const request = {
            right: {
                tenant_grants: this.tenantGrantsValue.map((grant)=>grant.toJson()),
                allow_ip_masks: this.allowIpMasksValue,
                allow_regions: this.allowRegionsValue,
                allowed_ws_origin: this.allowedWsOriginValue,
                expires_at: this.expiresAtValue
            },
            created_by: this.createdByValue
        };
        if (this.descriptionValue !== undefined) request.description = this.descriptionValue;
        $f6ceae4a600c8ad0$export$850bfc2a4e5d4d2a(request);
        return request;
    }
}
function $f6ceae4a600c8ad0$export$850bfc2a4e5d4d2a(request) {
    if (request.created_by.trim().length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("missing_created_by", "created_by is missing");
    if (request.right.expires_at.trim().length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("missing_expires_at", "expires_at is missing");
    if (request.right.tenant_grants.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("no_tenant_grants", "at least one tenant grant is required");
    if (Number.isNaN(new Date(request.right.expires_at).getTime())) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_expires_at", "expires_at must be RFC3339");
}
function $f6ceae4a600c8ad0$export$6f7af3e3db176cf7(fullToken) {
    const trimmed = fullToken.trim();
    if (!trimmed.startsWith("AT_")) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_access_token", "expected AT_{token_id}_{secret}");
    const rest = trimmed.slice(3);
    const sep = rest.indexOf("_");
    if (sep <= 0 || sep === rest.length - 1) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_access_token", "expected AT_{token_id}_{secret}");
    return {
        tokenId: rest.slice(0, sep),
        secret: rest.slice(sep + 1)
    };
}
function $f6ceae4a600c8ad0$export$8b0ffa74f6edb4a3(fullToken) {
    return $f6ceae4a600c8ad0$export$6f7af3e3db176cf7(fullToken).tokenId;
}
async function $f6ceae4a600c8ad0$export$916220f68f0e45e5(apiBase, masterToken, request, config = {}) {
    $f6ceae4a600c8ad0$export$850bfc2a4e5d4d2a(request);
    const response = await (0, $53649ab7bd2d4662$export$b0613bdcd91c3d8)((0, $53649ab7bd2d4662$export$e9ddf1da8d18d6f)(apiBase, "v1/get-token"), {
        method: "POST",
        headers: {
            Authorization: `Bearer ${masterToken}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    }, config, 5000);
    const body = await (0, $53649ab7bd2d4662$export$e03e3c24cd30661)(response);
    const parsed = JSON.parse(body);
    if (!parsed.token || typeof parsed.token !== "string") throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", body);
    return {
        token: parsed.token
    };
}
async function $f6ceae4a600c8ad0$export$f8f36faf9a051362(apiBase, masterToken, tokenId, expiresAt, config = {}) {
    const id = tokenId.trim();
    const expires = expiresAt.trim();
    if (id.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("missing_token_id", "token_id is missing");
    if (expires.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("missing_expires_at", "expires_at is missing");
    if (Number.isNaN(new Date(expires).getTime())) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_expires_at", "expires_at must be RFC3339");
    const request = {
        token_id: id,
        expires_at: expires
    };
    const response = await (0, $53649ab7bd2d4662$export$b0613bdcd91c3d8)((0, $53649ab7bd2d4662$export$e9ddf1da8d18d6f)(apiBase, "v1/refresh-token"), {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${masterToken}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    }, config, 5000);
    const body = await (0, $53649ab7bd2d4662$export$e03e3c24cd30661)(response);
    const parsed = JSON.parse(body);
    if (!parsed.new_expires_at || typeof parsed.new_expires_at !== "string") throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", body);
    return {
        message: typeof parsed.message === "string" ? parsed.message : "Token refreshed successfully",
        newExpiresAt: parsed.new_expires_at
    };
}
async function $f6ceae4a600c8ad0$export$5dbbe2e0b2a7d024(apiBase, masterToken, fullToken, expiresAt, config = {}) {
    return $f6ceae4a600c8ad0$export$f8f36faf9a051362(apiBase, masterToken, $f6ceae4a600c8ad0$export$8b0ffa74f6edb4a3(fullToken), expiresAt, config);
}
async function $f6ceae4a600c8ad0$export$c545d41f704a57a7(apiBase, masterToken, fullToken, config = {}) {
    const token = fullToken.trim();
    if (token.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("missing_token", "token is missing");
    const response = await (0, $53649ab7bd2d4662$export$b0613bdcd91c3d8)((0, $53649ab7bd2d4662$export$e9ddf1da8d18d6f)(apiBase, "v1/revoke-token"), {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${masterToken}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            token: token
        })
    }, config, 5000);
    const body = await (0, $53649ab7bd2d4662$export$e03e3c24cd30661)(response);
    const parsed = JSON.parse(body);
    return {
        message: typeof parsed.message === "string" ? parsed.message : "Token revoked successfully"
    };
}
const $f6ceae4a600c8ad0$export$de5e95458a713c61 = $f6ceae4a600c8ad0$export$916220f68f0e45e5;
const $f6ceae4a600c8ad0$export$5142c9336d33d01d = $f6ceae4a600c8ad0$export$f8f36faf9a051362;
const $f6ceae4a600c8ad0$export$f60e5fd39a50d50c = $f6ceae4a600c8ad0$export$5dbbe2e0b2a7d024;
const $f6ceae4a600c8ad0$export$687eed2ded992a6e = $f6ceae4a600c8ad0$export$c545d41f704a57a7;
const $f6ceae4a600c8ad0$export$cbc0d1e87065ccdf = $f6ceae4a600c8ad0$export$8b0ffa74f6edb4a3;
const $f6ceae4a600c8ad0$export$94ff8cca0cbab77c = $f6ceae4a600c8ad0$export$6f7af3e3db176cf7;



const $20120b594434c913$var$DEFAULT_CACHE_TTL_MS = 86400000;
/** Reject a cached edge when a fresh ping is worse than this multiple of the stored RTT. */ const $20120b594434c913$var$DEFAULT_CACHE_MAX_LATENCY_GROWTH = 1.5;
/** How often the +50% latency check may trigger a full reselect. Default: 1 hour. */ const $20120b594434c913$var$DEFAULT_CACHE_LATENCY_RECHECK_MS = 3600000;
const $20120b594434c913$var$EDGE_CACHE_PREFIX = "fastpubsub-sdk:edge:v1:";
class $20120b594434c913$export$83e714cfa95a61b3 {
    entries = new Map();
    async get(overlay) {
        return this.entries.get(overlay);
    }
    async set(overlay, entry) {
        this.entries.set(overlay, entry);
    }
    async remove(overlay) {
        this.entries.delete(overlay);
    }
}
const $20120b594434c913$var$memoryCache = new $20120b594434c913$export$83e714cfa95a61b3();
class $20120b594434c913$export$7482d94cdafffc18 {
    overlay;
    httpConfig;
    bootstrapUrl;
    candidatesValue = [];
    selectedEdgeValue;
    constructor(overlay, httpConfig = {}, bootstrapUrl = (0, $7f8afe2618a9f493$export$c17ae9c1a44a5870)(overlay)){
        this.overlay = overlay;
        this.httpConfig = httpConfig;
        this.bootstrapUrl = bootstrapUrl;
    }
    /**
     * Downloads edge candidates.
     */ async discoverEdges() {
        this.candidatesValue = await (0, $7f8afe2618a9f493$export$7c7678d71b4821d0)(this.overlay, this.bootstrapUrl, this.httpConfig);
        return [
            ...this.candidatesValue
        ];
    }
    /**
     * Selects the nearest edge by ping. Does not consult persistent cache.
     */ async selectNearestEdge(options = {}) {
        if (this.candidatesValue.length === 0) await this.discoverEdges();
        this.selectedEdgeValue = await (0, $7f8afe2618a9f493$export$515d30759ec3d446)(this.candidatesValue, this.httpConfig, options);
        return this.selectedEdgeValue;
    }
    /**
     * Runs discovery and fast edge selection.
     *
     * With `{ cache: "prefer" }`, a validated cached edge skips bootstrap and
     * the multi-edge probe. A live edge is reused; at most once per
     * `cacheLatencyRecheckMs` (default 1 hour) the SDK compares fresh RTT to the
     * stored `pingMs` and rediscovers if growth exceeds `cacheMaxLatencyGrowth`
     * (default 1.5). Ping failure or TTL expiry always falls back to full selection.
     */ async resolveEdge(options = {}) {
        if (this.selectedEdgeValue && !options.forceRefresh) return this.selectedEdgeValue;
        const cacheMode = options.cache ?? "disabled";
        const edgeCache = options.edgeCache ?? $20120b594434c913$var$defaultEdgeCache();
        if (cacheMode === "prefer" && !options.forceRefresh) {
            const cached = await $20120b594434c913$var$readFreshCacheEntry(edgeCache, this.overlay, options.cacheTtlMs);
            if (cached) try {
                const timing = await (0, $7f8afe2618a9f493$export$8828a016a29f8730)([
                    cached.selected.candidate.apiBase
                ], {
                    ...this.httpConfig,
                    timeoutMs: options.pingTimeoutMs ?? this.httpConfig.timeoutMs ?? 1000
                });
                const now = Date.now();
                const recheckMs = Math.max(0, options.cacheLatencyRecheckMs ?? $20120b594434c913$var$DEFAULT_CACHE_LATENCY_RECHECK_MS);
                const lastCheck = cached.lastLatencyCheckAtMs ?? 0;
                const latencyCheckDue = now - lastCheck >= recheckMs;
                const maxGrowth = options.cacheMaxLatencyGrowth ?? $20120b594434c913$var$DEFAULT_CACHE_MAX_LATENCY_GROWTH;
                if (latencyCheckDue && !$20120b594434c913$export$5e1dfe105b4e6493(cached.selected.pingMs, timing.durationMs, maxGrowth)) await $20120b594434c913$var$removeCacheEntry(edgeCache, this.overlay);
                else {
                    this.selectedEdgeValue = {
                        candidate: cached.selected.candidate,
                        pingMs: timing.durationMs
                    };
                    this.candidatesValue = [
                        cached.selected.candidate
                    ];
                    await $20120b594434c913$var$writeCacheEntry(edgeCache, this.overlay, {
                        // On a due latency check, store the fresh RTT as the new baseline.
                        // Between checks keep the previous baseline so the hourly compare is stable.
                        selected: latencyCheckDue ? this.selectedEdgeValue : cached.selected,
                        savedAtMs: cached.savedAtMs,
                        lastLatencyCheckAtMs: latencyCheckDue ? now : cached.lastLatencyCheckAtMs ?? lastCheck
                    });
                    return this.selectedEdgeValue;
                }
            } catch  {
                await $20120b594434c913$var$removeCacheEntry(edgeCache, this.overlay);
            }
        }
        await this.discoverEdges();
        const selected = await this.selectNearestEdge(options);
        if (cacheMode === "prefer") {
            const now = Date.now();
            await $20120b594434c913$var$writeCacheEntry(edgeCache, this.overlay, {
                selected: selected,
                savedAtMs: now,
                lastLatencyCheckAtMs: now
            });
        }
        return selected;
    }
    /**
     * Returns the selected edge.
     */ selectedEdge() {
        return this.selectedEdgeValue;
    }
    /**
     * Returns selected REST base URL.
     */ apiBase() {
        const selected = this.selectedEdgeValue;
        if (!selected) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_edge_selected", "edge is not selected, call resolveEdge");
        return selected.candidate.apiBase;
    }
    /**
     * Creates an access token on an automatically selected edge.
     *
     * This is primarily useful for trusted Node.js/backend applications. Browser
     * applications should request an access token from their own backend instead
     * of exposing a master token.
     */ async createAccessToken(masterToken, request, options = {}) {
        const selected = this.selectedEdgeValue ?? await this.resolveEdge({
            cache: "prefer",
            ...options
        });
        return (0, $f6ceae4a600c8ad0$export$916220f68f0e45e5)(selected.candidate.apiBase, masterToken, request, this.httpConfig);
    }
    /**
     * Extends AT expiry on an automatically selected edge (`PUT /v1/refresh-token`).
     *
     * Backend/trusted use only — requires a master token. Pass `tokenId` (not the secret).
     */ async refreshAccessToken(masterToken, tokenId, expiresAt, options = {}) {
        const selected = this.selectedEdgeValue ?? await this.resolveEdge({
            cache: "prefer",
            ...options
        });
        return (0, $f6ceae4a600c8ad0$export$f8f36faf9a051362)(selected.candidate.apiBase, masterToken, tokenId, expiresAt, this.httpConfig);
    }
    /**
     * Same as {@link refreshAccessToken}, but accepts a full `AT_...` string.
     */ async refreshAccessTokenFromAt(masterToken, fullToken, expiresAt, options = {}) {
        const selected = this.selectedEdgeValue ?? await this.resolveEdge({
            cache: "prefer",
            ...options
        });
        return (0, $f6ceae4a600c8ad0$export$5dbbe2e0b2a7d024)(selected.candidate.apiBase, masterToken, fullToken, expiresAt, this.httpConfig);
    }
    /**
     * Revokes an access token on an automatically selected edge (`DELETE /v1/revoke-token`).
     *
     * Backend/trusted use only — requires a master token and the full `AT_...`.
     */ async revokeAccessToken(masterToken, fullToken, options = {}) {
        const selected = this.selectedEdgeValue ?? await this.resolveEdge({
            cache: "prefer",
            ...options
        });
        return (0, $f6ceae4a600c8ad0$export$c545d41f704a57a7)(selected.candidate.apiBase, masterToken, fullToken, this.httpConfig);
    }
    /**
     * Creates a WebSocket builder. If no edge is selected yet, `build()` resolves
     * one automatically with the validated cache fast path enabled.
     */ webSocket(accessToken) {
        return (0, $7b4d8a91271f1bc3$export$3454ddbbf9ef1f33)(this.overlay, accessToken).resolveEndpoint(()=>this.resolveTransportEndpoint("websocket")).httpConfig(this.httpConfig);
    }
    /**
     * Creates a WebTransport builder. Edge resolution is deferred until `build()`.
     */ webTransport(accessToken) {
        return (0, $7b4d8a91271f1bc3$export$ac45ba05e245bb5)(this.overlay, accessToken).resolveEndpoint(()=>this.resolveTransportEndpoint("webtransport")).httpConfig(this.httpConfig);
    }
    async resolveTransportEndpoint(transport) {
        const selected = this.selectedEdgeValue ?? await this.resolveEdge({
            cache: "prefer"
        });
        return {
            endpoint: transport === "websocket" ? selected.candidate.wsEndpoint : selected.candidate.wtEndpoint ?? selected.candidate.apiBase,
            apiBase: selected.candidate.apiBase
        };
    }
}
function $20120b594434c913$export$3ce6949f20cea765(overlay, config = {}) {
    return new $20120b594434c913$export$7482d94cdafffc18(overlay, config);
}
function $20120b594434c913$var$defaultEdgeCache() {
    try {
        if (typeof localStorage !== "undefined") return $20120b594434c913$var$localStorageEdgeCache;
    } catch  {
    // Access to localStorage can be blocked by browser privacy settings.
    }
    return $20120b594434c913$var$memoryCache;
}
const $20120b594434c913$var$localStorageEdgeCache = {
    async get (overlay) {
        try {
            const raw = localStorage.getItem(`${$20120b594434c913$var$EDGE_CACHE_PREFIX}${overlay}`);
            if (!raw) return undefined;
            const entry = JSON.parse(raw);
            return $20120b594434c913$var$isCacheEntry(entry) ? entry : undefined;
        } catch  {
            return undefined;
        }
    },
    async set (overlay, entry) {
        try {
            localStorage.setItem(`${$20120b594434c913$var$EDGE_CACHE_PREFIX}${overlay}`, JSON.stringify(entry));
        } catch  {
        // The cache is an optional fast path, not a reason to fail discovery.
        }
    },
    async remove (overlay) {
        try {
            localStorage.removeItem(`${$20120b594434c913$var$EDGE_CACHE_PREFIX}${overlay}`);
        } catch  {
        // Ignore storage failures.
        }
    }
};
function $20120b594434c913$var$isCacheEntry(value) {
    if (!value || typeof value !== "object") return false;
    const entry = value;
    const candidate = entry.selected?.candidate;
    return typeof entry.savedAtMs === "number" && typeof entry.selected?.pingMs === "number" && typeof candidate?.id === "string" && typeof candidate.apiBase === "string" && typeof candidate.wsEndpoint === "string";
}
function $20120b594434c913$export$5e1dfe105b4e6493(cachedPingMs, currentPingMs, maxGrowth = $20120b594434c913$var$DEFAULT_CACHE_MAX_LATENCY_GROWTH) {
    if (!(cachedPingMs > 0) || !(currentPingMs >= 0) || !(maxGrowth > 0)) return true;
    return currentPingMs <= cachedPingMs * maxGrowth;
}
async function $20120b594434c913$var$readFreshCacheEntry(edgeCache, overlay, ttlMs) {
    try {
        const entry = await edgeCache.get(overlay);
        const maxAgeMs = Math.max(0, ttlMs ?? $20120b594434c913$var$DEFAULT_CACHE_TTL_MS);
        if (!entry || Date.now() - entry.savedAtMs > maxAgeMs) {
            if (entry) await edgeCache.remove(overlay);
            return undefined;
        }
        return entry;
    } catch  {
        return undefined;
    }
}
async function $20120b594434c913$var$writeCacheEntry(edgeCache, overlay, entry) {
    try {
        await edgeCache.set(overlay, entry);
    } catch  {
    // The selected edge is still valid if the optional cache cannot be written.
    }
}
async function $20120b594434c913$var$removeCacheEntry(edgeCache, overlay) {
    try {
        await edgeCache.remove(overlay);
    } catch  {
    // Ignore cache cleanup failures.
    }
}


/** WS PING interval for link quality (seconds). */ const $4a68f02554b6f92a$export$3ddc3df169b908 = 3;
const $4a68f02554b6f92a$export$35c5df7872f016f3 = 3000;
function $4a68f02554b6f92a$export$b27848052134e8d9(builder) {
    return builder.pingIntervalSec($4a68f02554b6f92a$export$3ddc3df169b908);
}
function $4a68f02554b6f92a$export$22b6e3e09e7618e1(snapshot) {
    const last = snapshot?.lastRttMs;
    const median = snapshot?.medianRttMs;
    if (last == null && median == null) return "ws rtt \u2026";
    const parts = [];
    if (last != null) parts.push(`last ${last} ms`);
    if (median != null) parts.push(`median ${median} ms`);
    return `ws ${parts.join(", ")}`;
}
function $4a68f02554b6f92a$export$9da51ec074aeac90(client) {
    if (!client || typeof client.linkQuality !== "function") return {
        lastRttMs: undefined,
        medianRttMs: undefined
    };
    return client.linkQuality(30);
}
function $4a68f02554b6f92a$export$f16c22ed31b708df(client, onSnapshot, intervalMs = $4a68f02554b6f92a$export$35c5df7872f016f3) {
    const tick = ()=>onSnapshot($4a68f02554b6f92a$export$9da51ec074aeac90(client));
    tick();
    return window.setInterval(tick, intervalMs);
}


/** Soft AT refresh timing for browser demos (no WebSocket reconnect). */ /** Prefer refresh at least this many seconds before expiry. */ const $fa2092c4b630b570$export$5369c96fa42d5576 = 300;
const $fa2092c4b630b570$export$1be2f9096086157 = 600;
function $fa2092c4b630b570$export$92cb32746170dab3(expiresInSec) {
    const ttlSec = Math.max(60, Number(expiresInSec) || 3600);
    let refreshInSec = Math.floor(ttlSec * 0.85);
    refreshInSec = Math.min(refreshInSec, Math.max(60, ttlSec - $fa2092c4b630b570$export$5369c96fa42d5576));
    return Math.max($fa2092c4b630b570$export$1be2f9096086157, refreshInSec);
}
function $fa2092c4b630b570$export$3de77490d9b87c4a(options) {
    let timerId = null;
    let stopped = false;
    const arm = (expiresInSec)=>{
        if (stopped) return;
        if (timerId !== null) {
            clearTimeout(timerId);
            timerId = null;
        }
        const delaySec = $fa2092c4b630b570$export$92cb32746170dab3(expiresInSec);
        console.info(`[token] soft refresh in ${delaySec}s (~${Math.round(delaySec / 60)} min), TTL ${expiresInSec}s`);
        timerId = setTimeout(async ()=>{
            timerId = null;
            if (stopped) return;
            try {
                const result = await options.refresh();
                options.onSoftOk?.(result);
                arm(result.expires_in_sec);
            } catch (error) {
                await options.onError?.(error instanceof Error ? error : new Error(String(error)));
            }
        }, delaySec * 1000);
    };
    arm(options.expiresInSec);
    return {
        clear () {
            stopped = true;
            if (timerId !== null) {
                clearTimeout(timerId);
                timerId = null;
            }
        }
    };
}




// Audio has its own FastPubSub subject, but uses the same capture-time clock
// as video. All timestamps are microseconds on the sender's wall clock.
const $5a445fc90c0eded1$export$ca145eb8bf3a921c = 16;
const $5a445fc90c0eded1$export$a1965eef9f32bdb5 = 17;
const $5a445fc90c0eded1$var$FRAME_HEADER_BYTES = 25;
function $5a445fc90c0eded1$export$ed6d22ba07956164(config, streamEpoch = 0) {
    const body = new TextEncoder().encode(JSON.stringify({
        codec: config.codec,
        sampleRate: config.sampleRate,
        numberOfChannels: config.numberOfChannels,
        description: config.description ? $5a445fc90c0eded1$var$toBase64(new Uint8Array(config.description)) : undefined,
        streamEpoch: streamEpoch
    }));
    const packet = new Uint8Array(body.byteLength + 1);
    packet[0] = $5a445fc90c0eded1$export$ca145eb8bf3a921c;
    packet.set(body, 1);
    return packet;
}
function $5a445fc90c0eded1$export$f4df1b230bb46f0a(packet) {
    try {
        const config = JSON.parse(new TextDecoder().decode(packet.slice(1)));
        if (config?.codec !== "opus" || !Number.isInteger(config.sampleRate) || !Number.isInteger(config.numberOfChannels) || !Number.isInteger(config.streamEpoch)) throw new Error("unsupported audio configuration");
        return config;
    } catch (error) {
        throw new Error(`invalid audio configuration: ${error?.message || String(error)}`);
    }
}
function $5a445fc90c0eded1$export$46d2203e4ceddd0c(chunk, captureTimeUs) {
    const data = new Uint8Array(chunk.byteLength);
    chunk.copyTo(data);
    const packet = new Uint8Array($5a445fc90c0eded1$var$FRAME_HEADER_BYTES + data.byteLength);
    packet[0] = $5a445fc90c0eded1$export$a1965eef9f32bdb5;
    const view = new DataView(packet.buffer);
    view.setFloat64(1, chunk.timestamp);
    view.setFloat64(9, chunk.duration || 20000);
    view.setFloat64(17, captureTimeUs);
    packet.set(data, $5a445fc90c0eded1$var$FRAME_HEADER_BYTES);
    return packet;
}
function $5a445fc90c0eded1$export$8279b87445c5a3af(packet) {
    if (packet.byteLength < $5a445fc90c0eded1$var$FRAME_HEADER_BYTES) return undefined;
    const view = new DataView(packet.buffer, packet.byteOffset, packet.byteLength);
    return {
        timestamp: view.getFloat64(1),
        duration: view.getFloat64(9),
        captureTimeUs: view.getFloat64(17),
        data: packet.slice($5a445fc90c0eded1$var$FRAME_HEADER_BYTES)
    };
}
function $5a445fc90c0eded1$var$toBase64(bytes) {
    let value = "";
    for (const byte of bytes)value += String.fromCharCode(byte);
    return btoa(value);
}
function $5a445fc90c0eded1$export$c537b38001c583b7(value) {
    const binary = atob(value);
    const bytes = new Uint8Array(binary.length);
    for(let index = 0; index < binary.length; index += 1)bytes[index] = binary.charCodeAt(index);
    return bytes;
}


const $f429fc0865f65f35$var$AUDIO_CONFIG = {
    codec: "opus",
    sampleRate: 48000,
    numberOfChannels: 1,
    bitrate: 64000
};
/** Подпись режима микрофона для UI. */ function $f429fc0865f65f35$var$microphoneStateLabel(voiceActivated) {
    if (voiceActivated) return "microphone: DTX Opus 48 kHz \xb7 voice-activated";
    const kbps = Math.round($f429fc0865f65f35$var$AUDIO_CONFIG.bitrate / 1000);
    return `microphone: continuous Opus 48 kHz \xb7 ${kbps} kbps`;
}
/** Max frames in WebCodecs AudioEncoder queue before waiting. */ const $f429fc0865f65f35$var$MAX_ENCODE_QUEUE = 48;
/** Max frames in AudioDecoder queue; above this we wait instead of dropping immediately. */ const $f429fc0865f65f35$var$MAX_DECODE_QUEUE = 48;
/** Сколько пакетов держать, пока декодер временно отстаёт (~0.5 с при 20 мс). */ const $f429fc0865f65f35$var$MAX_PENDING_DECODE = 32;
class $f429fc0865f65f35$export$ef60a77e87a15e80 {
    constructor({ publishPacket: publishPacket, voiceActivated: voiceActivated = false, onSpeaking: onSpeaking = ()=>{}, onDiagnostic: onDiagnostic = ()=>{}, onError: onError = console.error, onState: onState = ()=>{} }){
        this.publishPacket = publishPacket;
        this.voiceActivated = voiceActivated;
        this.onSpeaking = onSpeaking;
        this.onDiagnostic = onDiagnostic;
        this.onError = onError;
        this.onState = onState;
    }
    async start(mediaStream) {
        const track = mediaStream.getAudioTracks()[0];
        if (!track) throw new Error("Microphone track is unavailable.");
        if (!globalThis.AudioEncoder || !globalThis.MediaStreamTrackProcessor) throw new Error("This browser needs WebCodecs AudioEncoder and MediaStreamTrackProcessor for conference audio.");
        const support = await AudioEncoder.isConfigSupported($f429fc0865f65f35$var$AUDIO_CONFIG);
        if (!support.supported) throw new Error("Opus audio encoding is not supported by this browser.");
        this.lastConfigAtUs = 0;
        this.decoderConfig = support.config;
        this.streamEpoch = 0;
        // UI: длинный release; отправка Opus: короткий hangover ~200 мс.
        this.detector = new $f429fc0865f65f35$var$VoiceActivityDetector({
            transmitReleaseUs: 200000,
            uiReleaseUs: 1250000
        });
        this.preroll = new $f429fc0865f65f35$var$AudioPrerollBuffer(240000);
        this.captureClock = new $f429fc0865f65f35$var$AudioCaptureClock();
        this.publishChain = Promise.resolve();
        this.encoder = new AudioEncoder({
            output: (chunk, metadata)=>{
                const config = metadata?.decoderConfig || this.decoderConfig;
                if (metadata?.decoderConfig) this.decoderConfig = metadata.decoderConfig;
                const captureTimeUs = this.captureClock.wallTimeForTimestamp(chunk.timestamp);
                // FPS subjects do not retain a decoder configuration. Repeat it like a
                // video keyframe so a participant joining later can start decoding.
                if (config && captureTimeUs - this.lastConfigAtUs >= 1000000) {
                    this.lastConfigAtUs = captureTimeUs;
                    this.enqueuePublish((0, $5a445fc90c0eded1$export$ed6d22ba07956164)(config, this.streamEpoch));
                }
                this.enqueuePublish((0, $5a445fc90c0eded1$export$46d2203e4ceddd0c)(chunk, captureTimeUs));
            },
            error: (error)=>this.onError(error)
        });
        this.encoder.configure(support.config);
        this.reader = new MediaStreamTrackProcessor({
            track: track
        }).readable.getReader();
        this.running = true;
        this.onState({
            label: $f429fc0865f65f35$var$microphoneStateLabel(this.voiceActivated)
        });
        this.consume();
    }
    enqueuePublish(packet) {
        // Config and following Opus frames must keep their order on the subject.
        this.publishChain = this.publishChain.then(()=>this.publishPacket(packet)).catch((error)=>this.onError(error));
    }
    /**
   * Начало фразы после DTX: новый epoch, сброс Opus, preroll.
   * UI speaking обновляется отдельно через uiChange.
   */ beginSpeech() {
        this.streamEpoch += 1;
        this.lastConfigAtUs = 0;
        // Пауза без пакетов — новый epoch, а не дырка для PLC на приёме.
        this.encoder.reset();
        this.encoder.configure(this.decoderConfig);
        this.encodePreroll();
    }
    /** Waits for a free encoder queue slot instead of silently dropping frames. */ async waitEncodeSlot() {
        let waited = false;
        while(this.running && this.encoder && this.encoder.encodeQueueSize >= $f429fc0865f65f35$var$MAX_ENCODE_QUEUE){
            waited = true;
            await new Promise((resolve)=>setTimeout(resolve, 2));
        }
        if (waited) this.onDiagnostic({
            type: "audio_encode_backpressure"
        });
    }
    async consume() {
        try {
            while(this.running){
                const { done: done, value: value } = await this.reader.read();
                if (done) break;
                this.captureClock.observe(value);
                const { transmitChange: transmitChange, uiChange: uiChange } = this.detector.observe(value);
                if (uiChange === true) this.onSpeaking(true);
                if (uiChange === false) this.onSpeaking(false);
                if (this.voiceActivated) {
                    if (transmitChange === true) this.beginSpeech();
                    if (this.detector.transmitActive) {
                        await this.waitEncodeSlot();
                        if (this.encoder.encodeQueueSize < $f429fc0865f65f35$var$MAX_ENCODE_QUEUE) this.encoder.encode(value);
                    } else this.preroll.remember(value);
                } else {
                    await this.waitEncodeSlot();
                    if (this.encoder.encodeQueueSize < $f429fc0865f65f35$var$MAX_ENCODE_QUEUE) this.encoder.encode(value);
                }
                value.close();
            }
        } catch (error) {
            if (this.running) this.onError(error);
        }
    }
    stop() {
        this.running = false;
        this.reader?.cancel().catch(()=>{});
        this.reader = undefined;
        this.preroll?.clear();
        this.preroll = undefined;
        this.captureClock = undefined;
        this.encoder?.close();
        this.encoder = undefined;
    }
    encodePreroll() {
        if (!this.preroll) return;
        for (const audioData of this.preroll.drain())try {
            if (this.encoder.encodeQueueSize < $f429fc0865f65f35$var$MAX_ENCODE_QUEUE) this.encoder.encode(audioData);
        } finally{
            audioData.close();
        }
    }
}
/**
 * AudioEncoder outputs may be bursty. Use the original AudioData timestamp
 * for spacing, but anchor it to Date.now() once so it still lives on the same
 * broad wall-clock axis as the video capture timestamps.
 */ class $f429fc0865f65f35$var$AudioCaptureClock {
    observe(audioData) {
        if (this.timestampOriginUs !== undefined) return;
        this.timestampOriginUs = audioData.timestamp;
        this.wallOriginUs = Date.now() * 1000;
    }
    wallTimeForTimestamp(timestampUs) {
        if (this.timestampOriginUs === undefined) {
            this.timestampOriginUs = timestampUs;
            this.wallOriginUs = Date.now() * 1000;
        }
        return this.wallOriginUs + (timestampUs - this.timestampOriginUs);
    }
}
/** Keeps a tiny chunk of pre-speech audio so VAD does not chop word starts. */ class $f429fc0865f65f35$var$AudioPrerollBuffer {
    constructor(maxDurationUs){
        this.maxDurationUs = maxDurationUs;
        this.frames = [];
        this.durationUs = 0;
    }
    remember(audioData) {
        if (typeof audioData.clone !== "function") return;
        const clone = audioData.clone();
        const durationUs = audioData.duration || Math.round(audioData.numberOfFrames / audioData.sampleRate * 1000000);
        this.frames.push({
            audioData: clone,
            durationUs: durationUs
        });
        this.durationUs += durationUs;
        while(this.durationUs > this.maxDurationUs && this.frames.length > 1){
            const dropped = this.frames.shift();
            this.durationUs -= dropped.durationUs;
            dropped.audioData.close();
        }
    }
    drain() {
        const frames = this.frames.map((frame)=>frame.audioData);
        this.frames = [];
        this.durationUs = 0;
        return frames;
    }
    clear() {
        for (const frame of this.frames)frame.audioData.close();
        this.frames = [];
        this.durationUs = 0;
    }
}
/**
 * Energy VAD: две шкалы release.
 * transmit — короткий hangover для DTX; ui — длинный, чтобы лампочка не мигала.
 */ class $f429fc0865f65f35$var$VoiceActivityDetector {
    constructor({ transmitReleaseUs: transmitReleaseUs = 200000, uiReleaseUs: uiReleaseUs = 1250000 } = {}){
        this.transmitActive = false;
        this.uiSpeaking = false;
        this.voiceUs = 0;
        this.silenceUs = 0;
        this.threshold = 0.006;
        this.attackUs = 70000;
        this.transmitReleaseUs = transmitReleaseUs;
        this.uiReleaseUs = uiReleaseUs;
    }
    /**
   * @returns {{ transmitChange?: boolean, uiChange?: boolean }}
   */ observe(audioData) {
        const samples = new Float32Array(audioData.numberOfFrames);
        audioData.copyTo(samples, {
            planeIndex: 0,
            format: "f32-planar"
        });
        let energy = 0;
        for (const sample of samples)energy += sample * sample;
        const rms = Math.sqrt(energy / Math.max(1, samples.length));
        const durationUs = audioData.duration || Math.round(audioData.numberOfFrames / audioData.sampleRate * 1000000);
        /** @type {{ transmitChange?: boolean, uiChange?: boolean }} */ const result = {};
        if (rms >= this.threshold) {
            this.voiceUs += durationUs;
            this.silenceUs = 0;
            if (!this.transmitActive && this.voiceUs >= this.attackUs) {
                this.transmitActive = true;
                result.transmitChange = true;
            }
            if (!this.uiSpeaking && this.voiceUs >= this.attackUs) {
                this.uiSpeaking = true;
                result.uiChange = true;
            }
            return result;
        }
        this.voiceUs = 0;
        if (!this.transmitActive && !this.uiSpeaking) return result;
        this.silenceUs += durationUs;
        if (this.transmitActive && this.silenceUs >= this.transmitReleaseUs) {
            this.transmitActive = false;
            result.transmitChange = false;
        }
        if (this.uiSpeaking && this.silenceUs >= this.uiReleaseUs) {
            this.uiSpeaking = false;
            result.uiChange = false;
        }
        return result;
    }
}
/** Stable decoder key without changing description every second. */ function $f429fc0865f65f35$var$decoderSignature(config) {
    return `${config.codec}:${config.sampleRate}:${config.numberOfChannels}:${config.streamEpoch}`;
}
class $f429fc0865f65f35$export$7a7e4cdc1e0ebfe0 {
    constructor({ onAudioData: onAudioData, onAudioDiagnostic: onAudioDiagnostic = ()=>{}, onWarning: onWarning = console.warn }){
        this.onAudioData = onAudioData;
        this.onAudioDiagnostic = onAudioDiagnostic;
        this.onWarning = onWarning;
        this.tracks = new Map();
        /** Frames before first Opus config. */ this.earlyFrames = new Map();
    }
    receive(channel, payload) {
        if (payload[0] === (0, $5a445fc90c0eded1$export$ca145eb8bf3a921c)) {
            this.configure(channel, (0, $5a445fc90c0eded1$export$f4df1b230bb46f0a)(payload));
            this.flushEarly(channel);
        } else if (payload[0] === (0, $5a445fc90c0eded1$export$a1965eef9f32bdb5)) this.decode(channel, payload);
    }
    /** Decodes frames that arrived before config. */ flushEarly(channel) {
        const queued = this.earlyFrames.get(channel);
        if (!queued?.length) return;
        this.earlyFrames.delete(channel);
        for (const payload of queued)this.decode(channel, payload);
    }
    configure(channel, config) {
        if (!globalThis.AudioDecoder) throw new Error("This browser does not support WebCodecs AudioDecoder.");
        const signature = $f429fc0865f65f35$var$decoderSignature(config);
        if (this.tracks.get(channel)?.signature === signature) return;
        this.close(channel);
        const track = {
            channel: channel,
            signature: signature,
            pending: [],
            draining: false
        };
        const decoder = new AudioDecoder({
            output: (audioData)=>{
                this.onAudioDiagnostic({
                    type: "audio_decoded",
                    channel: channel
                });
                this.onAudioData(channel, audioData);
                this.drainPending(track);
            },
            error: (error)=>{
                this.onAudioDiagnostic({
                    type: "audio_decoder_error",
                    channel: channel
                });
                this.onWarning("[conference] audio decoder failed", {
                    channel: channel,
                    error: error
                });
            }
        });
        const decoderConfig = {
            codec: config.codec,
            sampleRate: config.sampleRate,
            numberOfChannels: config.numberOfChannels
        };
        if (config.description) decoderConfig.description = (0, $5a445fc90c0eded1$export$c537b38001c583b7)(config.description).buffer;
        decoder.configure(decoderConfig);
        track.decoder = decoder;
        this.tracks.set(channel, track);
        this.onAudioDiagnostic({
            type: "audio_decoder_configured",
            channel: channel
        });
    }
    decode(channel, payload) {
        const track = this.tracks.get(channel);
        const frame = (0, $5a445fc90c0eded1$export$8279b87445c5a3af)(payload);
        if (!track || !frame) {
            if (!track && frame) {
                let queued = this.earlyFrames.get(channel);
                if (!queued) {
                    queued = [];
                    this.earlyFrames.set(channel, queued);
                }
                if (queued.length < 24) {
                    queued.push(payload.slice());
                    this.onAudioDiagnostic({
                        type: "audio_early_buffered",
                        channel: channel
                    });
                    return;
                }
            }
            this.onAudioDiagnostic({
                type: "audio_dropped_no_decoder",
                channel: channel
            });
            return;
        }
        if (track.decoder.decodeQueueSize >= $f429fc0865f65f35$var$MAX_DECODE_QUEUE) {
            if (track.pending.length >= $f429fc0865f65f35$var$MAX_PENDING_DECODE) {
                this.onAudioDiagnostic({
                    type: "audio_dropped_pending_full",
                    channel: channel
                });
                return;
            }
            track.pending.push(payload);
            this.onAudioDiagnostic({
                type: "audio_pending_decode",
                channel: channel
            });
            return;
        }
        this.decodeFrame(track, channel, frame);
    }
    /** Decodes one Opus frame. */ decodeFrame(track, channel, frame) {
        track.captureTimeByTimestamp ??= new Map();
        track.captureTimeByTimestamp.set(frame.timestamp, frame.captureTimeUs);
        try {
            track.decoder.decode(new EncodedAudioChunk({
                type: "key",
                timestamp: frame.timestamp,
                duration: frame.duration,
                data: frame.data
            }));
        } catch (error) {
            this.onAudioDiagnostic({
                type: "audio_dropped_decode_exception",
                channel: channel
            });
            this.onWarning("[conference] dropped audio packet", {
                channel: channel,
                error: error
            });
        }
    }
    /** After decoder output, drains the deferred packet queue. */ drainPending(track) {
        if (track.draining || track.pending.length === 0) return;
        if (track.decoder.decodeQueueSize >= $f429fc0865f65f35$var$MAX_DECODE_QUEUE) return;
        track.draining = true;
        try {
            while(track.pending.length > 0 && track.decoder.decodeQueueSize < $f429fc0865f65f35$var$MAX_DECODE_QUEUE){
                const payload = track.pending.shift();
                const frame = (0, $5a445fc90c0eded1$export$8279b87445c5a3af)(payload);
                if (!frame) continue;
                this.decodeFrame(track, track.channel, frame);
            }
        } finally{
            track.draining = false;
        }
    }
    captureTime(channel, timestamp) {
        const track = this.tracks.get(channel);
        const value = track?.captureTimeByTimestamp?.get(timestamp);
        track?.captureTimeByTimestamp?.delete(timestamp);
        return value ?? Date.now() * 1000;
    }
    close(channel) {
        const track = this.tracks.get(channel);
        if (track) {
            track.decoder.close();
            this.tracks.delete(channel);
        }
    }
    closeAll() {
        for (const channel of this.tracks.keys())this.close(channel);
    }
}


/**
 * Web Audio mixes all inputs connected to one destination. Each participant
 * gets a gain node, so a future UI can add individual volume/mute controls.
 * The clock maps a sender's capture timestamps to one local playout timeline.
 */ class $e400ff737ae715d5$export$175e8b923d6c8dc0 {
    constructor(targetLatencyMs = 220){
        this.targetLatencyUs = targetLatencyMs * 1000;
        this.origins = new Map();
    }
    presentationUs(channel, captureTimeUs) {
        const nowUs = performance.now() * 1000;
        let origin = this.origins.get(channel);
        if (!origin) {
            origin = {
                captureTimeUs: captureTimeUs,
                presentationUs: nowUs + this.targetLatencyUs
            };
            this.origins.set(channel, origin);
        }
        return origin.presentationUs + captureTimeUs - origin.captureTimeUs;
    }
    audioTime(context, channel, captureTimeUs) {
        const nowUs = performance.now() * 1000;
        let dueUs = this.presentationUs(channel, captureTimeUs);
        const lateUs = nowUs - dueUs;
        const tooFarAheadUs = dueUs - nowUs;
        if (lateUs > 250000 || tooFarAheadUs > 2000000) {
            const origin = {
                captureTimeUs: captureTimeUs,
                presentationUs: nowUs + this.targetLatencyUs
            };
            this.origins.set(channel, origin);
            dueUs = origin.presentationUs + captureTimeUs - origin.captureTimeUs;
        }
        return Math.max(context.currentTime + 0.01, context.currentTime + (dueUs - nowUs) / 1000000);
    }
    videoDelayMs(channel, captureTimeUs) {
        return Math.max(0, (this.presentationUs(channel, captureTimeUs) - performance.now() * 1000) / 1000);
    }
    remove(channel) {
        this.origins.delete(channel);
    }
    clear() {
        this.origins.clear();
    }
}
/** Аварийный потолок fallback-очереди (~400 мс). */ const $e400ff737ae715d5$var$FALLBACK_MAX_SEC = 0.4;
var $91bfaba0a076f655$exports = {};
$91bfaba0a076f655$exports = import.meta.resolve("4QBtj");


class $e400ff737ae715d5$export$67e0b939433eb50c {
    constructor({ onState: onState = ()=>{}, onAudioDiagnostic: onAudioDiagnostic = ()=>{}, onWarning: onWarning = console.warn }){
        this.onState = onState;
        this.onAudioDiagnostic = onAudioDiagnostic;
        this.onWarning = onWarning;
        this.participantSettings = new Map();
        this.fallbackQueues = new Map();
        this.workletStreams = new Set();
    }
    /** Creates AudioContext and connects worklet or fallback player. */ async enable() {
        if (!this.context) {
            this.context = new AudioContext({
                sampleRate: 48000
            });
            this.master = this.context.createGain();
            this.master.gain.value = 0.9;
            this.master.connect(this.context.destination);
            if (this.context.audioWorklet) {
                await this.context.audioWorklet.addModule(new URL($91bfaba0a076f655$exports));
                this.worklet = new AudioWorkletNode(this.context, "conference-pcm-processor");
                this.worklet.connect(this.master);
                this.worklet.port.onmessage = (event)=>{
                    const data = event.data;
                    if (data?.type === "underrun") this.onAudioDiagnostic({
                        type: "audio_underrun",
                        count: data.count
                    });
                    else if (data?.type === "buffer_stats") this.onAudioDiagnostic({
                        type: "audio_buffer_stats",
                        bufferedMs: data.bufferedMs,
                        targetMs: data.targetMs,
                        catchUpMs: data.catchUpMs,
                        count: data.underruns
                    });
                };
                this.mode = "worklet";
            } else {
                this.mode = "fallback";
                this.fallbackNextAt = new Map();
            }
        }
        await this.context.resume();
        this.onAudioDiagnostic({
            type: "audio_mixer_running",
            state: this.context.state,
            mode: this.mode
        });
        this.onState({
            label: `audio mixer: ${this.context.sampleRate} Hz \xb7 ${this.mode}`
        });
        return this.context.state;
    }
    /**
   * Accepts decoded mono PCM and queues it for playback.
   * @param {string} channel
   * @param {AudioData} audioData
   */ async play(channel, audioData) {
        if (!this.context) {
            this.onAudioDiagnostic({
                type: "audio_dropped_context",
                channel: channel
            });
            audioData.close();
            return;
        }
        if (this.context.state === "suspended") try {
            await this.context.resume();
            this.onAudioDiagnostic({
                type: "audio_context_resumed",
                state: this.context.state
            });
        } catch (error) {
            this.onAudioDiagnostic({
                type: "audio_dropped_context",
                channel: channel
            });
            this.onWarning("[conference] AudioContext resume failed", {
                channel: channel,
                error: error
            });
            audioData.close();
            return;
        }
        if (this.context.state !== "running") {
            this.onAudioDiagnostic({
                type: "audio_dropped_context",
                channel: channel
            });
            audioData.close();
            return;
        }
        const frames = audioData.numberOfFrames;
        const samples = new Float32Array(frames);
        audioData.copyTo(samples, {
            planeIndex: 0,
            format: "f32-planar"
        });
        audioData.close();
        const gain = this.effectiveGain(channel);
        if (this.mode === "worklet") {
            this.ensureStreamSettings(channel);
            this.worklet.port.postMessage({
                type: "pcm",
                channel: channel,
                samples: samples
            }, [
                samples.buffer
            ]);
            this.onAudioDiagnostic({
                type: "audio_played",
                channel: channel
            });
            return;
        }
        this.playFallback(channel, samples, gain);
        this.onAudioDiagnostic({
            type: "audio_played",
            channel: channel
        });
    }
    /** Sends gain/mute to worklet on a participant's first frame. */ ensureStreamSettings(channel) {
        if (!this.participantSettings.has(channel)) this.participantSettings.set(channel, {
            volume: 1,
            muted: false
        });
        if (this.workletStreams.has(channel)) return;
        this.workletStreams.add(channel);
        this.sendStreamSettings(channel);
    }
    /** Syncs participant volume with worklet. */ sendStreamSettings(channel) {
        if (!this.worklet) return;
        const settings = this.participantSettings.get(channel) || {};
        this.worklet.port.postMessage({
            type: "mute",
            channel: channel,
            value: Boolean(settings.muted)
        });
        this.worklet.port.postMessage({
            type: "gain",
            channel: channel,
            value: this.effectiveGain(channel)
        });
    }
    /**
   * Fallback without AudioWorklet: schedules short buffers back-to-back without gaps.
   * @param {string} channel
   * @param {Float32Array} samples
   * @param {number} gain
   */ playFallback(channel, samples, gain) {
        let state = this.fallbackQueues.get(channel);
        if (!state) {
            state = {
                queue: [],
                queueFrames: 0,
                scheduledUntil: 0,
                gainNode: this.context.createGain()
            };
            state.gainNode.connect(this.master);
            this.fallbackQueues.set(channel, state);
        }
        state.gainNode.gain.value = gain;
        state.queue.push(samples);
        state.queueFrames += samples.length;
        const maxFrames = Math.floor(this.context.sampleRate * $e400ff737ae715d5$var$FALLBACK_MAX_SEC);
        while(state.queueFrames > maxFrames && state.queue.length > 1){
            const dropped = state.queue.shift();
            state.queueFrames -= dropped.length;
        }
        this.scheduleFallback(channel, state);
    }
    /** Schedules PCM from the fallback queue ahead on the AudioContext timeline. */ scheduleFallback(channel, state) {
        const lead = 0.08;
        const now = this.context.currentTime;
        if (!state.scheduledUntil || state.scheduledUntil < now) state.scheduledUntil = now + lead;
        while(state.queue.length > 0 && state.scheduledUntil < now + $e400ff737ae715d5$var$FALLBACK_MAX_SEC){
            const chunk = state.queue.shift();
            state.queueFrames -= chunk.length;
            const buffer = this.context.createBuffer(1, chunk.length, this.context.sampleRate);
            buffer.copyToChannel(chunk, 0);
            const source = this.context.createBufferSource();
            source.buffer = buffer;
            source.connect(state.gainNode);
            try {
                source.start(state.scheduledUntil);
                state.scheduledUntil += chunk.length / this.context.sampleRate;
            } catch (error) {
                this.onAudioDiagnostic({
                    type: "audio_dropped_start",
                    channel: channel
                });
                this.onWarning("[conference] fallback audio start failed", {
                    channel: channel,
                    error: error
                });
                break;
            }
        }
    }
    setVolume(channel, volume) {
        const settings = {
            ...this.participantSettings.get(channel) || {},
            volume: Math.max(0, Math.min(2, volume))
        };
        this.participantSettings.set(channel, settings);
        this.sendStreamSettings(channel);
        const state = this.fallbackQueues.get(channel);
        if (state) state.gainNode.gain.value = this.effectiveGain(channel);
    }
    setMuted(channel, muted) {
        const settings = {
            ...this.participantSettings.get(channel) || {},
            muted: Boolean(muted)
        };
        this.participantSettings.set(channel, settings);
        this.sendStreamSettings(channel);
        const state = this.fallbackQueues.get(channel);
        if (state) state.gainNode.gain.value = this.effectiveGain(channel);
    }
    effectiveGain(channel) {
        const settings = this.participantSettings.get(channel) || {};
        return settings.muted ? 0 : settings.volume ?? 1;
    }
    remove(channel) {
        this.participantSettings.delete(channel);
        this.workletStreams.delete(channel);
        this.worklet?.port.postMessage({
            type: "remove",
            channel: channel
        });
        const state = this.fallbackQueues.get(channel);
        if (state) {
            state.gainNode.disconnect();
            this.fallbackQueues.delete(channel);
        }
    }
    close() {
        this.worklet?.port.postMessage({
            type: "flush"
        });
        this.worklet?.disconnect();
        this.worklet = undefined;
        for (const state of this.fallbackQueues.values())state.gainNode.disconnect();
        this.fallbackQueues.clear();
        this.participantSettings.clear();
        this.workletStreams.clear();
        this.master?.disconnect();
        this.context?.close().catch(this.onWarning);
        this.context = undefined;
        this.mode = undefined;
    }
}


/**
 * Adaptive encode FPS from encoded delta frame sizes (not pixel analysis).
 * Keyframes are ignored — they skew the budget.
 */ class $016b4238ba54b213$export$6adfd5d4f7a099e {
    /**
   * @param {{ minFps?: number, maxFps?: number, startFps?: number, targetBitrate?: number, windowSize?: number }} [options]
   */ constructor({ minFps: minFps = 8, maxFps: maxFps = 15, startFps: startFps = 10, targetBitrate: targetBitrate = 1500000, windowSize: windowSize = 10 } = {}){
        this.minFps = minFps;
        this.maxFps = maxFps;
        this.targetFps = startFps;
        this.targetBitrate = targetBitrate;
        this.windowSize = windowSize;
        this.frames = [];
        this.lastChangeAt = 0;
    }
    /**
   * @param {EncodedVideoChunk} chunk
   */ onEncodedChunk(chunk) {
        if (chunk.type === "key") return;
        this.frames.push({
            bytes: chunk.byteLength,
            ts: performance.now()
        });
        if (this.frames.length > this.windowSize) this.frames.shift();
    }
    getStats() {
        const values = this.frames.map((frame)=>frame.bytes).sort((a, b)=>a - b);
        if (values.length === 0) return null;
        const sum = values.reduce((total, value)=>total + value, 0);
        return {
            avg: sum / values.length,
            median: values[Math.floor(values.length / 2)],
            p80: values[Math.floor(values.length * 0.8)],
            count: values.length
        };
    }
    /**
   * @param {{ encoderQueueSize?: number, sendQueueBytes?: number }} signals
   * @returns {number}
   */ update(signals = {}) {
        if (this.frames.length < 5) return this.targetFps;
        const now = performance.now();
        if (now - this.lastChangeAt < 1200) return this.targetFps;
        const encoderBusy = (signals.encoderQueueSize ?? 0) > 2;
        const networkBusy = (signals.sendQueueBytes ?? 0) > 512000;
        if (encoderBusy || networkBusy) {
            this.targetFps = Math.max(this.minFps, this.targetFps - 2);
            this.lastChangeAt = now;
            return this.targetFps;
        }
        const budgetBytesPerFrame = this.targetBitrate / 8 / this.targetFps;
        let small = 0;
        let big = 0;
        for (const frame of this.frames){
            const ratio = frame.bytes / budgetBytesPerFrame;
            if (ratio < 0.25) small += 1;
            else if (ratio > 0.85) big += 1;
        }
        const stats = this.getStats();
        const count = this.frames.length;
        const manySmall = small >= count * 0.7;
        const manyBig = big >= count * 0.5;
        const p80Big = stats && stats.p80 > budgetBytesPerFrame * 1.2;
        if (manySmall) {
            this.targetFps = Math.max(this.minFps, this.targetFps - 1);
            this.lastChangeAt = now;
            return this.targetFps;
        }
        if (manyBig || p80Big) {
            this.targetFps = Math.min(this.maxFps, this.targetFps + 1);
            this.lastChangeAt = now;
            return this.targetFps;
        }
        return this.targetFps;
    }
}



const $a4e644bcc40f18c3$export$c9266b590ec1334 = 1;
const $a4e644bcc40f18c3$export$78c1f9c2a475c2fb = 2;
const $a4e644bcc40f18c3$export$ffea5c61f034acbf = 1;
const $a4e644bcc40f18c3$var$VIDEO_FRAME_HEADER_BYTES = 26;
function $a4e644bcc40f18c3$export$c271d2c32aed2451(decoderConfig, track, fallbackCodec) {
    const description = decoderConfig?.description ? $a4e644bcc40f18c3$var$toBase64(new Uint8Array(decoderConfig.description)) : undefined;
    const body = new TextEncoder().encode(JSON.stringify({
        codec: decoderConfig?.codec || fallbackCodec.codec,
        width: track.width,
        height: track.height,
        description: description
    }));
    const packet = new Uint8Array(body.byteLength + 1);
    packet[0] = $a4e644bcc40f18c3$export$c9266b590ec1334;
    packet.set(body, 1);
    return packet;
}
function $a4e644bcc40f18c3$export$e0e9438c5e13b45f(packet) {
    try {
        const config = JSON.parse(new TextDecoder().decode(packet.slice(1)));
        if (!(0, $6ce98e86537e26d8$export$310a89419f878635).some((candidate)=>candidate.codec === config?.codec) || !Number.isInteger(config.width) || !Number.isInteger(config.height)) throw new Error("invalid video config");
        return config;
    } catch (error) {
        throw new Error(`invalid video configuration: ${error?.message || String(error)}`);
    }
}
function $a4e644bcc40f18c3$export$6fafdd1bdc6b8e0d(chunk) {
    const encoded = new Uint8Array(chunk.byteLength);
    chunk.copyTo(encoded);
    const packet = new Uint8Array($a4e644bcc40f18c3$var$VIDEO_FRAME_HEADER_BYTES + encoded.byteLength);
    packet[0] = $a4e644bcc40f18c3$export$78c1f9c2a475c2fb;
    packet[1] = chunk.type === "key" ? $a4e644bcc40f18c3$export$ffea5c61f034acbf : 0;
    const view = new DataView(packet.buffer);
    view.setFloat64(2, chunk.timestamp);
    view.setFloat64(10, chunk.duration || 0);
    view.setFloat64(18, Date.now() * 1000);
    packet.set(encoded, $a4e644bcc40f18c3$var$VIDEO_FRAME_HEADER_BYTES);
    return packet;
}
function $a4e644bcc40f18c3$export$c7f002ae1f88eb6f(payload) {
    if (payload.byteLength < $a4e644bcc40f18c3$var$VIDEO_FRAME_HEADER_BYTES) return undefined;
    const view = new DataView(payload.buffer, payload.byteOffset, payload.byteLength);
    return {
        keyFrame: Boolean(payload[1] & $a4e644bcc40f18c3$export$ffea5c61f034acbf),
        timestamp: view.getFloat64(2),
        duration: view.getFloat64(10),
        encodedAt: view.getFloat64(18),
        data: payload.slice($a4e644bcc40f18c3$var$VIDEO_FRAME_HEADER_BYTES)
    };
}
function $a4e644bcc40f18c3$var$toBase64(bytes) {
    let binary = "";
    for (const byte of bytes)binary += String.fromCharCode(byte);
    return btoa(binary);
}
function $a4e644bcc40f18c3$export$c537b38001c583b7(value) {
    const binary = atob(value);
    const bytes = new Uint8Array(binary.length);
    for(let index = 0; index < binary.length; index += 1)bytes[index] = binary.charCodeAt(index);
    return bytes;
}


const $7100ca349f5db080$var$DESKTOP_CODEC = {
    codec: "avc1.420028",
    label: "H.264 FullHD",
    avc: {
        format: "annexb"
    }
};
const $7100ca349f5db080$var$DESKTOP_QUALITY = "high";
const $7100ca349f5db080$var$DESKTOP_WIDTH = 1920;
const $7100ca349f5db080$var$DESKTOP_HEIGHT = 1080;
const $7100ca349f5db080$var$DESKTOP_BITRATE = 1500000;
/** Как часто слать keyframe, даже если экран не меняется. */ const $7100ca349f5db080$var$KEYFRAME_INTERVAL_MS = 2000;
/** Как часто проверять «давно не было кадра». */ const $7100ca349f5db080$var$IDLE_TICK_MS = 250;
class $7100ca349f5db080$export$5187cd80f22549a0 {
    constructor({ publishPacket: publishPacket, onError: onError = console.error, onState: onState = ()=>{}, onEnded: onEnded = ()=>{} }){
        this.publishPacket = publishPacket;
        this.onError = onError;
        this.onState = onState;
        this.onEnded = onEnded;
        this.fpsController = new (0, $016b4238ba54b213$export$6adfd5d4f7a099e)({
            minFps: 8,
            maxFps: 15,
            startFps: 10,
            targetBitrate: $7100ca349f5db080$var$DESKTOP_BITRATE,
            windowSize: 10
        });
        this.pendingSendBytes = 0;
        this.running = false;
        this.nextEncodeAt = 0;
        this.lastKeyframeAt = 0;
        this.lastEncodeAt = 0;
        this.forceNextKeyframe = true;
        this.hasDrawnFrame = false;
        this.idleTimer = undefined;
    }
    /**
   * Запускает захват экрана и кодирование.
   *
   * @param {{ mediaStream: MediaStream, preview: HTMLVideoElement }} options
   */ async start({ mediaStream: mediaStream, preview: preview }) {
        if (!globalThis.VideoEncoder || !globalThis.MediaStreamTrackProcessor) throw new Error("This browser needs WebCodecs VideoEncoder for desktop share.");
        const track = mediaStream.getVideoTracks()[0];
        if (!track) throw new Error("No screen video track.");
        this.mediaStream = mediaStream;
        this.preview = preview;
        this.running = true;
        this.track = track;
        this.trackEndedHandler = ()=>{
            if (this.running) this.onEnded();
        };
        track.addEventListener("ended", this.trackEndedHandler);
        const encoderConfig = {
            codec: $7100ca349f5db080$var$DESKTOP_CODEC.codec,
            width: $7100ca349f5db080$var$DESKTOP_WIDTH,
            height: $7100ca349f5db080$var$DESKTOP_HEIGHT,
            bitrate: $7100ca349f5db080$var$DESKTOP_BITRATE,
            framerate: 15,
            latencyMode: "realtime",
            hardwareAcceleration: "no-preference",
            avc: $7100ca349f5db080$var$DESKTOP_CODEC.avc
        };
        const support = await VideoEncoder.isConfigSupported(encoderConfig);
        if (!support.supported) throw new Error("H.264 FullHD encoder is not supported on this device.");
        this.desktopTrack = {
            width: $7100ca349f5db080$var$DESKTOP_WIDTH,
            height: $7100ca349f5db080$var$DESKTOP_HEIGHT,
            quality: $7100ca349f5db080$var$DESKTOP_QUALITY,
            codec: $7100ca349f5db080$var$DESKTOP_CODEC,
            decoderConfig: undefined,
            pendingAccessUnit: undefined,
            publishing: false,
            stopped: false,
            canvas: Object.assign(document.createElement("canvas"), {
                width: $7100ca349f5db080$var$DESKTOP_WIDTH,
                height: $7100ca349f5db080$var$DESKTOP_HEIGHT
            })
        };
        this.encoder = new VideoEncoder({
            output: (chunk, metadata)=>{
                this.fpsController.onEncodedChunk(chunk);
                if (metadata?.decoderConfig) this.desktopTrack.decoderConfig = metadata.decoderConfig;
                const configPacket = chunk.type === "key" && this.desktopTrack.decoderConfig ? (0, $a4e644bcc40f18c3$export$c271d2c32aed2451)(this.desktopTrack.decoderConfig, this.desktopTrack, $7100ca349f5db080$var$DESKTOP_CODEC) : undefined;
                this.queueAccessUnit(configPacket, (0, $a4e644bcc40f18c3$export$6fafdd1bdc6b8e0d)(chunk));
            },
            error: (error)=>this.onError(error)
        });
        this.encoder.configure(support.config);
        this.nextEncodeAt = 0;
        this.lastEncodeAt = 0;
        this.lastKeyframeAt = 0;
        this.forceNextKeyframe = true;
        this.hasDrawnFrame = false;
        this.onState({
            label: `desktop: H.264 FullHD \xb7 adaptive 8\u{2013}15 fps \xb7 ${Math.round($7100ca349f5db080$var$DESKTOP_BITRATE / 1000)} kbps \xb7 key ${$7100ca349f5db080$var$KEYFRAME_INTERVAL_MS}ms`
        });
        const processor = new MediaStreamTrackProcessor({
            track: track
        });
        this.frameReader = processor.readable.getReader();
        this.startIdleKeyframeTimer();
        this.consumeFrames();
    }
    /**
   * Останавливает захват, таймер и encoder.
   */ stop() {
        this.running = false;
        this.stopIdleKeyframeTimer();
        if (this.track && this.trackEndedHandler) this.track.removeEventListener("ended", this.trackEndedHandler);
        this.trackEndedHandler = undefined;
        this.frameReader?.cancel().catch(()=>{});
        this.frameReader = undefined;
        if (this.desktopTrack) {
            this.desktopTrack.stopped = true;
            this.desktopTrack.pendingAccessUnit = undefined;
        }
        this.encoder?.close();
        this.encoder = undefined;
        this.mediaStream?.getVideoTracks().forEach((videoTrack)=>videoTrack.stop());
        this.mediaStream = undefined;
        this.preview = undefined;
        this.pendingSendBytes = 0;
        this.hasDrawnFrame = false;
    }
    /**
   * Таймер: раз в секунду шлём keyframe с последнего canvas,
   * даже если трек молчит (статичный экран).
   *
   * For maintainers: getDisplayMedia often stops delivering frames until pixels change.
   */ startIdleKeyframeTimer() {
        this.stopIdleKeyframeTimer();
        this.idleTimer = setInterval(()=>{
            this.encodeIdleKeyframeIfNeeded();
        }, $7100ca349f5db080$var$IDLE_TICK_MS);
    }
    /**
   * Гасит idle-таймер.
   */ stopIdleKeyframeTimer() {
        if (this.idleTimer !== undefined) {
            clearInterval(this.idleTimer);
            this.idleTimer = undefined;
        }
    }
    /**
   * Если давно не было encode — перекодирует последний canvas как keyframe.
   */ encodeIdleKeyframeIfNeeded() {
        if (!this.running || !this.encoder || !this.hasDrawnFrame) return;
        const now = performance.now();
        if (now - this.lastKeyframeAt < $7100ca349f5db080$var$KEYFRAME_INTERVAL_MS) return;
        if (this.encoder.encodeQueueSize > 2) return;
        this.forceNextKeyframe = true;
        this.encodeCanvasFrame(now);
    }
    /**
   * Читает кадры с экрана и кодирует с адаптивным FPS.
   */ async consumeFrames() {
        try {
            while(this.running && this.frameReader){
                const { done: done, value: frame } = await this.frameReader.read();
                if (done) break;
                this.onCaptureFrame(frame);
                frame.close();
            }
        } catch (error) {
            if (this.running) this.onError(error);
        }
    }
    /**
   * Обрабатывает один кадр с трека (если пора по FPS).
   *
   * @param {VideoFrame} sourceFrame
   */ onCaptureFrame(sourceFrame) {
        if (!this.running || !this.encoder) return;
        const now = performance.now();
        const targetFps = this.fpsController.update({
            encoderQueueSize: this.encoder.encodeQueueSize,
            sendQueueBytes: this.pendingSendBytes
        });
        const intervalMs = 1000 / targetFps;
        if (now < this.nextEncodeAt) return;
        this.fitFrameToCanvas(sourceFrame);
        this.encodeCanvasFrame(now);
        this.nextEncodeAt = now + intervalMs;
    }
    /**
   * Кодирует текущий canvas. Keyframe — по таймеру или force.
   *
   * @param {number} now
   */ encodeCanvasFrame(now) {
        if (!this.running || !this.encoder || !this.desktopTrack?.canvas) return;
        const timestamp = Math.round(now * 1000);
        const keyFrame = this.shouldSendKeyframe(now);
        let frame;
        try {
            frame = new VideoFrame(this.desktopTrack.canvas, {
                timestamp: timestamp
            });
            this.encoder.encode(frame, {
                keyFrame: keyFrame
            });
            this.lastEncodeAt = now;
        } catch (error) {
            this.onError(error);
        } finally{
            frame?.close();
        }
    }
    /**
   * Нужен ли keyframe сейчас.
   *
   * @param {number} now
   * @returns {boolean}
   */ shouldSendKeyframe(now) {
        if (this.forceNextKeyframe) {
            this.forceNextKeyframe = false;
            this.lastKeyframeAt = now;
            return true;
        }
        if (now - this.lastKeyframeAt >= $7100ca349f5db080$var$KEYFRAME_INTERVAL_MS) {
            this.lastKeyframeAt = now;
            return true;
        }
        return false;
    }
    /**
   * Рисует кадр в 1920x1080 с letterbox — без обрезки и без растягивания.
   *
   * @param {VideoFrame} sourceFrame
   */ fitFrameToCanvas(sourceFrame) {
        const srcW = sourceFrame.displayWidth;
        const srcH = sourceFrame.displayHeight;
        const scale = Math.min($7100ca349f5db080$var$DESKTOP_WIDTH / srcW, $7100ca349f5db080$var$DESKTOP_HEIGHT / srcH);
        const drawW = Math.max(1, Math.round(srcW * scale));
        const drawH = Math.max(1, Math.round(srcH * scale));
        const canvas = this.desktopTrack.canvas;
        canvas.width = $7100ca349f5db080$var$DESKTOP_WIDTH;
        canvas.height = $7100ca349f5db080$var$DESKTOP_HEIGHT;
        const ctx = canvas.getContext("2d", {
            alpha: false
        });
        ctx.fillStyle = "#000000";
        ctx.fillRect(0, 0, $7100ca349f5db080$var$DESKTOP_WIDTH, $7100ca349f5db080$var$DESKTOP_HEIGHT);
        const offsetX = Math.floor(($7100ca349f5db080$var$DESKTOP_WIDTH - drawW) / 2);
        const offsetY = Math.floor(($7100ca349f5db080$var$DESKTOP_HEIGHT - drawH) / 2);
        ctx.drawImage(sourceFrame, offsetX, offsetY, drawW, drawH);
        this.hasDrawnFrame = true;
    }
    /**
   * Кладёт config+frame в очередь публикации (оставляет только последний AU).
   *
   * @param {Uint8Array|undefined} config
   * @param {Uint8Array} frame
   */ queueAccessUnit(config, frame) {
        this.desktopTrack.pendingAccessUnit = {
            config: config,
            frame: frame
        };
        if (!this.desktopTrack.publishing) this.publishLatest();
    }
    /**
   * Публикует последние access unit по порядку.
   */ async publishLatest() {
        const state = this.desktopTrack;
        if (!state) return;
        state.publishing = true;
        try {
            while(state.pendingAccessUnit && !state.stopped && this.running){
                const accessUnit = state.pendingAccessUnit;
                state.pendingAccessUnit = undefined;
                if (accessUnit.config) await this.publishQueued($7100ca349f5db080$var$DESKTOP_QUALITY, accessUnit.config);
                await this.publishQueued($7100ca349f5db080$var$DESKTOP_QUALITY, accessUnit.frame);
            }
        } catch (error) {
            this.onError(error);
        } finally{
            state.publishing = false;
            if (state.pendingAccessUnit && !state.stopped && this.running) this.publishLatest();
        }
    }
    /**
   * Публикует один пакет и учитывает размер очереди отправки.
   *
   * @param {string} quality
   * @param {Uint8Array} payload
   */ async publishQueued(quality, payload) {
        this.pendingSendBytes += payload.byteLength;
        try {
            await this.publishPacket(quality, payload);
        } finally{
            this.pendingSendBytes = Math.max(0, this.pendingSendBytes - payload.byteLength);
        }
    }
}


/**
 * Захват экрана для desktop share (FullHD, до 15 fps capture).
 */ async function $0f1ac663850663d8$export$8ea5fb8750bab5cc() {
    if (!navigator.mediaDevices?.getDisplayMedia) throw new Error("Screen sharing is not supported in this browser.");
    const stream = await navigator.mediaDevices.getDisplayMedia({
        video: {
            width: {
                ideal: 1920,
                max: 1920
            },
            height: {
                ideal: 1080,
                max: 1080
            },
            frameRate: {
                ideal: 15,
                max: 15
            }
        },
        audio: false
    });
    const track = stream.getVideoTracks()[0];
    if (track) try {
        track.contentHint = "detail";
    } catch  {
    /* старые браузеры */ }
    return stream;
}


/** Пустой id — микрофон по умолчанию в системе/браузере. */ const $be84addac8871937$export$1f13b6c27149433e = "";
async function $be84addac8871937$export$87f9e16cf0961315() {
    if (!navigator.mediaDevices?.enumerateDevices) return [];
    const devices = await navigator.mediaDevices.enumerateDevices();
    let index = 0;
    return devices.filter((device)=>device.kind === "audioinput").map((device)=>{
        index += 1;
        return {
            deviceId: device.deviceId,
            label: device.label || `Microphone ${index}`
        };
    });
}
function $be84addac8871937$export$c74060dcd916f433(deviceId) {
    const audio = {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true
    };
    if (deviceId) audio.deviceId = {
        exact: deviceId
    };
    return {
        video: false,
        audio: audio
    };
}


/** Participant heartbeat message on public.*.state. */ const $4e04d6614c3f1e48$export$8dfce651c54735a7 = "participant_state";
const $4e04d6614c3f1e48$export$42661b4ced6a4e14 = "public.room.closed";
const $4e04d6614c3f1e48$export$dcf7e1392b1bdf4b = "conference_closed";
const $4e04d6614c3f1e48$export$561b06d4d002405c = "public.#";
const $4e04d6614c3f1e48$export$dcdcc86a22cb1582 = 3500;
/**
 * Debug heartbeat in console: URL ?fpsDebug=1 or localStorage.fpsDebug=1.
 * For myself: opt-in so normal demos stay quiet.
 */ function $4e04d6614c3f1e48$var$isFpsStateDebug() {
    try {
        if (typeof window === "undefined") return false;
        if (window.localStorage?.getItem("fpsDebug") === "1") return true;
        return new URLSearchParams(window.location.search).get("fpsDebug") === "1";
    } catch  {
        return false;
    }
}
function $4e04d6614c3f1e48$export$ad60a02788fbff4d(channel) {
    const parts = channel.split(".");
    if (parts.length !== 4 || parts[0] !== "public" || parts[3] !== "state") return undefined;
    const role = parts[1];
    const participantId = parts[2];
    if (!role || !participantId) return undefined;
    return {
        role: role,
        participantId: participantId
    };
}
function $4e04d6614c3f1e48$export$476494f8a96ec061(conferenceId) {
    return new TextEncoder().encode(JSON.stringify({
        type: $4e04d6614c3f1e48$export$dcf7e1392b1bdf4b,
        conference_id: conferenceId,
        sent_at: Date.now()
    }));
}
function $4e04d6614c3f1e48$export$fc257fda86963049(payload) {
    try {
        const message = JSON.parse(new TextDecoder().decode(payload));
        if (message?.type !== $4e04d6614c3f1e48$export$dcf7e1392b1bdf4b || typeof message.conference_id !== "string") return undefined;
        return {
            conferenceId: message.conference_id
        };
    } catch  {
        return undefined;
    }
}
function $4e04d6614c3f1e48$export$121bd55b18eef014({ participantId: participantId, status: status, camera: camera, microphone: microphone, speaking: speaking = false, videoSource: videoSource = "none", wantVideoHigh: wantVideoHigh = "" }) {
    return new TextEncoder().encode(JSON.stringify({
        type: $4e04d6614c3f1e48$export$8dfce651c54735a7,
        participant_id: participantId,
        status: status,
        camera: Boolean(camera),
        microphone: Boolean(microphone),
        speaking: Boolean(speaking),
        video_source: videoSource === "camera" || videoSource === "desktop" ? videoSource : "none",
        want_video_high: typeof wantVideoHigh === "string" ? wantVideoHigh : "",
        sent_at: Date.now()
    }));
}
function $4e04d6614c3f1e48$export$47d8d36eb7d8adac(payload) {
    try {
        const message = JSON.parse(new TextDecoder().decode(payload));
        if (message?.type !== $4e04d6614c3f1e48$export$8dfce651c54735a7 || typeof message.participant_id !== "string") return undefined;
        const status = message.status === "offline" ? "offline" : "online";
        return {
            participantId: message.participant_id,
            status: status,
            camera: Boolean(message.camera),
            microphone: Boolean(message.microphone),
            speaking: Boolean(message.speaking),
            videoSource: message.video_source === "desktop" ? "desktop" : message.video_source === "camera" ? "camera" : "none",
            wantVideoHigh: typeof message.want_video_high === "string" ? message.want_video_high : "",
            sentAt: Number(message.sent_at) || Date.now()
        };
    } catch  {
        return undefined;
    }
}
class $4e04d6614c3f1e48$export$894a04b4104f8ba1 {
    constructor({ client: client, tenant: tenant, channelRole: channelRole, participantId: participantId, onRemoteUpdate: onRemoteUpdate = ()=>{}, onRoomClosed: onRoomClosed = ()=>{}, onWarning: onWarning = console.warn }){
        this.client = client;
        this.tenant = tenant;
        this.channelRole = channelRole;
        this.participantId = participantId;
        this.publishChannel = `public.${channelRole}.${participantId}.state`;
        this.onRemoteUpdate = onRemoteUpdate;
        this.onRoomClosed = onRoomClosed;
        this.onWarning = onWarning;
        this.localStatus = "online";
        this.local = {
            camera: false,
            microphone: false,
            speaking: false,
            videoSource: "none",
            wantVideoHigh: ""
        };
        /** @type {Map<string, { channelRole: string, status: string, camera: boolean, microphone: boolean, speaking: boolean, receivedAt: number }>} */ this.remote = new Map();
        this.publishTimer = undefined;
        this.listenTask = {
            stopped: false
        };
        this.stopped = false;
    }
    /** Updates local camera/mic/speaking and sends a packet immediately. */ setLocal(change) {
        this.local = {
            ...this.local,
            ...change
        };
        this.publishNow().catch((error)=>this.onWarning("[conference] state publish failed", error));
    }
    /** Local status online; sends a packet immediately. */ setOnline() {
        this.localStatus = "online";
        this.publishNow().catch((error)=>this.onWarning("[conference] state publish failed", error));
    }
    /** Before leaving — offline and one last packet. */ setOffline() {
        this.localStatus = "offline";
        this.local = {
            camera: false,
            microphone: false,
            speaking: false,
            videoSource: "none",
            wantVideoHigh: ""
        };
        this.publishNow().catch((error)=>this.onWarning("[conference] state offline failed", error));
    }
    /** Starts 1 Hz publishing and a single wildcard subscription. */ start() {
        this.stopped = false;
        this.listenTask = {
            stopped: false
        };
        this.localStatus = "online";
        this.publishTimer = window.setInterval(()=>{
            this.publishNow().catch((error)=>this.onWarning("[conference] state tick failed", error));
        }, 1000);
        this.publishNow().catch(()=>{});
        this.listenAll();
    }
    /** Stops the timer and wildcard subscription. */ stop() {
        this.stopped = true;
        this.listenTask.stopped = true;
        if (this.publishTimer) {
            window.clearInterval(this.publishTimer);
            this.publishTimer = undefined;
        }
        this.client.unsubscribe(this.tenant, $4e04d6614c3f1e48$export$561b06d4d002405c).catch(this.onWarning);
    }
    /** Publishes own heartbeat to public.<role>.<participant_id>.state. */ async publishNow() {
        if (!this.client || this.stopped) return;
        const packet = $4e04d6614c3f1e48$export$121bd55b18eef014({
            participantId: this.participantId,
            status: this.localStatus,
            camera: this.local.camera,
            microphone: this.local.microphone,
            speaking: this.local.speaking,
            videoSource: this.local.videoSource,
            wantVideoHigh: this.local.wantVideoHigh || ""
        });
        if ($4e04d6614c3f1e48$var$isFpsStateDebug()) console.log("[fps-state:pub]", this.publishChannel, {
            status: this.localStatus,
            camera: this.local.camera,
            microphone: this.local.microphone,
            videoSource: this.local.videoSource
        });
        await this.client.publish(this.tenant, this.publishChannel, packet);
    }
    /** Subscribes once to every public.*.state channel in the tenant. */ async listenAll() {
        const task = this.listenTask;
        try {
            // Очередь больше: на public.# лежат heartbeat всех участников + свои.
            const queue = await this.client.subscribe(this.tenant, $4e04d6614c3f1e48$export$561b06d4d002405c, {
                queueCapacity: 128
            });
            if ($4e04d6614c3f1e48$var$isFpsStateDebug()) console.log("[fps-state:sub]", $4e04d6614c3f1e48$export$561b06d4d002405c, "tenant=", this.tenant);
            while(!task.stopped && !this.stopped){
                const message = await queue.recv();
                if (!message || task.stopped) break;
                // Важно: newest только внутри одного channel.
                // Иначе heartbeat хоста пропадает, когда в очереди лежит свой state.
                const newestByChannel = new Map();
                newestByChannel.set(message.channel, message);
                let queued;
                while(queued = queue.tryRecv())newestByChannel.set(queued.channel, queued);
                for (const item of newestByChannel.values())this.receive(item.channel, item.payload);
            }
        } catch (error) {
            if (!task.stopped && !this.stopped) this.onWarning(`participant state subscription ${$4e04d6614c3f1e48$export$561b06d4d002405c}`, error);
        }
    }
    /**
   * Хост объявляет закрытие комнаты. Писать может только AT с allow_pub
   * public.room.closed (роль host).
   */ async publishRoomClosed(conferenceId) {
        if (!this.client || this.stopped) return;
        await this.client.publish(this.tenant, $4e04d6614c3f1e48$export$42661b4ced6a4e14, $4e04d6614c3f1e48$export$476494f8a96ec061(conferenceId));
    }
    /**
   * Handles one remote state packet.
   * Role and participant_id are taken from the channel name; body participant_id must match.
   */ receive(channel, payload) {
        if (channel === $4e04d6614c3f1e48$export$42661b4ced6a4e14) {
            const closed = $4e04d6614c3f1e48$export$fc257fda86963049(payload);
            if (closed) this.onRoomClosed(closed);
            return;
        }
        const channelIdentity = $4e04d6614c3f1e48$export$ad60a02788fbff4d(channel);
        if (!channelIdentity) {
            if ($4e04d6614c3f1e48$var$isFpsStateDebug()) console.log("[fps-state:skip]", channel, "not a state channel");
            return;
        }
        const parsed = $4e04d6614c3f1e48$export$47d8d36eb7d8adac(payload);
        if (!parsed || parsed.participantId !== channelIdentity.participantId) {
            if ($4e04d6614c3f1e48$var$isFpsStateDebug()) console.log("[fps-state:skip]", channel, "body mismatch");
            return;
        }
        if (parsed.participantId === this.participantId) {
            if ($4e04d6614c3f1e48$var$isFpsStateDebug()) console.log("[fps-state:echo]", channel, "own heartbeat");
            return;
        }
        if ($4e04d6614c3f1e48$var$isFpsStateDebug()) console.log("[fps-state:recv]", channel, {
            status: parsed.status,
            camera: parsed.camera,
            microphone: parsed.microphone,
            videoSource: parsed.videoSource
        });
        this.remote.set(channelIdentity.participantId, {
            channelRole: channelIdentity.role,
            status: parsed.status,
            camera: parsed.camera,
            microphone: parsed.microphone,
            speaking: parsed.speaking,
            videoSource: parsed.videoSource,
            wantVideoHigh: parsed.wantVideoHigh || "",
            receivedAt: Date.now()
        });
        this.onRemoteUpdate(channelIdentity.participantId);
    }
    /**
   * Remote participant state with staleness applied.
   * @param {string} participantId
   */ remoteState(participantId) {
        const state = this.remote.get(participantId);
        if (!state) return {
            status: "offline",
            stale: true,
            ageMs: null,
            channelRole: undefined,
            camera: false,
            microphone: false,
            speaking: false,
            videoSource: "none",
            wantVideoHigh: ""
        };
        const ageMs = Date.now() - state.receivedAt;
        const stale = ageMs > $4e04d6614c3f1e48$export$dcdcc86a22cb1582;
        return {
            channelRole: state.channelRole,
            status: stale ? "offline" : state.status,
            camera: state.camera,
            microphone: state.microphone,
            speaking: state.speaking,
            videoSource: state.videoSource || "none",
            wantVideoHigh: state.wantVideoHigh || "",
            stale: stale,
            ageMs: ageMs
        };
    }
    /** Participant is online by state heartbeat (not stale, status online). */ participantOnline(participantId) {
        const state = this.remoteState(participantId);
        return !state.stale && state.status === "online";
    }
    /** Desktop or camera video is on per latest state. */ participantVideoOn(participantId) {
        const state = this.remoteState(participantId);
        return !state.stale && state.camera;
    }
    /** Remote video source: camera, desktop, or none. */ participantVideoSource(participantId) {
        const state = this.remoteState(participantId);
        if (state.stale || !state.camera) return "none";
        return state.videoSource === "desktop" ? "desktop" : "camera";
    }
    /** Camera is on per latest state (not stale). */ participantCameraOn(participantId) {
        const state = this.remoteState(participantId);
        return !state.stale && state.camera;
    }
    /** Microphone is on per latest state. */ participantMicrophoneOn(participantId) {
        const state = this.remoteState(participantId);
        return !state.stale && state.microphone;
    }
    /**
   * Кто-то из живых просит high этого участника (solo / fullscreen).
   * @param {string} targetParticipantId
   */ someoneWantsHigh(targetParticipantId) {
        if (!targetParticipantId) return false;
        for (const participantId of this.onlineParticipantIds()){
            const state = this.remoteState(participantId);
            if (state.wantVideoHigh === targetParticipantId) return true;
        }
        return false;
    }
    /** Private media prefix: private.<role>.<participant_id> from channel name. */ privatePrefixFor(participantId) {
        const state = this.remoteState(participantId);
        if (!state.channelRole) return undefined;
        return `private.${state.channelRole}.${participantId}`;
    }
    /** Online remote participant ids (excluding self). */ onlineParticipantIds() {
        const out = [];
        for (const [participantId] of this.remote){
            if (participantId === this.participantId) continue;
            if (this.participantOnline(participantId)) out.push(participantId);
        }
        return out;
    }
    /** Snapshot for UI (remote participants only). */ snapshot() {
        const out = {};
        for (const [participantId] of this.remote)out[participantId] = this.remoteState(participantId);
        return out;
    }
}



const $d112d830ad738fba$var$AUDIO_RESUBSCRIBE_MS = 800;
/** Очередь FPS для живого голоса: ~0.6–1 с при 20 мс кадрах, не секунды. */ const $d112d830ad738fba$var$AUDIO_QUEUE_CAPACITY = 40;
class $d112d830ad738fba$export$d3034648954c075c {
    constructor({ client: client, tenant: tenant, subjectPrefix: subjectPrefix, onAudioPacket: onAudioPacket, onAudioDiagnostic: onAudioDiagnostic = ()=>{}, onWarning: onWarning = console.warn }){
        this.client = client;
        this.tenant = tenant;
        this.subjectPrefix = subjectPrefix;
        this.onAudioPacket = onAudioPacket;
        this.onAudioDiagnostic = onAudioDiagnostic;
        this.onWarning = onWarning;
        this.subscriptions = new Map();
    }
    audioChannel(subjectPrefix) {
        return `${subjectPrefix}.media.audio.opus`;
    }
    publishAudio(payload) {
        return this.client.publish(this.tenant, this.audioChannel(this.subjectPrefix), payload);
    }
    syncSubscriptions(subjectPrefixes) {
        const wanted = new Set([
            ...subjectPrefixes
        ].map((prefix)=>this.audioChannel(prefix)));
        this.sync(this.subscriptions, wanted, (channel)=>this.subscribeAudio(channel));
    }
    /** Синхронизирует карту подписок с нужным набором каналов. */ sync(subscriptions, wanted, subscribe) {
        for (const [channel, subscription] of subscriptions){
            if (wanted.has(channel)) continue;
            subscription.stopped = true;
            subscriptions.delete(channel);
            this.client.unsubscribe(this.tenant, `${channel}.#`).catch(this.onWarning);
            this.onAudioDiagnostic({
                type: "audio_unsubscribed",
                channel: channel
            });
        }
        for (const channel of wanted)if (!subscriptions.has(channel)) subscribe(channel);
    }
    /** Один пакет из очереди подписки. */ deliverAudioPacket(message) {
        if (message.payload[0] !== (0, $5a445fc90c0eded1$export$ca145eb8bf3a921c) && message.payload[0] !== (0, $5a445fc90c0eded1$export$a1965eef9f32bdb5)) return;
        this.onAudioDiagnostic({
            type: message.payload[0] === (0, $5a445fc90c0eded1$export$ca145eb8bf3a921c) ? "audio_config_packet" : "audio_frame_packet",
            channel: message.channel
        });
        this.onAudioPacket(message.channel, message.payload);
    }
    /** Пауза перед повторной подпиской после обрыва recv. */ waitResubscribe() {
        return new Promise((resolve)=>setTimeout(resolve, $d112d830ad738fba$var$AUDIO_RESUBSCRIBE_MS));
    }
    /**
   * Подписка на аудио с авто-reconnect, когда recv() вернул null.
   */ async subscribeAudio(channel) {
        const subscription = {
            stopped: false
        };
        this.subscriptions.set(channel, subscription);
        while(!subscription.stopped){
            let queue;
            try {
                queue = await this.client.subscribe(this.tenant, `${channel}.#`, {
                    queueCapacity: $d112d830ad738fba$var$AUDIO_QUEUE_CAPACITY
                });
                this.onAudioDiagnostic({
                    type: "audio_subscribed",
                    channel: channel
                });
            } catch (error) {
                if (subscription.stopped) return;
                this.onAudioDiagnostic({
                    type: "audio_subscription_error",
                    channel: channel
                });
                this.onWarning(`audio subscription ${channel}`, error);
                await this.waitResubscribe();
                continue;
            }
            try {
                while(!subscription.stopped){
                    const message = await queue.recv();
                    if (subscription.stopped) break;
                    if (!message) {
                        this.onAudioDiagnostic({
                            type: "audio_subscription_ended",
                            channel: channel
                        });
                        break;
                    }
                    this.deliverAudioPacket(message);
                    let queued;
                    while(queued = queue.tryRecv())this.deliverAudioPacket(queued);
                }
            } catch (error) {
                if (!subscription.stopped) {
                    this.onAudioDiagnostic({
                        type: "audio_subscription_error",
                        channel: channel
                    });
                    this.onWarning(`audio subscription ${channel}`, error);
                }
            }
            if (subscription.stopped) return;
            this.onAudioDiagnostic({
                type: "audio_subscription_reconnecting",
                channel: channel
            });
            this.client.unsubscribe(this.tenant, `${channel}.#`).catch(this.onWarning);
            await this.waitResubscribe();
        }
    }
    stop() {
        this.sync(this.subscriptions, new Set(), ()=>{});
    }
}



class $28fbb5f918dda4ef$export$6715a103814e8e69 {
    constructor({ client: client, tenant: tenant, subjectPrefix: subjectPrefix, onVideoPacket: onVideoPacket, onWarning: onWarning = console.warn }){
        this.client = client;
        this.tenant = tenant;
        this.subjectPrefix = subjectPrefix;
        this.onVideoPacket = onVideoPacket;
        this.onWarning = onWarning;
        this.subscriptions = new Map();
    }
    videoChannel(subjectPrefix, quality) {
        return `${subjectPrefix}.media.video.${quality}`;
    }
    publishVideo(quality, payload) {
        return this.client.publish(this.tenant, this.videoChannel(this.subjectPrefix, quality), payload);
    }
    syncSubscriptions(channels) {
        this.sync(this.subscriptions, channels, (channel)=>this.subscribeVideo(channel));
    }
    /** Синхронизирует карту подписок с нужным набором каналов. */ sync(subscriptions, wanted, subscribe) {
        for (const [channel, subscription] of subscriptions){
            if (wanted.has(channel)) continue;
            subscription.stopped = true;
            subscriptions.delete(channel);
            this.client.unsubscribe(this.tenant, `${channel}.#`).catch(this.onWarning);
        }
        for (const channel of wanted)if (!subscriptions.has(channel)) subscribe(channel);
    }
    async subscribeVideo(channel) {
        const subscription = {
            stopped: false
        };
        this.subscriptions.set(channel, subscription);
        try {
            const queue = await this.client.subscribe(this.tenant, `${channel}.#`, {
                queueCapacity: 8
            });
            while(!subscription.stopped){
                const message = await queue.recv();
                if (!message || subscription.stopped) break;
                if (message.payload[0] === (0, $a4e644bcc40f18c3$export$c9266b590ec1334)) this.onVideoPacket(message.channel, message.payload);
                let newest = message.payload[0] === (0, $a4e644bcc40f18c3$export$78c1f9c2a475c2fb) ? message : undefined;
                let queued;
                while(queued = queue.tryRecv()){
                    if (queued.payload[0] === (0, $a4e644bcc40f18c3$export$c9266b590ec1334)) this.onVideoPacket(queued.channel, queued.payload);
                    else if (queued.payload[0] === (0, $a4e644bcc40f18c3$export$78c1f9c2a475c2fb)) newest = queued;
                }
                if (newest) this.onVideoPacket(newest.channel, newest.payload);
            }
        } catch (error) {
            if (!subscription.stopped) this.onWarning(`video subscription ${channel}`, error);
        }
    }
    stop() {
        this.sync(this.subscriptions, new Set(), ()=>{});
    }
}




class $0bdbfad2e9cec567$export$b4afc42873b6fcf5 {
    constructor({ publishPacket: publishPacket, onError: onError = console.error, onState: onState = ()=>{} }){
        this.publishPacket = publishPacket;
        this.onError = onError;
        this.onState = onState;
        this.encoders = new Map();
    }
    async start({ mediaStream: mediaStream, preview: preview, modes: modes }) {
        this.mediaStream = mediaStream;
        this.preview = preview;
        this.encoders = new Map();
        for (const track of modes)await this.addMode(track);
        this.lastKeyFrameAt = 0;
        const cameraTrack = mediaStream.getVideoTracks()[0];
        if (cameraTrack && globalThis.MediaStreamTrackProcessor) {
            const processor = new MediaStreamTrackProcessor({
                track: cameraTrack
            });
            this.cameraFrameReader = processor.readable.getReader();
            this.consumeCameraFrames();
        } else if (typeof preview.requestVideoFrameCallback === "function") this.schedulePreviewCapture();
        else this.captureTimer = window.setInterval(()=>this.capturePreviewFrame(), 1000 / 30);
    }
    /**
   * Добавляет один quality-энкодер. Нужно, чтобы high включать только по запросу.
   * @param {object} track
   */ async addMode(track) {
        if (!this.mediaStream || this.encoders.has(track.quality)) return undefined;
        const selection = await (0, $6ce98e86537e26d8$export$3087b69c708aa5d9)(track, track.preference, track.hardwareOnly);
        if (!selection) throw new Error(`${track.quality} codec preference is not supported on this device.`);
        const support = await VideoEncoder.isConfigSupported((0, $6ce98e86537e26d8$export$40a5ed4d0752a125)(selection.codec, track, selection.acceleration));
        if (!support.supported) throw new Error(`${selection.codec.label} ${track.quality} encoder is not supported on this device.`);
        const state = {
            ...track,
            codec: selection.codec,
            config: support.config,
            canvas: Object.assign(document.createElement("canvas"), {
                width: track.width,
                height: track.height
            }),
            decoderConfig: undefined,
            pendingAccessUnit: undefined,
            publishing: false,
            lastEncodedAt: 0,
            stopped: false
        };
        const encoder = new VideoEncoder({
            output: (chunk, metadata)=>{
                if (metadata?.decoderConfig) state.decoderConfig = metadata.decoderConfig;
                this.queueAccessUnit(state, chunk.type === "key" ? (0, $a4e644bcc40f18c3$export$c271d2c32aed2451)(state.decoderConfig, track, selection.codec) : undefined, (0, $a4e644bcc40f18c3$export$6fafdd1bdc6b8e0d)(chunk));
            },
            error: (error)=>this.onError(error, track.quality)
        });
        encoder.configure(support.config);
        state.encoder = encoder;
        this.encoders.set(track.quality, state);
        this.emitLabels();
        return `${track.quality}: ${selection.codec.label}${selection.acceleration === "prefer-software" ? " (software)" : ""}`;
    }
    /**
   * Выключает один quality, остальные не трогает.
   * @param {string} quality
   */ stopMode(quality) {
        const state = this.encoders.get(quality);
        if (!state) return;
        state.stopped = true;
        state.pendingAccessUnit = undefined;
        try {
            state.encoder.close();
        } catch  {
        // энкодер уже закрыт
        }
        this.encoders.delete(quality);
        this.emitLabels();
    }
    /** Есть ли этот quality. */ hasMode(quality) {
        return this.encoders.has(quality);
    }
    emitLabels() {
        const labels = [
            ...this.encoders.values()
        ].map((state)=>{
            const software = state.config?.hardwareAcceleration === "prefer-software" ? " (software)" : "";
            return `${state.quality}: ${state.codec.label}${software}`;
        });
        this.onState({
            labels: labels
        });
    }
    stop() {
        window.clearInterval(this.captureTimer);
        this.captureTimer = undefined;
        if (this.captureFrameCallback !== undefined && this.preview?.cancelVideoFrameCallback) this.preview.cancelVideoFrameCallback(this.captureFrameCallback);
        this.captureFrameCallback = undefined;
        if (this.cameraFrameReader) {
            this.cameraFrameReader.cancel().catch(()=>{});
            this.cameraFrameReader = undefined;
        }
        for (const state of this.encoders.values()){
            state.stopped = true;
            state.pendingAccessUnit = undefined;
            state.encoder.close();
        }
        this.encoders.clear();
        this.mediaStream = undefined;
    }
    async consumeCameraFrames() {
        try {
            while(this.cameraFrameReader && this.mediaStream){
                const { done: done, value: frame } = await this.cameraFrameReader.read();
                if (done) break;
                this.encodeFrame(frame);
                frame.close();
            }
        } catch (error) {
            if (this.mediaStream) this.onError(error);
        }
    }
    schedulePreviewCapture() {
        this.captureFrameCallback = this.preview.requestVideoFrameCallback(()=>{
            this.captureFrameCallback = undefined;
            this.capturePreviewFrame();
            if (this.mediaStream && this.encoders.size) this.schedulePreviewCapture();
        });
    }
    capturePreviewFrame() {
        if (!this.mediaStream || this.preview.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) return;
        const frame = new VideoFrame(this.preview, {
            timestamp: Math.round(performance.now() * 1000)
        });
        this.encodeFrame(frame);
        frame.close();
    }
    encodeFrame(sourceFrame) {
        if (!this.mediaStream) return;
        const timestamp = Date.now() * 1000;
        const keyFrame = timestamp - this.lastKeyFrameAt >= 1000000;
        if (keyFrame) this.lastKeyFrameAt = timestamp;
        for (const state of this.encoders.values()){
            if (state.encoder.encodeQueueSize > 2 || timestamp - state.lastEncodedAt < 1000000 / state.framerate) continue;
            state.lastEncodedAt = timestamp;
            const frame = sourceFrame.displayWidth === state.width && sourceFrame.displayHeight === state.height ? new VideoFrame(sourceFrame, {
                timestamp: timestamp
            }) : this.resizeFrame(sourceFrame, state, timestamp);
            state.encoder.encode(frame, {
                keyFrame: keyFrame
            });
            frame.close();
        }
    }
    resizeFrame(sourceFrame, state, timestamp) {
        state.canvas.getContext("2d", {
            alpha: false
        }).drawImage(sourceFrame, 0, 0, state.width, state.height);
        return new VideoFrame(state.canvas, {
            timestamp: timestamp
        });
    }
    queueAccessUnit(state, config, frame) {
        state.pendingAccessUnit = {
            config: config,
            frame: frame
        };
        if (!state.publishing) this.publishLatest(state);
    }
    async publishLatest(state) {
        state.publishing = true;
        try {
            while(state.pendingAccessUnit && !state.stopped && this.mediaStream){
                const accessUnit = state.pendingAccessUnit;
                state.pendingAccessUnit = undefined;
                if (accessUnit.config) await this.publishPacket(state.quality, accessUnit.config);
                await this.publishPacket(state.quality, accessUnit.frame);
            }
        } catch (error) {
            this.onError(error, state.quality);
        } finally{
            state.publishing = false;
            if (state.pendingAccessUnit && !state.stopped && this.mediaStream) this.publishLatest(state);
        }
    }
}
class $0bdbfad2e9cec567$export$1faf96f9e9ef8965 {
    constructor({ findTarget: findTarget, canDraw: canDraw = ()=>true, onWarning: onWarning = console.warn }){
        this.findTarget = findTarget;
        this.canDraw = canDraw;
        this.onWarning = onWarning;
        this.tracks = new Map();
    }
    receive(channel, payload) {
        if (payload[0] === (0, $a4e644bcc40f18c3$export$c9266b590ec1334)) this.configure(channel, (0, $a4e644bcc40f18c3$export$e0e9438c5e13b45f)(payload));
        else if (payload[0] === (0, $a4e644bcc40f18c3$export$78c1f9c2a475c2fb)) this.decode(channel, payload);
    }
    configure(channel, config) {
        if (!globalThis.VideoDecoder) throw new Error("This browser does not support WebCodecs video decoding.");
        if (!this.findTarget(channel)) return;
        const signature = JSON.stringify(config);
        const existing = this.tracks.get(channel);
        if (existing?.signature === signature && existing.decoder.state !== "closed") return;
        this.close(channel);
        const decoder = new VideoDecoder({
            output: (frame)=>this.render(channel, frame),
            error: (error)=>this.onWarning("[conference] video decoder failed", {
                    channel: channel,
                    error: error
                })
        });
        const decoderConfig = {
            codec: config.codec,
            codedWidth: config.width,
            codedHeight: config.height
        };
        if (config.description) decoderConfig.description = (0, $a4e644bcc40f18c3$export$c537b38001c583b7)(config.description).buffer;
        decoder.configure(decoderConfig);
        this.tracks.set(channel, {
            decoder: decoder,
            signature: signature,
            timings: new Map(),
            pendingFrame: undefined,
            pendingTiming: undefined,
            presentFrameId: undefined
        });
    }
    decode(channel, payload) {
        const track = this.tracks.get(channel);
        if (!track?.decoder || track.decoder.state === "closed") return;
        const frame = (0, $a4e644bcc40f18c3$export$c7f002ae1f88eb6f)(payload);
        if (!frame) return;
        // Behind live edge: keep only keyframes until the decoder catches up.
        if (track.decoder.decodeQueueSize > 1 && !frame.keyFrame) return;
        const chunk = new EncodedVideoChunk({
            type: frame.keyFrame ? "key" : "delta",
            timestamp: frame.timestamp,
            duration: frame.duration,
            data: frame.data
        });
        track.timings.set(chunk.timestamp, {
            encodedAt: frame.encodedAt,
            receivedAt: Date.now() * 1000
        });
        if (track.timings.size > 64) track.timings.delete(track.timings.keys().next().value);
        try {
            track.decoder.decode(chunk);
        } catch (error) {
            this.onWarning("[conference] dropped video packet", {
                channel: channel,
                error: error
            });
        }
    }
    /**
   * Live edge: coalesce decoder output to one paint per screen frame.
   * Older pending frames are dropped instead of queued for playback.
   * @param {string} channel
   * @param {VideoFrame} frame
   */ render(channel, frame) {
        const target = this.findTarget(channel);
        const track = this.tracks.get(channel);
        if (!target || !track) {
            frame.close();
            return;
        }
        this.enqueuePresent(channel, frame, track.timings.get(frame.timestamp));
    }
    /** Keeps only the newest decoded frame; schedules one rAF paint per channel. */ enqueuePresent(channel, frame, timing) {
        const track = this.tracks.get(channel);
        if (!track) {
            frame.close();
            return;
        }
        if (track.pendingFrame) track.pendingFrame.close();
        track.pendingFrame = frame;
        track.pendingTiming = timing;
        if (track.presentFrameId !== undefined) return;
        track.presentFrameId = window.requestAnimationFrame(()=>{
            track.presentFrameId = undefined;
            this.presentLatest(channel);
        });
    }
    /** Paints the latest coalesced frame for this channel. */ presentLatest(channel) {
        const track = this.tracks.get(channel);
        if (!track?.pendingFrame) return;
        const frame = track.pendingFrame;
        const timing = track.pendingTiming;
        track.pendingFrame = undefined;
        track.pendingTiming = undefined;
        this.drawFrame(channel, frame, timing);
    }
    drawFrame(channel, frame, timing) {
        try {
            const target = this.findTarget(channel);
            const track = this.tracks.get(channel);
            if (!target || !track || track.decoder.state === "closed") return;
            if (target.participantId && !this.canDraw(target.participantId)) return;
            const { canvas: canvas, tile: tile } = target;
            if (canvas.width !== frame.displayWidth || canvas.height !== frame.displayHeight) {
                canvas.width = frame.displayWidth;
                canvas.height = frame.displayHeight;
            }
            canvas.getContext("2d", {
                alpha: false
            }).drawImage(frame, 0, 0, canvas.width, canvas.height);
            if (timing) {
                track.timings.delete(frame.timestamp);
                const now = Date.now() * 1000;
                tile.title = `video: encode ${Math.round((timing.encodedAt - frame.timestamp) / 1000)} ms \xb7 transport ${Math.round((timing.receivedAt - timing.encodedAt) / 1000)} ms \xb7 decode ${Math.round((now - timing.receivedAt) / 1000)} ms`;
            }
        } finally{
            frame.close();
        }
    }
    close(channel) {
        const track = this.tracks.get(channel);
        if (!track) return;
        if (track.presentFrameId !== undefined) window.cancelAnimationFrame(track.presentFrameId);
        if (track.pendingFrame) track.pendingFrame.close();
        this.tracks.delete(channel);
        if (track.decoder.state === "closed") return;
        try {
            track.decoder.close();
        } catch (error) {
            this.onWarning("[conference] video decoder close failed", {
                channel: channel,
                error: error
            });
        }
    }
    closeAll() {
        for (const channel of [
            ...this.tracks.keys()
        ])this.close(channel);
    }
}


class $3b2b0f3d639f637a$export$4fa144f6e3d186ad {
    constructor({ ui: ui, chat: chat }){
        this.ui = ui;
        this.chat = chat;
        // View settings, not DOM elements. A future UI can reuse this controller.
        this.highMode = "auto";
        this.lowMode = "auto";
        /** Чей high смотрим: solo/fullscreen. Пусто = все плитки low. */ this.viewHighParticipantId = "";
        this.highStopTimer = undefined;
        this.participantMedia = new Map();
        this.audioDiagnostics = (0, $ea71a0b4b5f3b38e$export$61a68d4025b3028d)();
        this.microphoneSpeaking = false;
        this.reconcileMediaFrame = undefined;
        /** Empty string — system default microphone. */ this.selectedMicId = (0, $be84addac8871937$export$1f13b6c27149433e);
        /** Preferred video source: camera or desktop (not both at once). */ this.preferredVideoSource = "camera";
        /** Active published video source: none, camera, or desktop. */ this.activeVideoSource = "none";
        this.edgeLabel = "";
        this.linkQualityLabel = "ws rtt \u2026";
        this.linkQualityTimer = undefined;
        this.selectedEdgeApiBase = "";
        this.tokenRefreshHandle = null;
    }
    /**
   * Слушатель просит high этого участника (solo или fullscreen).
   * Плитки сетки — всегда low.
   * @param {string} participantId
   */ setVideoViewDemand(participantId) {
        const selfId = this.joined?.participant?.participant_id;
        const id = participantId && participantId !== selfId ? participantId : "";
        if (this.viewHighParticipantId === id) return;
        this.viewHighParticipantId = id;
        this.participantStateHub?.setLocal({
            wantVideoHigh: id
        });
        this.scheduleReconcileMediaSubscriptions();
    }
    async enableRemoteAudio() {
        const state = await this.audioMixer.enable();
        const enabled = state === "running";
        this.ui.setAudioEnabled(enabled);
        if (enabled) this.disarmAudioPlayback();
        if (!enabled) this.ui.setMediaNote("Audio playback is ready; the browser will unlock it on your next click or key press.");
        return enabled;
    }
    setParticipantVolume(participantId, volume) {
        const policy = this.policyFor(participantId);
        policy.volume = volume;
        this.audioMixer.setVolume(this.audioTransport.audioChannel(this.privatePrefixForId(participantId)), volume);
        this.ui.setParticipantMedia(participantId, {
            volume: volume
        });
    }
    setParticipantMuted(participantId, muted) {
        const policy = this.policyFor(participantId);
        policy.muted = muted;
        this.audioMixer.setMuted(this.audioTransport.audioChannel(this.privatePrefixForId(participantId)), muted);
        this.ui.setParticipantMedia(participantId, {
            muted: muted
        });
    }
    policyFor(participantId) {
        let policy = this.participantMedia.get(participantId);
        if (!policy) {
            policy = {
                volume: 1,
                muted: false
            };
            this.participantMedia.set(participantId, policy);
        }
        return policy;
    }
    async setVideoModes({ highMode: highMode, lowMode: lowMode }) {
        this.highMode = highMode;
        this.lowMode = lowMode;
        await this.restartVideoPublishing();
    }
    async createConference({ title: title, chatPolicy: chatPolicy, displayName: displayName }) {
        this.ui.setStatus("creating meeting\u2026", true);
        const response = await fetch("/api/v1/demo/conference/conferences", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                title: title,
                chat_policy: chatPolicy
            })
        });
        if (!response.ok) throw new Error(await response.text());
        const created = await response.json();
        this.ui.showLinks(created);
        await this.connect("admin", {
            conferenceId: created.conference_id,
            ownerSecret: created.owner_secret,
            displayName: displayName
        });
    }
    async joinConference(kind, details) {
        await this.connect(kind, details);
    }
    /** Bootstrap FastPubSub, acquire a scoped token, then enter the room. */ async connect(kind, details) {
        this.ui.setStatus("bootstrap: choosing nearest edge\u2026", true);
        const configResponse = await fetch("/api/v1/demo/conference/config");
        if (!configResponse.ok) throw new Error(`conference config ${configResponse.status}`);
        const config = await configResponse.json();
        this.session = (0, $20120b594434c913$export$3ce6949f20cea765)(config.overlay);
        const edge = await this.session.resolveEdge({
            cache: "prefer"
        });
        this.selectedEdgeApiBase = edge.candidate.apiBase;
        const endpoint = kind === "admin" ? `/api/v1/demo/conference/conferences/${encodeURIComponent(details.conferenceId)}/admin/join` : `/api/v1/demo/conference/invites/${encodeURIComponent(details.inviteId)}/join`;
        const body = {
            api_base: edge.candidate.apiBase,
            display_name: details.displayName
        };
        if (kind === "admin") body.owner_secret = details.ownerSecret;
        const response = await fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) throw new Error(await response.text());
        this.joined = await response.json();
        this.ownerSecret = kind === "admin" ? details.ownerSecret : undefined;
        this.roomClosed = false;
        this.roomState = this.joined.conference;
        this.resetAudioDiagnostics();
        this.client = await (0, $4a68f02554b6f92a$export$b27848052134e8d9)(this.session.webSocket(this.joined.token).addFilter(this.joined.tenant, "private.", new (0, $7e363819e496eacf$export$f1345d679fe06355)(49152, 16384)).filterTimerMode("lowLatency200Hz")).build();
        this.initialiseVideoStack();
        this.participantStateHub = new (0, $4e04d6614c3f1e48$export$894a04b4104f8ba1)({
            client: this.client,
            tenant: this.joined.tenant,
            channelRole: this.channelRole(this.joined.participant),
            participantId: this.joined.participant.participant_id,
            onRemoteUpdate: ()=>this.onParticipantStateUpdate(),
            onRoomClosed: ()=>this.onConferenceClosedByHost(),
            onWarning: (message, error)=>console.warn(message, error)
        });
        this.participantStateHub.start();
        this.armAudioPlayback();
        this.enableRemoteAudio().catch((error)=>{
            this.ui.setAudioEnabled(false);
            this.ui.setMediaNote(`Audio playback waits for browser permission: ${$3b2b0f3d639f637a$var$friendlyError(error)}`);
        });
        this.chat.start(this.client, this.joined.tenant, this.chatTransport());
        this.startAuthoritySubscription();
        this.ui.showConference(this.joined.conference, this.joined.media_publish_allowed);
        this.renderRoom(this.roomState);
        this.edgeLabel = `${edge.candidate.id} (edge ${Math.round(edge.pingMs)} ms)`;
        this.startLinkQualityTimer();
        this.armSoftTokenRefresh(this.joined.expires_in_sec);
        this.refreshConnectionStatus();
        this.roomUiTimer = window.setInterval(()=>this.refreshRoomUi(), 1000);
    }
    /**
   * Soft-extends meeting AT via demo-server; keeps the open WebSocket.
   * @param {number} expiresInSec
   */ armSoftTokenRefresh(expiresInSec) {
        this.tokenRefreshHandle?.clear();
        if (!expiresInSec || !this.joined?.token) return;
        this.tokenRefreshHandle = (0, $fa2092c4b630b570$export$3de77490d9b87c4a)({
            expiresInSec: expiresInSec,
            refresh: async ()=>{
                const response = await fetch("/api/v1/demo/conference/token/refresh", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        api_base: this.selectedEdgeApiBase,
                        token: this.joined.token
                    })
                });
                if (!response.ok) throw new Error(await response.text());
                const body = await response.json();
                this.joined.token = body.token;
                this.joined.expires_in_sec = body.expires_in_sec;
                return body;
            },
            onSoftOk: ()=>{
                console.info("[conference] AT soft refreshed");
            },
            onError: (error)=>{
                console.warn("[conference] AT soft refresh failed", error);
                this.ui.setStatus(`token refresh failed: ${error.message}`, false);
            }
        });
    }
    /** Polls WS link quality and refreshes the header status every 3 seconds. */ startLinkQualityTimer() {
        if (this.linkQualityTimer) window.clearInterval(this.linkQualityTimer);
        const tick = ()=>{
            if (!this.client || this.roomClosed) return;
            this.linkQualityLabel = (0, $4a68f02554b6f92a$export$22b6e3e09e7618e1)((0, $4a68f02554b6f92a$export$9da51ec074aeac90)(this.client));
            this.refreshConnectionStatus();
        };
        tick();
        this.linkQualityTimer = window.setInterval(tick, (0, $4a68f02554b6f92a$export$35c5df7872f016f3));
    }
    refreshConnectionStatus() {
        if (!this.edgeLabel || this.roomClosed) return;
        this.ui.setStatus(`connected \xb7 ${this.edgeLabel} \xb7 ${this.linkQualityLabel}`, true);
    }
    initialiseVideoStack() {
        this.videoReceiver = new (0, $0bdbfad2e9cec567$export$1faf96f9e9ef8965)({
            findTarget: (channel)=>this.ui.remoteVideoTarget(channel),
            canDraw: (participantId)=>this.participantCameraOn(participantId),
            onWarning: console.warn
        });
        this.audioMixer = new (0, $e400ff737ae715d5$export$67e0b939433eb50c)({
            onState: ({ label: label })=>this.ui.setMediaNote(label),
            onAudioDiagnostic: (event)=>this.recordAudioDiagnostic(event),
            onWarning: console.warn
        });
        this.audioReceiver = new (0, $f429fc0865f65f35$export$7a7e4cdc1e0ebfe0)({
            onAudioData: (channel, audioData)=>{
                this.audioMixer.play(channel, audioData);
            },
            onAudioDiagnostic: (event)=>this.recordAudioDiagnostic(event),
            onWarning: console.warn
        });
        this.videoTransport = new (0, $28fbb5f918dda4ef$export$6715a103814e8e69)({
            client: this.client,
            tenant: this.joined.tenant,
            subjectPrefix: this.privatePrefix(this.joined.participant),
            onVideoPacket: (channel, payload)=>this.videoReceiver.receive(channel, payload),
            onWarning: console.warn
        });
        this.audioTransport = new (0, $d112d830ad738fba$export$d3034648954c075c)({
            client: this.client,
            tenant: this.joined.tenant,
            subjectPrefix: this.privatePrefix(this.joined.participant),
            onAudioPacket: (channel, payload)=>this.audioReceiver.receive(channel, payload),
            onAudioDiagnostic: (event)=>this.recordAudioDiagnostic(event),
            onWarning: console.warn
        });
        this.videoPublisher = new (0, $0bdbfad2e9cec567$export$b4afc42873b6fcf5)({
            publishPacket: (quality, payload)=>this.videoTransport.publishVideo(quality, payload),
            onError: (error, quality)=>{
                console.error("[conference] video pipeline failed", {
                    quality: quality,
                    error: error
                });
                this.ui.setStatus(`camera error: ${$3b2b0f3d639f637a$var$friendlyError(error)}`, false);
            },
            onState: ({ labels: labels })=>this.ui.setMediaNote(`Publishing ${labels.join(" \xb7 ")} through FastPubSub.`)
        });
        this.desktopPublisher = new (0, $7100ca349f5db080$export$5187cd80f22549a0)({
            publishPacket: (quality, payload)=>this.videoTransport.publishVideo(quality, payload),
            onError: (error)=>{
                console.error("[conference] desktop share failed", error);
                this.ui.setStatus(`desktop error: ${$3b2b0f3d639f637a$var$friendlyError(error)}`, false);
            },
            onState: ({ label: label })=>this.ui.setMediaNote(`Publishing ${label} through FastPubSub.`),
            onEnded: ()=>{
                if (this.activeVideoSource === "desktop") this.stopDesktop();
            }
        });
        this.audioPublisher = new (0, $f429fc0865f65f35$export$ef60a77e87a15e80)({
            publishPacket: (payload)=>this.audioTransport.publishAudio(payload),
            voiceActivated: false,
            onSpeaking: (speaking)=>{
                this.microphoneSpeaking = speaking;
                this.ui.setMicrophoneSpeaking(speaking);
                this.participantStateHub?.setLocal({
                    speaking: speaking
                });
            },
            onDiagnostic: (event)=>this.recordAudioDiagnostic(event),
            onError: (error)=>this.ui.setStatus(`microphone error: ${$3b2b0f3d639f637a$var$friendlyError(error)}`, false),
            onState: ({ label: label })=>this.ui.setMediaNote(`Publishing camera + ${label} through FastPubSub.`)
        });
    }
    renderRoom(snapshot) {
        this.roomState = snapshot;
        if (snapshot.closed) {
            this.onConferenceClosedByHost();
            return;
        }
        this.applyRoomToUi();
        this.scheduleReconcileMediaSubscriptions();
    }
    /** Хост закрыл комнату: стоп медиа и на стартовый экран /demo/conference. */ onConferenceClosedByHost() {
        if (this.roomClosed) return;
        this.stopMediaForClosedRoom();
        this.ui.exitRoom("conference closed by its owner");
    }
    /** Room for UI: online/offline from public.*.state heartbeats, not HTTP. */ buildRoomViewForUi() {
        const participants = {};
        for (const [participantId, participant] of Object.entries(this.roomState.participants))participants[participantId] = {
            ...participant,
            status: this.participantPresenceOnline(participantId) ? "online" : "offline"
        };
        for (const participantId of this.participantStateHub?.onlineParticipantIds() ?? []){
            if (participants[participantId]) continue;
            const state = this.participantStateHub.remoteState(participantId);
            participants[participantId] = {
                participant_id: participantId,
                display_name: participantId,
                role: state.channelRole || "participant",
                status: "online"
            };
        }
        return {
            ...this.roomState,
            participants: participants
        };
    }
    /** Participant online: local while in session; remote via public.*.state at 1 Hz. */ participantPresenceOnline(participantId) {
        if (participantId === this.joined.participant.participant_id) return !this.roomClosed;
        return this.participantStateHub?.participantOnline(participantId) ?? false;
    }
    applyRoomToUi() {
        this.ui.renderRoom(this.buildRoomViewForUi(), this.joined.participant.participant_id);
        this.refreshParticipantStateUi();
    }
    /** Once per second: public.*.state staleness and UI refresh. */ refreshRoomUi() {
        this.refreshParticipantStateUi();
        if (!this.roomState || this.roomClosed) return;
        this.ui.renderRoom(this.buildRoomViewForUi(), this.joined.participant.participant_id);
        this.scheduleReconcileMediaSubscriptions();
        this.syncHighPublishing();
    }
    onParticipantStateUpdate() {
        if (!this.roomState || this.roomClosed) return;
        this.ui.renderRoom(this.buildRoomViewForUi(), this.joined.participant.participant_id);
        this.refreshParticipantStateUi();
        this.scheduleReconcileMediaSubscriptions();
        this.syncHighPublishing();
    }
    /** Waits for Preact to mount tiles before subscribing to remote video. */ scheduleReconcileMediaSubscriptions() {
        if (this.reconcileMediaFrame) return;
        this.reconcileMediaFrame = window.requestAnimationFrame(()=>{
            this.reconcileMediaFrame = undefined;
            this.reconcileMediaSubscriptions();
        });
    }
    stopMediaForClosedRoom() {
        if (this.roomClosed) return;
        this.roomClosed = true;
        if (this.highStopTimer) {
            window.clearTimeout(this.highStopTimer);
            this.highStopTimer = undefined;
        }
        this.videoPublisher?.stop();
        this.desktopPublisher?.stop();
        this.audioPublisher?.stop();
        this.mediaStream?.getTracks().forEach((track)=>track.stop());
        this.mediaStream = undefined;
        this.videoReceiver?.closeAll();
        this.audioReceiver?.closeAll();
        this.videoTransport?.stop();
        this.audioTransport?.stop();
        this.audioMixer?.close();
        this.disarmAudioPlayback();
        this.chat.stop();
        this.participantStateHub?.setOffline();
        this.participantStateHub?.stop();
        if (this.reconcileMediaFrame) {
            window.cancelAnimationFrame(this.reconcileMediaFrame);
            this.reconcileMediaFrame = undefined;
        }
        window.clearInterval(this.roomUiTimer);
        window.clearInterval(this.linkQualityTimer);
        this.linkQualityTimer = undefined;
        this.tokenRefreshHandle?.clear();
        this.tokenRefreshHandle = null;
        this.client?.close();
        this.client = undefined;
    }
    /** Updates participant state panel and video placeholders. */ refreshParticipantStateUi() {
        if (!this.participantStateHub) return;
        const participantState = this.buildParticipantStateView();
        this.ui.setParticipantState(participantState);
        this.ui.syncParticipantVideoPlaceholders(participantState);
    }
    /** Local + remote state for UI. */ buildParticipantStateView() {
        const participantState = this.participantStateHub.snapshot();
        participantState[this.joined.participant.participant_id] = {
            camera: this.hasLiveTrack("video"),
            microphone: this.hasLiveTrack("audio"),
            speaking: this.microphoneSpeaking,
            videoSource: this.activeVideoSource,
            stale: false,
            ageMs: 0,
            local: true
        };
        return participantState;
    }
    /** Camera on per public.*.state (1 Hz), not HTTP authority. */ participantCameraOn(participantId) {
        if (participantId === this.joined.participant.participant_id) return this.hasLiveTrack("video");
        return this.participantStateHub?.participantCameraOn(participantId) ?? false;
    }
    /** Microphone on per public.*.state. */ participantMicrophoneOn(participantId) {
        if (participantId === this.joined.participant.participant_id) return this.hasLiveTrack("audio");
        return this.participantStateHub?.participantMicrophoneOn(participantId) ?? false;
    }
    /** Качество подписки: плитки low, solo/fullscreen high, desktop всегда high. */ remoteVideoQuality(participantId) {
        if (participantId === this.joined.participant.participant_id) return this.activeVideoSource === "desktop" ? "high" : "low";
        if (this.participantStateHub?.participantVideoSource(participantId) === "desktop") return "high";
        if (this.viewHighParticipantId === participantId) return "high";
        return "low";
    }
    /** Subscribe to video/audio for participants seen alive on public.*.state. */ reconcileMediaSubscriptions() {
        if (!this.videoTransport && !this.audioTransport || !this.roomState || this.roomClosed) return;
        const wantedChannels = new Set();
        for (const participantId of this.participantStateHub?.onlineParticipantIds() ?? []){
            const prefix = this.participantStateHub.privatePrefixFor(participantId);
            if (!prefix || !this.remoteCanPublishMedia(participantId, prefix)) continue;
            const quality = this.remoteVideoQuality(participantId);
            if (this.participantVideoOn(participantId) && quality !== "off") wantedChannels.add(this.videoTransport.videoChannel(prefix, quality));
        }
        const staleVideoChannels = [];
        for (const channel of this.videoTransport.subscriptions.keys())if (!wantedChannels.has(channel)) staleVideoChannels.push(channel);
        this.videoTransport.syncSubscriptions(wantedChannels);
        for (const channel of staleVideoChannels)this.videoReceiver.close(channel);
        for (const channel of [
            ...this.videoReceiver.tracks.keys()
        ])if (!wantedChannels.has(channel)) this.videoReceiver.close(channel);
        const audioPrefixes = (this.participantStateHub?.onlineParticipantIds() ?? []).map((participantId)=>({
                participantId: participantId,
                prefix: this.participantStateHub.privatePrefixFor(participantId)
            })).filter((item)=>item.prefix && this.remoteCanPublishMedia(item.participantId, item.prefix) && this.participantMicrophoneOn(item.participantId)).map((item)=>item.prefix);
        for (const channel of this.audioTransport.subscriptions.keys())if (!audioPrefixes.some((prefix)=>channel === this.audioTransport.audioChannel(prefix))) {
            this.audioReceiver.close(channel);
            this.audioMixer.remove(channel);
        }
        this.audioTransport.syncSubscriptions(audioPrefixes);
    }
    async toggleCamera() {
        await this.toggleVideo();
    }
    /**
   * Select video source. Stops publishing if something is already live.
   * @param {"camera"|"desktop"} source
   */ setPreferredVideoSource(source) {
        if (source !== "camera" && source !== "desktop") return;
        if (this.preferredVideoSource === source) return;
        this.preferredVideoSource = source;
        this.ui.setPreferredVideoSource(source);
        if (this.hasLiveTrack("video")) this.stopVideo();
    }
    async toggleVideo() {
        if (this.hasLiveTrack("video")) {
            this.stopVideo();
            return;
        }
        if (this.preferredVideoSource === "desktop") await this.startDesktop();
        else await this.startCamera();
    }
    stopVideo() {
        if (this.activeVideoSource === "desktop") this.stopDesktop();
        else if (this.activeVideoSource === "camera") this.stopCamera();
    }
    participantVideoOn(participantId) {
        if (participantId === this.joined.participant.participant_id) return this.hasLiveTrack("video");
        return this.participantStateHub?.participantVideoOn(participantId) ?? false;
    }
    async toggleMicrophone() {
        if (this.hasLiveTrack("audio")) this.stopMicrophone();
        else await this.startMicrophone();
    }
    /**
   * Select microphone. Empty deviceId restores the system default.
   * Restarts capture when the microphone is already enabled.
   * @param {string} deviceId
   */ async setMicrophoneDevice(deviceId) {
        const nextId = deviceId || (0, $be84addac8871937$export$1f13b6c27149433e);
        if (nextId === this.selectedMicId) return;
        this.selectedMicId = nextId;
        if (this.hasLiveTrack("audio")) {
            this.stopMicrophone();
            await this.startMicrophone();
        }
    }
    async startCamera() {
        try {
            this.stopVideo();
            if (!navigator.mediaDevices?.getUserMedia) {
                const reason = window.isSecureContext ? "Browser does not provide the MediaDevices camera API." : "Camera access requires HTTPS (or http://localhost).";
                throw new Error(reason);
            }
            if (!globalThis.VideoEncoder || !globalThis.VideoDecoder) throw new Error("This browser does not support WebCodecs video.");
            const capture = await navigator.mediaDevices.getUserMedia({
                video: {
                    width: {
                        ideal: 1280
                    },
                    height: {
                        ideal: 720
                    },
                    frameRate: {
                        ideal: 30
                    }
                },
                audio: false
            });
            this.addTracks(capture.getVideoTracks());
            const preview = await this.ui.showLocalStream(this.mediaStream);
            await this.startVideoPublishing(preview);
            this.activeVideoSource = "camera";
            this.ui.setVideoPublishing(true, "camera");
            this.participantStateHub?.setLocal({
                camera: true,
                videoSource: "camera"
            });
        } catch (error) {
            this.videoPublisher?.stop();
            this.stopTracks("video");
            this.ui.clearLocalStream();
            this.activeVideoSource = "none";
            this.ui.setVideoPublishing(false, "none");
            this.participantStateHub?.setLocal({
                camera: false,
                videoSource: "none"
            });
            this.ui.setStatus(`camera error: ${$3b2b0f3d639f637a$var$friendlyError(error)}`, false);
        }
    }
    stopCamera() {
        this.videoPublisher?.stop();
        this.stopTracks("video");
        this.ui.clearLocalStream();
        this.activeVideoSource = "none";
        this.ui.setVideoPublishing(false, "none");
        this.participantStateHub?.setLocal({
            camera: false,
            videoSource: "none"
        });
        this.scheduleReconcileMediaSubscriptions();
    }
    async startDesktop() {
        try {
            this.stopVideo();
            if (!globalThis.VideoEncoder || !globalThis.VideoDecoder) throw new Error("This browser does not support WebCodecs video.");
            const capture = await (0, $0f1ac663850663d8$export$8ea5fb8750bab5cc)();
            this.addTracks(capture.getVideoTracks());
            const preview = await this.ui.showLocalStream(this.mediaStream);
            await this.desktopPublisher.start({
                mediaStream: this.mediaStream,
                preview: preview
            });
            this.activeVideoSource = "desktop";
            this.ui.setVideoPublishing(true, "desktop");
            this.participantStateHub?.setLocal({
                camera: true,
                videoSource: "desktop"
            });
        } catch (error) {
            this.desktopPublisher?.stop();
            this.stopTracks("video");
            this.ui.clearLocalStream();
            this.activeVideoSource = "none";
            this.ui.setVideoPublishing(false, "none");
            this.participantStateHub?.setLocal({
                camera: false,
                videoSource: "none"
            });
            if (error?.name !== "NotAllowedError") this.ui.setStatus(`desktop error: ${$3b2b0f3d639f637a$var$friendlyError(error)}`, false);
        }
    }
    stopDesktop() {
        this.desktopPublisher?.stop();
        this.stopTracks("video");
        this.ui.clearLocalStream();
        this.activeVideoSource = "none";
        this.ui.setVideoPublishing(false, "none");
        this.participantStateHub?.setLocal({
            camera: false,
            videoSource: "none"
        });
        this.scheduleReconcileMediaSubscriptions();
    }
    async startMicrophone() {
        try {
            if (!navigator.mediaDevices?.getUserMedia) throw new Error("Microphone access requires HTTPS and the MediaDevices API.");
            await this.enableRemoteAudio();
            const capture = await navigator.mediaDevices.getUserMedia((0, $be84addac8871937$export$c74060dcd916f433)(this.selectedMicId));
            this.addTracks(capture.getAudioTracks());
            await this.audioPublisher.start(this.mediaStream);
            this.ui.setMicrophoneEnabled(true);
            this.microphoneSpeaking = false;
            this.ui.setMicrophoneSpeaking(false);
            this.participantStateHub?.setLocal({
                microphone: true,
                speaking: false
            });
        } catch (error) {
            this.audioPublisher?.stop();
            this.stopTracks("audio");
            this.microphoneSpeaking = false;
            this.ui.setMicrophoneSpeaking(false);
            this.participantStateHub?.setLocal({
                microphone: false,
                speaking: false
            });
            this.ui.setStatus(`microphone error: ${$3b2b0f3d639f637a$var$friendlyError(error)}`, false);
        }
    }
    stopMicrophone() {
        this.audioPublisher?.stop();
        this.stopTracks("audio");
        this.ui.setMicrophoneEnabled(false);
        this.microphoneSpeaking = false;
        this.ui.setMicrophoneSpeaking(false);
        this.participantStateHub?.setLocal({
            microphone: false,
            speaking: false
        });
        this.scheduleReconcileMediaSubscriptions();
    }
    addTracks(tracks) {
        if (!this.mediaStream) this.mediaStream = new MediaStream();
        for (const track of tracks)this.mediaStream.addTrack(track);
    }
    stopTracks(kind) {
        const tracks = kind === "video" ? this.mediaStream?.getVideoTracks() : this.mediaStream?.getAudioTracks();
        for (const track of tracks || []){
            track.stop();
            this.mediaStream.removeTrack(track);
        }
        if (!this.mediaStream?.getTracks().length) this.mediaStream = undefined;
    }
    hasLiveTrack(kind) {
        const tracks = kind === "video" ? this.mediaStream?.getVideoTracks() : this.mediaStream?.getAudioTracks();
        return Boolean(tracks?.some((track)=>track.readyState === "live"));
    }
    async restartVideoPublishing() {
        if (!this.hasLiveTrack("video") || this.activeVideoSource !== "camera") return;
        try {
            this.videoPublisher.stop();
            await this.startVideoPublishing(this.ui.localVideo());
        } catch (error) {
            this.ui.setStatus(`camera error: ${$3b2b0f3d639f637a$var$friendlyError(error)}`, false);
        }
    }
    async startVideoPublishing(preview) {
        const lowMode = (0, $6ce98e86537e26d8$export$40105d0178b236dd)[this.lowMode] || (0, $6ce98e86537e26d8$export$40105d0178b236dd).auto;
        await this.videoPublisher.start({
            mediaStream: this.mediaStream,
            preview: preview,
            modes: [
                {
                    quality: "low",
                    ...lowMode
                }
            ]
        });
        await this.syncHighPublishing();
    }
    /**
   * High-энкодер камеры только если кто-то просит (solo/fullscreen).
   * Выключение с паузой 1.5 с, чтобы не дёргать при коротком клике.
   */ async syncHighPublishing() {
        if (this.activeVideoSource !== "camera" || !this.videoPublisher || this.roomClosed) return;
        const me = this.joined?.participant?.participant_id;
        const want = Boolean(me && this.participantStateHub?.someoneWantsHigh(me));
        if (want) {
            if (this.highStopTimer) {
                window.clearTimeout(this.highStopTimer);
                this.highStopTimer = undefined;
            }
            if (this.videoPublisher.hasMode("high")) return;
            const highMode = (0, $6ce98e86537e26d8$export$e5ce0b90cfc7c793)[this.highMode] || (0, $6ce98e86537e26d8$export$e5ce0b90cfc7c793).auto;
            try {
                await this.videoPublisher.addMode({
                    quality: "high",
                    ...highMode
                });
            } catch (error) {
                this.ui.setStatus(`camera error: ${$3b2b0f3d639f637a$var$friendlyError(error)}`, false);
            }
            return;
        }
        if (!this.videoPublisher.hasMode("high") || this.highStopTimer) return;
        this.highStopTimer = window.setTimeout(()=>{
            this.highStopTimer = undefined;
            if (this.participantStateHub?.someoneWantsHigh(this.joined?.participant?.participant_id)) {
                this.syncHighPublishing();
                return;
            }
            this.videoPublisher?.stopMode("high");
        }, 1500);
    }
    async startAuthoritySubscription() {
        const queue = await this.client.subscribe(this.joined.tenant, "authority.#");
        while(this.client){
            const message = await queue.recv();
            if (!message) break;
            try {
                const event = JSON.parse(new TextDecoder().decode(message.payload));
                if (event.type === "conference_closed" || event.conference?.closed) {
                    this.onConferenceClosedByHost();
                    continue;
                }
                if (event.type === "conference_state" && event.conference?.version >= this.roomState.version) this.renderRoom(event.conference);
            } catch  {
            // Ignore malformed authority events.
            }
        }
    }
    async sendChat(text) {
        await this.chat.send(this.joined.participant, text);
    }
    async closeConference() {
        if (!this.ownerSecret) throw new Error("Only the conference owner can close this room.");
        const response = await fetch(this.conferencePath("close"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                owner_secret: this.ownerSecret
            })
        });
        if (!response.ok) throw new Error(await response.text());
        const snapshot = await response.json();
        // Сначала в канал гостям (свой открытый WS), потом себе на стартовый экран.
        try {
            await this.participantStateHub?.publishRoomClosed(snapshot.conference_id);
        } catch (error) {
            console.warn("[conference] room closed publish failed", error);
        }
        this.renderRoom(snapshot);
    }
    leave() {
        if (!this.joined) return;
        if (this.highStopTimer) {
            window.clearTimeout(this.highStopTimer);
            this.highStopTimer = undefined;
        }
        this.videoPublisher?.stop();
        this.desktopPublisher?.stop();
        this.audioPublisher?.stop();
        this.mediaStream?.getTracks().forEach((track)=>track.stop());
        this.mediaStream = undefined;
        this.videoReceiver?.closeAll();
        this.audioReceiver?.closeAll();
        this.videoTransport?.stop();
        this.audioTransport?.stop();
        this.audioMixer?.close();
        this.disarmAudioPlayback();
        this.chat.stop();
        this.participantStateHub?.setOffline();
        this.participantStateHub?.stop();
        window.clearInterval(this.roomUiTimer);
        window.clearInterval(this.linkQualityTimer);
        this.linkQualityTimer = undefined;
        this.tokenRefreshHandle?.clear();
        this.tokenRefreshHandle = null;
        this.client?.close();
        this.client = undefined;
    }
    conferencePath(suffix) {
        const conferenceId = encodeURIComponent(this.joined.conference.conference_id);
        return `/api/v1/demo/conference/conferences/${conferenceId}/${suffix}`;
    }
    privatePrefixForId(participantId) {
        const participant = this.roomState?.participants?.[participantId];
        if (participant) return this.privatePrefix(participant);
        const fromState = this.participantStateHub?.privatePrefixFor(participantId);
        if (fromState) return fromState;
        throw new Error(`participant ${participantId} is not in the room state`);
    }
    privatePrefix(participant) {
        return `private.${this.channelRole(participant)}.${participant.participant_id}`;
    }
    /** Role segment in subject paths — meeting mode always uses participant. */ channelRole(_participant) {
        return "participant";
    }
    /** Whether a remote prefix may publish media. */ remoteCanPublishMedia(participantId, prefix) {
        const role = prefix.split(".")[1];
        if (role !== "participant") return false;
        const participant = this.roomState.participants[participantId];
        if (participant) return this.participantCanPublishMedia(participant);
        return true;
    }
    participantCanPublishMedia(_participant) {
        return true;
    }
    chatTransport() {
        const prefix = this.privatePrefix(this.joined.participant);
        if (this.roomState.chat_policy === "disabled") return {
            subscribePatterns: [],
            publishChannel: undefined
        };
        return {
            subscribePatterns: [
                "private.*.*.chat.room"
            ],
            publishChannel: `${prefix}.chat.room`
        };
    }
    recordAudioDiagnostic(event) {
        const next = (0, $ea71a0b4b5f3b38e$export$bfd5269466af3b86)(this.audioDiagnostics, event);
        this.audioDiagnostics = next;
        const now = Date.now();
        const pushUi = (0, $ea71a0b4b5f3b38e$export$934800c44d3689d1)(event.type) || !this.audioDiagUiAt || now - this.audioDiagUiAt >= 500;
        if (pushUi) {
            this.audioDiagUiAt = now;
            this.ui.setAudioDiagnostics(next);
        }
        if (next.framePackets > 0 && next.playedFrames === 0 && (!this.audioMixer?.context || this.audioMixer.context.state !== "running")) this.ui.setMediaNote("Remote audio packets are arriving; click anywhere once if the browser has not unlocked playback yet.");
    }
    resetAudioDiagnostics() {
        this.audioDiagnostics = (0, $ea71a0b4b5f3b38e$export$61a68d4025b3028d)();
        this.ui.setAudioDiagnostics(this.audioDiagnostics);
    }
    armAudioPlayback() {
        if (this.audioUnlockHandler) return;
        this.audioUnlockHandler = async ()=>{
            try {
                if (await this.enableRemoteAudio()) this.disarmAudioPlayback();
            } catch (error) {
                this.ui.setMediaNote(`Audio playback unlock failed: ${$3b2b0f3d639f637a$var$friendlyError(error)}`);
            }
        };
        const options = {
            capture: true,
            passive: true
        };
        window.addEventListener("pointerdown", this.audioUnlockHandler, options);
        window.addEventListener("keydown", this.audioUnlockHandler, {
            capture: true
        });
        window.addEventListener("touchstart", this.audioUnlockHandler, options);
    }
    disarmAudioPlayback() {
        if (!this.audioUnlockHandler) return;
        const options = {
            capture: true
        };
        window.removeEventListener("pointerdown", this.audioUnlockHandler, options);
        window.removeEventListener("keydown", this.audioUnlockHandler, options);
        window.removeEventListener("touchstart", this.audioUnlockHandler, options);
        this.audioUnlockHandler = undefined;
    }
}
function $3b2b0f3d639f637a$var$friendlyError(error) {
    return error?.message || String(error);
}



/**
 * Small bridge between the imperative media pipeline and the declarative
 * Preact tree. It owns no markup: it only publishes view state and retains
 * element references that WebCodecs must draw into.
 */ class $fdc9499eb2cdf07a$export$1ce9b561ae32bad2 {
    constructor(updateView){
        this.updateView = updateView;
        this.tileByParticipant = new Map();
        this.canvasByParticipant = new Map();
        this.unknownFrameChannels = new Set();
        this.localStream = undefined;
        this.localVideoElement = undefined;
    }
    patch(change) {
        this.updateView((current)=>({
                ...current,
                ...change
            }));
    }
    setStatus(text, ok) {
        this.patch({
            status: {
                text: text,
                kind: ok ? "ok" : "err"
            }
        });
    }
    setMediaNote(mediaNote) {
        this.patch({
            mediaNote: mediaNote
        });
    }
    setCameraEnabled(cameraEnabled) {
        this.patch({
            cameraEnabled: cameraEnabled
        });
    }
    setCameraButton(capturing) {
        this.patch({
            capturing: capturing
        });
    }
    setPreferredVideoSource(preferredVideoSource) {
        this.patch({
            preferredVideoSource: preferredVideoSource
        });
    }
    setVideoPublishing(capturing, activeVideoSource) {
        this.patch({
            capturing: capturing,
            activeVideoSource: activeVideoSource
        });
    }
    setMicrophoneEnabled(microphoneEnabled) {
        this.patch({
            microphoneEnabled: microphoneEnabled
        });
    }
    setMicrophoneSpeaking(microphoneSpeaking) {
        this.patch({
            microphoneSpeaking: microphoneSpeaking
        });
    }
    setAudioDiagnostics(audioDiagnostics) {
        this.patch({
            audioDiagnostics: audioDiagnostics
        });
    }
    setParticipantMedia(participantId, change) {
        this.updateView((current)=>({
                ...current,
                participantMedia: {
                    ...current.participantMedia,
                    [participantId]: {
                        ...current.participantMedia[participantId],
                        ...change
                    }
                }
            }));
    }
    setAudioEnabled(audioEnabled) {
        this.patch({
            audioEnabled: audioEnabled
        });
    }
    setParticipantState(participantState) {
        this.patch({
            participantState: participantState
        });
    }
    showConference(conference, cameraEnabled) {
        this.patch({
            conference: conference,
            cameraEnabled: cameraEnabled,
            inRoom: true,
            mediaNote: cameraEnabled ? "Publishes 360p and 720p camera tracks through FastPubSub." : "Your role is listen-only; the authority token has no media publish permission."
        });
    }
    /**
   * После закрытия хостом — на стартовую страницу встречи
   * (без invite/admin в URL), как /demo/conference.
   */ exitRoom(message) {
        this.patch({
            inRoom: false,
            conference: undefined,
            room: undefined,
            localParticipantId: undefined,
            cameraEnabled: false,
            capturing: false,
            preferredVideoSource: "camera",
            activeVideoSource: "none",
            audioEnabled: false,
            microphoneEnabled: false,
            microphoneSpeaking: false,
            participantState: {},
            participantMedia: {},
            mediaNote: ""
        });
        this.setStatus(message || "conference closed by its owner", false);
        const start = new URL("/demo/conference", window.location.origin);
        start.searchParams.set("closed", "1");
        window.location.replace(start.href);
    }
    showLinks(created) {
        const invite = new URL("/demo/conference", window.location.origin);
        invite.searchParams.set("invite", created.invite_id);
        const admin = new URL("/demo/conference", window.location.origin);
        admin.searchParams.set("conference", created.conference_id);
        admin.hash = new URLSearchParams({
            owner: created.owner_secret
        }).toString();
        this.patch({
            links: {
                invite: invite.href,
                admin: admin.href
            }
        });
    }
    renderRoom(room, localParticipantId) {
        this.patch({
            room: room,
            localParticipantId: localParticipantId
        });
    }
    setLocalVideoElement(element) {
        // Preact replaces an inline ref by calling the old callback with null
        // before it calls the new one with the *same* element. Do not forget a
        // live preview during that transient null callback.
        if (!element) {
            if (!this.localStream) this.localVideoElement = undefined;
            return;
        }
        this.localVideoElement = element;
        if (this.localStream) this.attachLocalStream(element, this.localStream).catch((error)=>{
            console.warn("[conference] local video preview failed", error);
        });
    }
    setRemoteCanvasElement(participantId, element) {
        if (element) {
            const previous = this.canvasByParticipant.get(participantId);
            if (previous && previous !== element && previous.width > 0) {
                element.width = previous.width;
                element.height = previous.height;
                element.getContext("2d", {
                    alpha: false
                }).drawImage(previous, 0, 0);
            }
            this.canvasByParticipant.set(participantId, element);
            return;
        }
        const current = this.canvasByParticipant.get(participantId);
        if (current && current.isConnected) this.canvasByParticipant.delete(participantId);
    }
    setParticipantTileElement(participantId, element) {
        if (element) this.tileByParticipant.set(participantId, element);
        else {
            const current = this.tileByParticipant.get(participantId);
            if (current && current.isConnected) this.tileByParticipant.delete(participantId);
        }
    }
    async showLocalStream(stream) {
        this.localStream = stream;
        const video = this.localVideo();
        if (!video) throw new Error("The local video tile is not ready yet.");
        await this.attachLocalStream(video, stream);
        return video;
    }
    async attachLocalStream(video, stream) {
        // Assigning an identical srcObject starts a new media load and aborts a
        // pending play() request. Preact may call this more than once per render.
        if (video.srcObject !== stream) video.srcObject = stream;
        try {
            await video.play();
        } catch (error) {
            // An AbortError only means the browser superseded this particular
            // play() request; the next ref/update will issue one for the live stream.
            if (error?.name !== "AbortError") throw error;
        }
    }
    clearLocalStream() {
        this.localStream = undefined;
        if (this.localVideoElement) {
            this.localVideoElement.pause();
            this.localVideoElement.srcObject = null;
        }
    }
    /** Clears remote participant canvas (last frame must not remain). */ clearRemoteCanvas(participantId) {
        const canvas = this.canvasByParticipant.get(participantId);
        if (!canvas) return;
        canvas.width = 0;
        canvas.height = 0;
    }
    /**
   * Syncs placeholders with public.*.state: camera off — clear canvas.
   * @param {Record<string, { camera?: boolean, stale?: boolean }>} participantState
   */ syncParticipantVideoPlaceholders(participantState) {
        for (const [participantId] of this.canvasByParticipant){
            const state = participantState[participantId];
            if (!state || state.stale || !state.camera) this.clearRemoteCanvas(participantId);
        }
    }
    localVideo() {
        return this.localVideoElement;
    }
    /**
   * Canvas and tile for remote video. Creates off-DOM placeholders until Preact
   * mounts the real tile (video may arrive before the first paint).
   */ remoteVideoTarget(channel) {
        const participantId = $fdc9499eb2cdf07a$var$participantIdFromChannel(channel);
        if (!participantId) {
            if (!this.unknownFrameChannels.has(channel)) {
                this.unknownFrameChannels.add(channel);
                console.warn("[conference] received video on an unparseable channel", {
                    channel: channel
                });
            }
            return undefined;
        }
        return this.ensureRemoteTarget(participantId);
    }
    /** Returns canvas + tile refs, creating placeholders when the tile is not mounted yet. */ ensureRemoteTarget(participantId) {
        let canvas = this.canvasByParticipant.get(participantId);
        if (!canvas) {
            canvas = document.createElement("canvas");
            canvas.className = "remote-video";
            this.canvasByParticipant.set(participantId, canvas);
        }
        let tile = this.tileByParticipant.get(participantId);
        if (!tile) {
            tile = {
                title: ""
            };
            this.tileByParticipant.set(participantId, tile);
        }
        return {
            canvas: canvas,
            tile: tile,
            participantId: participantId
        };
    }
}
function $fdc9499eb2cdf07a$var$participantIdFromChannel(channel) {
    const parts = channel.split(".");
    const mediaIndex = parts.indexOf("media");
    // private.<role>.<participant-id>.media.<kind>…
    return mediaIndex >= 1 ? parts[mediaIndex - 1] : undefined;
}



const $e7f6c19edc3bead5$var$HIGH_MODE_OPTIONS = [
    [
        "auto",
        "Auto \xb7 1280x720 \xb7 30 fps \xb7 1.6 Mbps \xb7 lowest CPU codec"
    ],
    [
        "avc1080",
        "H.264 / AVC \xb7 1920x1080 \xb7 30 fps \xb7 2.8 Mbps"
    ],
    [
        "avc720",
        "H.264 / AVC \xb7 1280x720 \xb7 30 fps \xb7 1.6 Mbps"
    ],
    [
        "vp8720",
        "VP8 \xb7 1280x720 \xb7 30 fps \xb7 1.6 Mbps"
    ],
    [
        "vp9720",
        "VP9 \xb7 1280x720 \xb7 24 fps \xb7 1.1 Mbps"
    ],
    [
        "hevc720",
        "HEVC / H.265 \xb7 1280x720 \xb7 30 fps \xb7 1.0 Mbps"
    ],
    [
        "av1540",
        "AV1 \xb7 960x540 \xb7 20 fps \xb7 650 kbps"
    ]
];
const $e7f6c19edc3bead5$var$LOW_MODE_OPTIONS = [
    [
        "auto",
        "Auto \xb7 480x270 \xb7 12 fps \xb7 200 kbps \xb7 hardware preferred"
    ],
    [
        "avc360",
        "H.264 / AVC \xb7 640x360 \xb7 15 fps \xb7 300 kbps"
    ],
    [
        "avc270",
        "H.264 / AVC \xb7 480x270 \xb7 12 fps \xb7 200 kbps"
    ],
    [
        "hevc270",
        "HEVC / H.265 \xb7 480x270 \xb7 12 fps \xb7 150 kbps \xb7 hardware preferred"
    ],
    [
        "vp9270",
        "VP9 \xb7 480x270 \xb7 12 fps \xb7 170 kbps"
    ],
    [
        "vp8180",
        "VP8 \xb7 320x180 \xb7 10 fps \xb7 150 kbps"
    ],
    [
        "av1180",
        "AV1 \xb7 320x180 \xb7 8 fps \xb7 80 kbps"
    ]
];
const $e7f6c19edc3bead5$var$INITIAL_VIEW = {
    status: {
        text: "not connected",
        kind: ""
    },
    inRoom: false,
    conference: undefined,
    room: undefined,
    localParticipantId: undefined,
    cameraEnabled: false,
    capturing: false,
    preferredVideoSource: "camera",
    activeVideoSource: "none",
    audioEnabled: false,
    microphoneEnabled: false,
    microphoneSpeaking: false,
    audioDiagnostics: {},
    participantState: {},
    participantMedia: {},
    mediaNote: "",
    links: undefined
};
function $e7f6c19edc3bead5$var$ConferenceApp() {
    const [view, setView] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($e7f6c19edc3bead5$var$INITIAL_VIEW);
    const [messages, setMessages] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const [submitting, setSubmitting] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const [capabilityReport, setCapabilityReport] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("");
    const [copyLabel, setCopyLabel] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("Copy report");
    const [modeSupport, setModeSupport] = (0, $204a33a7557cbbd0$export$60241385465d0a34)({
        high: {},
        low: {}
    });
    // The adapter is deliberately the only mutable link between Preact and the
    // video pipeline. Everything else in this file is ordinary UI state.
    const uiRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)();
    if (!uiRef.current) uiRef.current = new (0, $fdc9499eb2cdf07a$export$1ce9b561ae32bad2)(setView);
    const ui = uiRef.current;
    const chatRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)();
    if (!chatRef.current) chatRef.current = new (0, $d7391e6a0d77ea45$export$cbdb7321be0c886b)({
        onMessage: (message)=>setMessages((current)=>[
                    ...current,
                    message
                ])
    });
    const controllerRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)();
    if (!controllerRef.current) controllerRef.current = new (0, $3b2b0f3d639f637a$export$4fa144f6e3d186ad)({
        ui: ui,
        chat: chatRef.current
    });
    const controller = controllerRef.current;
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        $e7f6c19edc3bead5$var$loadModeSupport((0, $6ce98e86537e26d8$export$e5ce0b90cfc7c793), "high", setModeSupport);
        $e7f6c19edc3bead5$var$loadModeSupport((0, $6ce98e86537e26d8$export$40105d0178b236dd), "low", setModeSupport);
        return ()=>controller.leave();
    }, [
        controller
    ]);
    // После закрытия хостом — чистый старт /demo/conference?closed=1
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const url = new URL(window.location.href);
        if (url.searchParams.get("closed") !== "1") return;
        ui.setStatus("conference closed by its owner", false);
        url.searchParams.delete("closed");
        window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    }, [
        ui
    ]);
    const query = new URL(window.location.href).searchParams;
    const inviteFromUrl = query.get("invite") || "";
    const adminConferenceId = query.get("conference");
    const ownerSecret = new URLSearchParams(window.location.hash.slice(1)).get("owner");
    const isAdminLink = Boolean(adminConferenceId && ownerSecret);
    const isInviteLink = Boolean(inviteFromUrl);
    async function runEntry(action) {
        setSubmitting(true);
        try {
            await action();
        } catch (error) {
            ui.setStatus(`error: ${$e7f6c19edc3bead5$var$friendlyError(error)}`, false);
        } finally{
            setSubmitting(false);
        }
    }
    async function checkCapabilities() {
        setCapabilityReport("Checking browser video capabilities\u2026");
        setCopyLabel("Copy report");
        setCapabilityReport(await (0, $cbc7cb66acde099d$export$2db45ecbb35621b9)());
    }
    async function copyCapabilityReport() {
        try {
            await navigator.clipboard.writeText(capabilityReport);
            setCopyLabel("Copied");
        } catch  {
            setCopyLabel("Copy failed");
        }
    }
    async function selectVideoModes(change) {
        try {
            await controller.setVideoModes(change);
        } catch (error) {
            ui.setStatus(`camera error: ${$e7f6c19edc3bead5$var$friendlyError(error)}`, false);
        }
    }
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("main", {
        class: "page",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$Header, {
                status: view.status
            }),
            !view.inRoom ? isAdminLink ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$AdminRejoinCard, {
                submitting: submitting,
                onJoin: ({ displayName: displayName })=>runEntry(()=>controller.joinConference("admin", {
                            conferenceId: adminConferenceId,
                            ownerSecret: ownerSecret,
                            displayName: displayName
                        }))
            }) : isInviteLink ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$InviteJoinCard, {
                inviteId: inviteFromUrl,
                submitting: submitting,
                onJoin: ({ displayName: displayName })=>runEntry(()=>controller.joinConference("invite", {
                            inviteId: inviteFromUrl,
                            displayName: displayName
                        }))
            }) : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$CreateConferenceCard, {
                submitting: submitting,
                onCreate: ({ title: title, chatPolicy: chatPolicy, displayName: displayName })=>runEntry(()=>controller.createConference({
                            title: title,
                            chatPolicy: chatPolicy,
                            displayName: displayName
                        }))
            }) : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$ConferenceRoom, {
                view: view,
                messages: messages,
                ui: ui,
                controller: controller,
                modeSupport: modeSupport,
                capabilityReport: capabilityReport,
                copyLabel: copyLabel,
                onVideoModesChange: selectVideoModes,
                onToggleCamera: ()=>controller.toggleVideo(),
                onSetVideoSource: (source)=>controller.setPreferredVideoSource(source),
                onToggleMicrophone: ()=>controller.toggleMicrophone(),
                onCheckCapabilities: checkCapabilities,
                onCopyReport: copyCapabilityReport,
                onSendChat: (text)=>controller.sendChat(text),
                onCloseConference: ()=>runEntry(()=>controller.closeConference())
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$Header({ status: status }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("header", {
        class: "top-bar",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("a", {
                href: "/",
                children: "\u2190 all demos"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("h1", {
                        children: "FastPubSub Video Meeting"
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("p", {
                        children: "Everyone publishes camera and microphone to FastPubSub media subjects \u2014 mesh pub/sub, not WebRTC."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                class: `status ${status.kind}`,
                children: status.text
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$CreateConferenceCard({ submitting: submitting, onCreate: onCreate }) {
    const [title, setTitle] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("Team meeting");
    const [chatPolicy, setChatPolicy] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("shared");
    const [hostName, setHostName] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("Host");
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
        class: "join-card",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("h2", {
                children: "Create a meeting"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("p", {
                class: "muted",
                children: "The server generates a random FastPubSub tenant, participant identity and ACL-limited token. A meeting title is never a tenant name."
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("form", {
                onSubmit: (event)=>{
                    event.preventDefault();
                    onCreate({
                        title: title,
                        chatPolicy: chatPolicy,
                        displayName: hostName
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                        children: [
                            "Title ",
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                                value: title,
                                maxlength: "80",
                                required: true,
                                onInput: (event)=>setTitle(event.currentTarget.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                        children: [
                            "Your name ",
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                                value: hostName,
                                maxlength: "48",
                                required: true,
                                onInput: (event)=>setHostName(event.currentTarget.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                        children: [
                            "Chat",
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("select", {
                                value: chatPolicy,
                                onChange: (event)=>setChatPolicy(event.currentTarget.value),
                                children: [
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("option", {
                                        value: "shared",
                                        children: "Shared chat"
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("option", {
                                        value: "disabled",
                                        children: "Disabled"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        type: "submit",
                        disabled: submitting,
                        children: "Create and join"
                    })
                ]
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$InviteJoinCard({ inviteId: inviteId, submitting: submitting, onJoin: onJoin }) {
    const [guestName, setGuestName] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("Guest");
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
        class: "join-card",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("h2", {
                children: "Join meeting"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("p", {
                class: "muted",
                children: "You were invited to a FastPubSub meeting. Enter your display name to join."
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("form", {
                onSubmit: (event)=>{
                    event.preventDefault();
                    onJoin({
                        displayName: guestName
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                        children: [
                            "Invite ",
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                                value: inviteId,
                                readOnly: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                        children: [
                            "Your name ",
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                                value: guestName,
                                maxlength: "48",
                                required: true,
                                onInput: (event)=>setGuestName(event.currentTarget.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        type: "submit",
                        disabled: submitting,
                        children: "Join meeting"
                    })
                ]
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$AdminRejoinCard({ submitting: submitting, onJoin: onJoin }) {
    const [hostName, setHostName] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("Host");
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
        class: "join-card",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("h2", {
                children: "Rejoin as meeting owner"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("p", {
                class: "muted",
                children: "This admin link restores owner capabilities for an existing meeting."
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("form", {
                onSubmit: (event)=>{
                    event.preventDefault();
                    onJoin({
                        displayName: hostName
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                        children: [
                            "Your name ",
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                                value: hostName,
                                maxlength: "48",
                                required: true,
                                onInput: (event)=>setHostName(event.currentTarget.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        type: "submit",
                        disabled: submitting,
                        children: "Join as admin"
                    })
                ]
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$ConferenceRoom(props) {
    const { view: view, controller: controller, ui: ui } = props;
    const participants = Object.values(view.room?.participants || {});
    const onlineParticipants = participants.filter((participant)=>participant.status === "online");
    const [focusedParticipantId, setFocusedParticipantId] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(null);
    const [fullscreenParticipantId, setFullscreenParticipantId] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(null);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const onFullscreen = ()=>{
            const element = document.fullscreenElement;
            const id = element instanceof HTMLElement ? element.dataset.participantId : "";
            setFullscreenParticipantId(id || null);
        };
        document.addEventListener("fullscreenchange", onFullscreen);
        return ()=>document.removeEventListener("fullscreenchange", onFullscreen);
    }, []);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        controller.setVideoViewDemand(fullscreenParticipantId || focusedParticipantId || "");
    }, [
        controller,
        fullscreenParticipantId,
        focusedParticipantId
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (!focusedParticipantId) return undefined;
        const onKeyDown = (event)=>{
            if (event.key === "Escape" && !document.fullscreenElement) setFocusedParticipantId(null);
        };
        window.addEventListener("keydown", onKeyDown);
        return ()=>window.removeEventListener("keydown", onKeyDown);
    }, [
        focusedParticipantId
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (!focusedParticipantId) return;
        const stillVisible = onlineParticipants.some((participant)=>participant.participant_id === focusedParticipantId);
        if (!stillVisible) setFocusedParticipantId(null);
    }, [
        focusedParticipantId,
        onlineParticipants
    ]);
    const visibleParticipants = focusedParticipantId ? onlineParticipants.filter((participant)=>participant.participant_id === focusedParticipantId) : onlineParticipants;
    const focusedParticipant = focusedParticipantId ? onlineParticipants.find((participant)=>participant.participant_id === focusedParticipantId) : undefined;
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
        class: "conference",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "room-bar",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                        children: [
                            view.conference.title,
                            " \xb7 meeting \xb7 chat: ",
                            view.room?.chat_policy ?? view.conference.chat_policy
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                        class: "muted",
                        children: [
                            "authority version ",
                            view.room?.version ?? "\u2026"
                        ]
                    }),
                    controller.ownerSecret && !view.room?.closed && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        type: "button",
                        onClick: props.onCloseConference,
                        children: "Close meeting"
                    })
                ]
            }),
            view.links && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$ShareLinks, {
                links: view.links
            }),
            focusedParticipantId && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "focus-bar",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                        children: [
                            "Only ",
                            focusedParticipant?.display_name ?? focusedParticipantId
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        type: "button",
                        onClick: ()=>setFocusedParticipantId(null),
                        children: "Show all videos"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
                class: `tiles${focusedParticipantId ? " focus-mode" : ""}`,
                children: visibleParticipants.map((participant)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$ParticipantTile, {
                        participant: participant,
                        isLocal: participant.participant_id === view.localParticipantId,
                        capturing: view.capturing,
                        activeVideoSource: view.activeVideoSource,
                        microphoneEnabled: view.microphoneEnabled,
                        microphoneSpeaking: view.microphoneSpeaking,
                        focusMode: Boolean(focusedParticipantId),
                        ui: ui,
                        media: view.participantMedia[participant.participant_id],
                        participantState: view.participantState?.[participant.participant_id],
                        onVolume: (value)=>controller.setParticipantVolume(participant.participant_id, value),
                        onMute: (muted)=>controller.setParticipantMuted(participant.participant_id, muted),
                        onFocus: ()=>setFocusedParticipantId(participant.participant_id)
                    }, participant.participant_id))
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$VideoControls, {
                ...props
            }),
            props.capabilityReport && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$CapabilityReport, {
                report: props.capabilityReport,
                copyLabel: props.copyLabel,
                onCopy: props.onCopyReport
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
                class: "bottom-grid",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$ParticipantStatePanel, {
                        participants: participants,
                        participantState: view.participantState || {},
                        localParticipantId: view.localParticipantId
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$AuthorityPanel, {
                        participants: participants
                    }),
                    view.room?.chat_policy === "disabled" ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
                        class: "panel",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("h2", {
                                children: "Chat"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("p", {
                                class: "muted",
                                children: "Disabled by the room owner."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$ChatPanel, {
                        messages: props.messages,
                        onSend: props.onSendChat
                    })
                ]
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$ShareLinks({ links: links }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
        class: "share-card",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("h3", {
                children: "Meeting created"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                children: [
                    "Invite link \u2014 safe to share ",
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                        value: links.invite,
                        readOnly: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                children: [
                    "Admin link \u2014 keep private ",
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                        value: links.admin,
                        readOnly: true
                    })
                ]
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$ParticipantTile({ participant: participant, isLocal: isLocal, capturing: capturing, activeVideoSource: activeVideoSource, microphoneEnabled: microphoneEnabled, microphoneSpeaking: microphoneSpeaking, focusMode: focusMode, ui: ui, media: media = {}, participantState: participantState, onVolume: onVolume, onMute: onMute, onFocus: onFocus }) {
    const tileRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(null);
    const videoEnabled = true;
    const remoteState = !isLocal ? participantState : undefined;
    const remoteVideoSource = remoteState?.videoSource === "desktop" ? "desktop" : "camera";
    const localVideoSource = activeVideoSource === "desktop" ? "desktop" : "camera";
    const videoSource = isLocal ? localVideoSource : remoteVideoSource;
    const cameraIsOn = isLocal ? capturing : Boolean(remoteState && !remoteState.stale && remoteState.camera && videoEnabled);
    const placeholderText = !isLocal && !videoEnabled ? "Video disabled" : isLocal ? capturing ? "" : videoSource === "desktop" ? "Desktop off" : "Camera off" : !remoteState || remoteState.stale ? "Waiting for signal\u2026" : remoteState.camera ? remoteVideoSource === "desktop" ? "Waiting for desktop\u2026" : "Waiting for video\u2026" : remoteVideoSource === "desktop" ? "Desktop off" : "Camera off";
    const micLabel = isLocal ? microphoneEnabled ? microphoneSpeaking ? " \xb7 mic on \xb7 speaking" : " \xb7 mic on" : " \xb7 mic off" : remoteState && !remoteState.stale ? remoteState.microphone ? remoteState.speaking ? " \xb7 mic on \xb7 speaking" : " \xb7 mic on" : " \xb7 mic off" : "";
    async function toggleFullscreen() {
        const tile = tileRef.current;
        if (!tile) return;
        try {
            if (document.fullscreenElement === tile) await document.exitFullscreen();
            else await tile.requestFullscreen();
        } catch (error) {
            console.warn("[conference] fullscreen failed", error);
        }
    }
    const isDesktopShare = cameraIsOn && videoSource === "desktop";
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("article", {
        "data-participant-id": participant.participant_id,
        class: `tile${isLocal ? " me" : ""}${cameraIsOn ? "" : " camera-off"}${focusMode ? " focus-main" : ""}${isDesktopShare ? " tile-desktop" : ""}`,
        ref: (element)=>{
            tileRef.current = element;
            ui.setParticipantTileElement(participant.participant_id, element);
        },
        children: [
            placeholderText ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "placeholder",
                children: placeholderText
            }) : null,
            isLocal ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("video", {
                ref: (element)=>ui.setLocalVideoElement(element),
                autoplay: true,
                muted: true,
                playsInline: true,
                class: "local-video"
            }) : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("canvas", {
                ref: (element)=>ui.setRemoteCanvasElement(participant.participant_id, element),
                class: "remote-video"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "tile-focus-controls",
                children: [
                    !focusMode && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        type: "button",
                        onClick: onFocus,
                        children: "Solo"
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        type: "button",
                        onClick: ()=>{
                            toggleFullscreen();
                        },
                        children: "Fullscreen"
                    })
                ]
            }),
            !isLocal && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "tile-media-controls",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                        children: [
                            "Sound ",
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                                type: "range",
                                min: "0",
                                max: "200",
                                value: Math.round((media.volume ?? 1) * 100),
                                onInput: (event)=>onVolume(Number(event.currentTarget.value) / 100)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        type: "button",
                        onClick: ()=>onMute(!media.muted),
                        children: media.muted ? "Unmute" : "Mute"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                class: "tile-name",
                children: [
                    participant.display_name,
                    isLocal ? " (you)" : "",
                    cameraIsOn && videoSource === "desktop" ? " \xb7 desktop" : "",
                    micLabel
                ]
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$VideoControls({ view: view, controller: controller, ui: ui, modeSupport: modeSupport, onVideoModesChange: onVideoModesChange, onToggleCamera: onToggleCamera, onSetVideoSource: onSetVideoSource, onToggleMicrophone: onToggleMicrophone, onCheckCapabilities: onCheckCapabilities }) {
    const [highMode, setHighMode] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(controller.highMode);
    const [lowMode, setLowMode] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(controller.lowMode);
    const [micDevices, setMicDevices] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const videoSource = view.preferredVideoSource || "camera";
    const isDesktop = videoSource === "desktop";
    const videoButtonLabel = view.capturing ? isDesktop ? "Stop desktop" : "Stop camera" : isDesktop ? "Share desktop" : "Start camera";
    async function refreshMicDevices() {
        try {
            setMicDevices(await (0, $be84addac8871937$export$87f9e16cf0961315)());
        } catch  {
            setMicDevices([]);
        }
    }
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        refreshMicDevices();
        const media = navigator.mediaDevices;
        if (!media?.addEventListener) return undefined;
        const onDeviceChange = ()=>{
            refreshMicDevices();
        };
        media.addEventListener("devicechange", onDeviceChange);
        return ()=>media.removeEventListener("devicechange", onDeviceChange);
    }, []);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (view.microphoneEnabled) refreshMicDevices();
    }, [
        view.microphoneEnabled
    ]);
    async function changeMicDevice(event) {
        try {
            await controller.setMicrophoneDevice(event.currentTarget.value);
        } catch (error) {
            ui.setStatus(`microphone error: ${$e7f6c19edc3bead5$var$friendlyError(error)}`, false);
        }
    }
    const changeHighMode = (event)=>{
        const nextHighMode = event.currentTarget.value;
        setHighMode(nextHighMode);
        onVideoModesChange({
            highMode: nextHighMode,
            lowMode: lowMode
        });
    };
    const changeLowMode = (event)=>{
        const nextLowMode = event.currentTarget.value;
        setLowMode(nextLowMode);
        onVideoModesChange({
            highMode: highMode,
            lowMode: nextLowMode
        });
    };
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
        class: "controls",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                children: [
                    "Video source",
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("select", {
                        value: videoSource,
                        disabled: view.capturing || view.room?.closed,
                        onChange: (event)=>onSetVideoSource(event.currentTarget.value),
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("option", {
                                value: "camera",
                                children: "Camera"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("option", {
                                value: "desktop",
                                children: "Desktop"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                type: "button",
                disabled: !view.cameraEnabled || view.room?.closed,
                onClick: onToggleCamera,
                children: videoButtonLabel
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                type: "button",
                disabled: !view.cameraEnabled || view.room?.closed,
                onClick: ()=>{
                    onToggleMicrophone();
                },
                children: view.microphoneEnabled ? view.microphoneSpeaking ? "Mute microphone \xb7 speaking" : "Mute microphone" : "Enable microphone"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                children: [
                    "Microphone",
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("select", {
                        value: controller.selectedMicId ?? (0, $be84addac8871937$export$1f13b6c27149433e),
                        disabled: view.room?.closed,
                        onChange: (event)=>{
                            changeMicDevice(event);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("option", {
                                value: (0, $be84addac8871937$export$1f13b6c27149433e),
                                children: "System default"
                            }),
                            micDevices.map((device)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("option", {
                                    value: device.deviceId,
                                    children: device.label
                                }, device.deviceId))
                        ]
                    })
                ]
            }),
            !isDesktop && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$ModeSelect, {
                        label: "High mode",
                        options: $e7f6c19edc3bead5$var$HIGH_MODE_OPTIONS,
                        value: highMode,
                        support: modeSupport.high,
                        onChange: changeHighMode
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$ModeSelect, {
                        label: "Low mode",
                        options: $e7f6c19edc3bead5$var$LOW_MODE_OPTIONS,
                        value: lowMode,
                        support: modeSupport.low,
                        onChange: changeLowMode
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                type: "button",
                onClick: onCheckCapabilities,
                children: "Check video capabilities"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                class: "muted",
                children: view.mediaNote
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$AudioDiagnostics, {
                diagnostics: view.audioDiagnostics,
                participantState: view.participantState
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$AudioDiagnostics({ diagnostics: diagnostics = {}, participantState: participantState = {} }) {
    const [open, setOpen] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const [copyLabel, setCopyLabel] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("copy");
    const [tick, setTick] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (!open) return undefined;
        const id = window.setInterval(()=>setTick((value)=>value + 1), 1000);
        return ()=>window.clearInterval(id);
    }, [
        open
    ]);
    const presence = $e7f6c19edc3bead5$var$remoteAudioPresence(participantState);
    const summary = (0, $ea71a0b4b5f3b38e$export$6d6ee81e00bef33a)(diagnostics);
    const detail = (0, $ea71a0b4b5f3b38e$export$2b833180f8471ab9)(diagnostics, presence);
    const health = diagnostics.framePackets ? Math.round(diagnostics.decodedFrames / diagnostics.framePackets * 100) : 100;
    const healthClass = health >= 98 ? "ok" : health >= 90 ? "warn" : "bad";
    const onCopy = async ()=>{
        try {
            await navigator.clipboard.writeText(detail);
            setCopyLabel("copied");
            window.setTimeout(()=>setCopyLabel("copy"), 1500);
        } catch  {
            setCopyLabel("error");
        }
    };
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "audio-diagnostics-panel",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                type: "button",
                class: `audio-diagnostics-toggle health-${healthClass}`,
                onClick: ()=>setOpen((value)=>!value),
                title: "Click for detailed audio diagnostics",
                children: [
                    summary,
                    " ",
                    open ? "\u25BE" : "\u25B8"
                ]
            }),
            open ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "audio-diagnostics-detail",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "audio-diagnostics-actions",
                        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            type: "button",
                            onClick: ()=>{
                                onCopy();
                            },
                            children: copyLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("pre", {
                        children: detail
                    })
                ]
            }) : null
        ]
    });
}
function $e7f6c19edc3bead5$var$ModeSelect({ label: label, options: options, value: value, support: support, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
        children: [
            label,
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("select", {
                value: value,
                onChange: onChange,
                children: options.map(([mode, text])=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("option", {
                        value: mode,
                        disabled: support[mode] === false,
                        children: support[mode] === false ? `${text} \xb7 unavailable` : text
                    }, mode))
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$CapabilityReport({ report: report, copyLabel: copyLabel, onCopy: onCopy }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
        class: "panel capability-card",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "capability-heading",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("h2", {
                        children: "Video capability report"
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        type: "button",
                        onClick: onCopy,
                        children: copyLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("pre", {
                children: report
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$AuthorityPanel({ participants: participants }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
        class: "panel",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("h2", {
                children: "Conference authority"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("p", {
                class: "muted",
                children: "Roles and roster come from FastPubSub authority. Online/offline and camera/mic use public.*.state at 1 Hz."
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("ul", {
                class: "participants",
                children: participants.map((participant)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("li", {
                        children: [
                            participant.display_name,
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "role",
                                children: [
                                    " \xb7 ",
                                    participant.role,
                                    " \xb7 ",
                                    participant.status
                                ]
                            })
                        ]
                    }, participant.participant_id))
            })
        ]
    });
}
function $e7f6c19edc3bead5$var$ParticipantStatePanel({ participants: participants, participantState: participantState, localParticipantId: localParticipantId }) {
    const online = participants.filter((participant)=>participant.status === "online");
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
        class: "panel media-control-panel",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("h2", {
                children: "Participant state"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("p", {
                class: "muted",
                children: "Heartbeat: public.<role>.<participant_id>.state \u2014 role and id from channel ACL; room = tenant."
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("table", {
                class: "media-control-table",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("thead", {
                        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("th", {
                                    children: "Participant"
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("th", {
                                    children: "Camera"
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("th", {
                                    children: "Microphone"
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("th", {
                                    children: "Updated"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("tbody", {
                        children: online.map((participant)=>{
                            const state = participantState[participant.participant_id];
                            const isLocal = participant.participant_id === localParticipantId;
                            const ageSec = state?.ageMs == null ? "\u2014" : `${Math.round(state.ageMs / 1000)} s`;
                            return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("tr", {
                                class: state?.stale ? "stale" : "",
                                children: [
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("td", {
                                        children: [
                                            participant.display_name,
                                            isLocal ? " (you)" : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("td", {
                                        children: $e7f6c19edc3bead5$var$mediaStateLabel(state, "camera")
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("td", {
                                        children: $e7f6c19edc3bead5$var$mediaStateLabel(state, "microphone", state?.speaking)
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("td", {
                                        children: state?.stale ? "no signal" : ageSec
                                    })
                                ]
                            }, participant.participant_id);
                        })
                    })
                ]
            })
        ]
    });
}
/** Short on/off/waiting label for the panel. */ function $e7f6c19edc3bead5$var$mediaStateLabel(state, field, speaking = false) {
    if (!state) return "waiting\u2026";
    if (state.stale) return "\u2014";
    if (!state[field]) return "off";
    return speaking ? "on \xb7 speaking" : "on";
}
/**
 * Есть ли удалённый участник с микрофоном / говорящий — для подсказок звука.
 * @param {Record<string, { local?: boolean, microphone?: boolean, speaking?: boolean, stale?: boolean }>} participantState
 */ function $e7f6c19edc3bead5$var$remoteAudioPresence(participantState) {
    let remoteMicOn = false;
    let remoteSpeaking = false;
    for (const state of Object.values(participantState || {})){
        if (!state || state.local || state.stale) continue;
        if (state.microphone) remoteMicOn = true;
        if (state.speaking) remoteSpeaking = true;
    }
    return {
        remoteMicOn: remoteMicOn,
        remoteSpeaking: remoteSpeaking
    };
}
function $e7f6c19edc3bead5$var$ChatPanel({ messages: messages, onSend: onSend }) {
    const [text, setText] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("");
    const logRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)();
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (logRef.current) logRef.current.scrollTop = logRef.current.scrollHeight;
    }, [
        messages
    ]);
    async function submit(event) {
        event.preventDefault();
        const message = text.trim();
        if (!message) return;
        try {
            await onSend(message);
            setText("");
        } catch (error) {
            console.error("[conference] chat send failed", error);
        }
    }
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("section", {
        class: "panel chat-panel",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("h2", {
                children: "Chat"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                ref: logRef,
                class: "chat-log",
                children: messages.map((message)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "chat-item",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("strong", {
                                children: [
                                    message.name,
                                    ": "
                                ]
                            }),
                            message.text
                        ]
                    }, message.id))
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("form", {
                class: "chat-form",
                onSubmit: submit,
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                        value: text,
                        maxlength: "500",
                        placeholder: "Message",
                        required: true,
                        onInput: (event)=>setText(event.currentTarget.value)
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        type: "submit",
                        children: "Send"
                    })
                ]
            })
        ]
    });
}
async function $e7f6c19edc3bead5$var$loadModeSupport(modes, quality, setModeSupport) {
    const result = {};
    await Promise.all(Object.entries(modes).map(async ([name, mode])=>{
        result[name] = await (0, $6ce98e86537e26d8$export$d892a920364a0f60)(mode, quality);
    }));
    setModeSupport((current)=>({
            ...current,
            [quality]: result
        }));
}
function $e7f6c19edc3bead5$var$friendlyError(error) {
    return error?.message || String(error);
}
(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($e7f6c19edc3bead5$var$ConferenceApp, {}), document.getElementById("app-root"));


//# sourceMappingURL=conference.11ba5560.js.map
